/* Generated scent taxonomy for products.
   Source: Fragrantica/API ranked notes first, explicit Shopify note sections only as fallback.
   Regenerate with _import/generate_product_taxonomy.py. */
(function () {
  var map = {
  "azman-killer-vavoom": [
    "gender:unisex",
    "note:rose",
    "note:jasmine",
    "note:iris",
    "note:osmanthus",
    "note:bergamot",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:dark"
  ],
  "azman-i-am-darkness": [
    "gender:unisex",
    "note:balsamic",
    "note:oud",
    "note:jasmine",
    "note:frangipani",
    "note:bergamot",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "azman-risk": [
    "gender:unisex",
    "note:amber",
    "note:balsamic",
    "note:oud",
    "note:tuberose",
    "note:iris",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "azman-song-for-a-wanderer": [
    "gender:unisex",
    "note:oud",
    "note:orange-blossom",
    "note:bergamot",
    "note:lemon",
    "note:orange",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "azman-oh-my-shisha": [
    "gender:unisex",
    "note:sweet",
    "note:gourmand",
    "note:fruity"
  ],
  "azman-crown-of-fire": [
    "gender:unisex",
    "note:oud",
    "note:iris",
    "note:violet",
    "note:osmanthus",
    "note:sandalwood",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "azman-majnoon": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:rose",
    "note:patchouli",
    "note:incense",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "azman-two-minutes-after-the-kiss": [
    "gender:unisex",
    "note:balsamic",
    "note:oud",
    "note:floral",
    "note:rose",
    "note:sandalwood",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "azman-nocturnal-immortal": [
    "gender:unisex",
    "note:balsamic",
    "note:rose",
    "note:mandarin",
    "note:orange",
    "note:rosemary",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "azman-riad-jasmine": [
    "gender:unisex",
    "note:oud",
    "note:jasmine",
    "note:berry",
    "note:cedar",
    "note:pine",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "lorenzo-pazzaglia-cherry-ink": [
    "gender:unisex",
    "note:cherry",
    "note:bergamot",
    "note:pepper",
    "note:rhum-accord",
    "note:black-cherry",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "room-1015-kokoa-bang": [
    "gender:unisex",
    "note:accord-ros-champagne",
    "note:pear",
    "note:lemon",
    "note:magnolia",
    "note:chocolate",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "room-1015-sonic-flower": [
    "gender:unisex",
    "note:pepper",
    "note:carrot-seeds",
    "note:iris",
    "note:jasmine",
    "note:ambroxan",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "trudon-carmen-scented-hand-lotion": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:rhum",
    "note:tobacco",
    "note:oak-wood",
    "note:dark"
  ],
  "trudon-carmen-hand-soap": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:rhum",
    "note:tobacco",
    "note:oak-wood",
    "note:dark"
  ],
  "fascent-discovery-kit": [
    "gender:unisex",
    "note:fresh",
    "note:balsamic",
    "note:floral",
    "note:orange-blossom",
    "note:iris",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "fascent-red-flag": [
    "gender:unisex",
    "note:iris",
    "note:vetiver",
    "note:patchouli",
    "note:wood",
    "note:incense",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "fascent-corn-star": [
    "gender:unisex",
    "note:pear",
    "note:fig",
    "note:tonka",
    "note:coconut",
    "note:marine",
    "note:fresh",
    "note:gourmand",
    "note:fruity"
  ],
  "fascent-creme-brulante": [
    "gender:unisex",
    "note:amber",
    "note:balsamic",
    "note:fig",
    "note:wood",
    "note:incense",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:boozy",
    "note:fruity"
  ],
  "fascent-leau-dor-dort": [
    "gender:unisex",
    "note:orange-blossom",
    "note:bergamot",
    "note:lemon",
    "note:orange",
    "note:musk",
    "note:floral"
  ],
  "fascent-i-fig-you": [
    "gender:unisex",
    "note:fresh",
    "note:citrus",
    "note:sage",
    "note:fig",
    "note:cedar",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:fruity",
    "note:dark"
  ],
  "fascent-milky-no-way": [
    "gender:unisex",
    "note:amber",
    "note:sandalwood",
    "note:wood",
    "note:tonka",
    "note:milk",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "fascent-radical-softness": [
    "gender:unisex",
    "note:floral",
    "note:frangipani",
    "note:tea",
    "note:pepper",
    "note:musk",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "fascent-sel-a-vie": [
    "gender:unisex",
    "note:jasmine",
    "note:ylang",
    "note:mandarin",
    "note:orange",
    "note:vanilla",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "tada-parfumeur-discovery-set-02": [
    "gender:unisex"
  ],
  "tada-parfumeur-discovery-set-01": [
    "gender:unisex"
  ],
  "tada-parfumeur-the-print-house": [
    "gender:unisex",
    "note:blueberry-accord",
    "note:pepper",
    "note:bergamot",
    "note:lavender",
    "note:geranium",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-the-inner-child": [
    "gender:unisex",
    "note:blueberry-accord",
    "note:pepper",
    "note:bergamot",
    "note:lavender",
    "note:geranium",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-the-little-adult": [
    "gender:unisex",
    "note:mandarin",
    "note:pepper",
    "note:bergamot",
    "note:neroli",
    "note:clove",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-velvet-sanctuary": [
    "gender:unisex",
    "note:bergamot",
    "note:red-wine-accord",
    "note:grapefruit",
    "note:rhubarb",
    "note:rose",
    "note:floral"
  ],
  "tada-parfumeur-nocturnal-noir": [
    "gender:unisex",
    "note:patchouli",
    "note:saffron",
    "note:davana",
    "note:whiskey-accord",
    "note:smoke",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "tada-parfumeur-radiant-memories": [
    "gender:unisex",
    "note:apricot",
    "note:dried-fruits",
    "note:orange",
    "note:iris",
    "note:amber",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "tada-parfumeur-when-i-realised": [
    "gender:unisex",
    "note:orange",
    "note:bergamot",
    "note:clove",
    "note:suede",
    "note:chocolate",
    "note:gourmand",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "tada-parfumeur-latakia": [
    "gender:unisex",
    "note:smoke",
    "note:honey",
    "note:dried-fruit",
    "note:lavender",
    "note:tea",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "tada-parfumeur-black-cavendish": [
    "gender:unisex",
    "note:rum",
    "note:incense",
    "note:clove",
    "note:caramel",
    "note:jasmine",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "hellenist-eveil-du-faune": [
    "gender:unisex",
    "note:candied-angelica-bergamot-davana",
    "note:leather-narcissus-musc",
    "note:oud",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "meo-fusciuni-amara-vita": [
    "gender:unisex",
    "note:iris",
    "note:orange",
    "note:berry",
    "note:sandalwood",
    "note:tonka",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity"
  ],
  "mith-legend": [
    "gender:unisex",
    "note:apple",
    "note:galbanum",
    "note:lemon",
    "note:pepper",
    "note:geranium",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "narcotica-amber-radiance": [
    "gender:unisex",
    "note:lemon-zest",
    "note:rum",
    "note:amber",
    "note:orange-blossom",
    "note:vanilla",
    "note:musk",
    "note:ambergris",
    "note:fresh",
    "note:boozy",
    "note:resin-smoke",
    "note:floral",
    "note:gourmand"
  ],
  "house-of-cosmo-dark-matter": [
    "gender:unisex",
    "note:blackberry",
    "note:davana-essence",
    "note:vaporwoods",
    "note:incense",
    "note:iris",
    "note:tobacco",
    "note:akigalawood",
    "note:cypriol",
    "note:musk",
    "note:oud",
    "note:fruity",
    "note:aromatic",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:earthy",
    "note:dark"
  ],
  "borntostandout-saint-petal": [
    "gender:unisex",
    "note:orange-blossom",
    "note:cumin",
    "note:bergamot",
    "note:dust",
    "note:violet-leaves",
    "note:jasmine",
    "note:coffee",
    "note:incense",
    "note:akigalawood",
    "note:amyris",
    "note:vetiver",
    "note:cistus",
    "note:oud",
    "note:leather",
    "note:fresh",
    "note:floral",
    "note:spiced-aromatic",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:earthy",
    "note:dark"
  ],
  "lost-tribe-kong": [
    "gender:unisex",
    "note:amber",
    "note:balsamic",
    "note:floral",
    "note:magnolia",
    "note:frangipani",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "lost-tribe-dark-shadows": [
    "gender:unisex",
    "note:fresh",
    "note:amber",
    "note:balsamic",
    "note:oud",
    "note:floral",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:fruity",
    "note:dark"
  ],
  "lost-tribe-zilla": [
    "gender:unisex",
    "note:fresh",
    "note:citrus",
    "note:amber",
    "note:oud",
    "note:floral",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "lost-tribe-pans-labyrinth-v2": [
    "gender:unisex",
    "note:bergamot",
    "note:rose",
    "note:powder-accord",
    "note:bitter-almond",
    "note:white-ambergris",
    "note:floral"
  ],
  "twentysecondofmay-skin-to-skin": [
    "gender:unisex",
    "note:fabric-softener",
    "note:clean-aldehydes",
    "note:coconut",
    "note:ambrette-seeds",
    "note:orange",
    "note:gourmand"
  ],
  "liis-forest-sounds": [
    "gender:unisex",
    "note:ozonic",
    "note:yuzu",
    "note:vetiver",
    "note:wood",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "perfumology-pursuit-of-happiness-250-limited-edition": [
    "gender:unisex",
    "note:balsamic",
    "note:lemon",
    "note:grapefruit",
    "note:mandarin",
    "note:berry",
    "note:fresh",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "perfumology-boutique": [
    "gender:unisex",
    "note:red-apple",
    "note:grapefruit",
    "note:ambrettolide",
    "note:white-blossoms",
    "note:jasmine",
    "note:floral"
  ],
  "amouage-honour-woman-gift-set": [
    "gender:unisex",
    "note:pepper",
    "note:rhubarb-leaves",
    "note:coriander",
    "note:jasmine",
    "note:tuberose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-reflection-man-gift-set": [
    "gender:unisex",
    "note:rosemary",
    "note:pepper",
    "note:orange",
    "note:neroli",
    "note:orris-iris",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-guidance-gift-set": [
    "gender:unisex",
    "note:pear",
    "note:incense",
    "note:almond",
    "note:saffron",
    "note:rose",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "amouage-decision-gift-set": [
    "gender:unisex",
    "note:bergamot",
    "note:cardamom",
    "note:pepper",
    "note:frankincense-olibanum",
    "note:balsamic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-purpose-gift-set": [
    "gender:unisex",
    "note:bergamot",
    "note:pepper",
    "note:incense",
    "note:pimento-berry",
    "note:rose",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "ormonde-jayne-oud-liaisons": [
    "gender:unisex",
    "note:orange",
    "note:bergamot",
    "note:osmanthus-absolute",
    "note:jasmine",
    "note:tuberose",
    "note:floral"
  ],
  "ormonde-jayne-vanilla-aube": [
    "gender:unisex",
    "note:bergamot",
    "note:raspberry-leaf",
    "note:red-fruits",
    "note:bifurcated-vetiver",
    "note:rose",
    "note:floral"
  ],
  "ormonde-jayne-patchouli-d-atlas": [
    "gender:unisex",
    "note:aldehydes",
    "note:amber",
    "note:aniseed",
    "note:basil",
    "note:bengal-quince",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "ormonde-jayne-verano": [
    "gender:unisex",
    "note:bergamot",
    "note:wood",
    "note:milk",
    "note:vanilla",
    "note:amber",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke"
  ],
  "ormonde-jayne-tanger": [
    "gender:unisex",
    "note:basil",
    "note:bergamot",
    "note:clary-sage",
    "note:galbanum",
    "note:pineapple",
    "note:aromatic",
    "note:fruity"
  ],
  "ormonde-jayne-levant": [
    "gender:unisex",
    "note:bergamot",
    "note:paperbark",
    "note:rosemary",
    "note:hempzidralok",
    "note:aniseed",
    "note:aromatic"
  ],
  "ormonde-jayne-bijou-zafran": [
    "gender:unisex",
    "note:basil",
    "note:bergamot",
    "note:clary-sage",
    "note:galbanum",
    "note:pineapple",
    "note:aromatic",
    "note:fruity"
  ],
  "nebular-perfumes-discovery-kit": [
    "gender:unisex"
  ],
  "nebular-perfumes-one-galaxy": [
    "gender:unisex",
    "note:rose",
    "note:iris",
    "note:floral"
  ],
  "nebular-perfumes-aurora": [
    "gender:unisex",
    "note:amber",
    "note:tonka",
    "note:caramel",
    "note:honey",
    "note:cinnamon",
    "note:gourmand",
    "note:resin-smoke",
    "note:boozy",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "nebular-perfumes-supernova": [
    "gender:unisex",
    "note:amber",
    "note:orange-blossom",
    "note:neroli",
    "note:orange",
    "note:cedar",
    "note:woody",
    "note:resin-smoke",
    "note:floral"
  ],
  "nebular-perfumes-halo": [
    "gender:unisex",
    "note:rose",
    "note:lemon",
    "note:sandalwood",
    "note:wood",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:floral"
  ],
  "marc-antoine-barrois-ganymede-extrait": [
    "gender:unisex",
    "note:bergamot",
    "note:cedar",
    "note:musk",
    "note:vetiver",
    "note:grothzenvixol",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "marc-antoine-barrois-b683-extrait": [
    "gender:unisex",
    "note:lemon-vervain",
    "note:pineapple",
    "note:salted-caramel",
    "note:vextronplibar",
    "note:fruity"
  ],
  "marc-antoine-barrois-aldebaran": [
    "gender:unisex",
    "note:frangipani",
    "note:orange",
    "note:ylang",
    "note:cashmere",
    "note:cedar",
    "note:woody",
    "note:floral"
  ],
  "marc-antoine-barrois-encelade": [
    "gender:unisex",
    "note:amber",
    "note:bergamot",
    "note:birch-tar",
    "note:galbanum",
    "note:leather",
    "note:resin-smoke",
    "note:dark"
  ],
  "marc-antoine-barrois-ganymede": [
    "gender:unisex",
    "note:mineral",
    "note:floral",
    "note:osmanthus",
    "note:mandarin",
    "note:sea-salt",
    "note:fresh",
    "note:dark"
  ],
  "marc-antoine-barrois-b683": [
    "gender:unisex",
    "note:chamomile",
    "note:bergamot-zest",
    "note:mint",
    "note:orange-blossom",
    "note:tonka",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral"
  ],
  "marc-antoine-barrois-tilia": [
    "gender:unisex",
    "note:orange",
    "note:mango",
    "note:vetiver",
    "note:moss",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:dark"
  ],
  "jinx-naga": [
    "gender:unisex",
    "note:pandanus",
    "note:bergamot",
    "note:meyer-lemon",
    "note:violet-leaf",
    "note:spices",
    "note:spiced-aromatic"
  ],
  "amouage-purpose": [
    "gender:unisex",
    "note:incense",
    "note:pimento",
    "note:pepper",
    "note:bergamot",
    "note:papyrus",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-lineage": [
    "gender:unisex",
    "note:ginger",
    "note:pepper",
    "note:saffron",
    "note:incense",
    "note:fenugreek",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-enclave": [
    "gender:unisex",
    "note:spearmint",
    "note:cardamom",
    "note:cinnamon",
    "note:pepper",
    "note:incense",
    "note:gourmand",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-crimson-rocks": [
    "gender:unisex",
    "note:pepper",
    "note:jujube-honey",
    "note:rose",
    "note:oak-wood-co2",
    "note:cedar",
    "note:woody",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-interlude": [
    "gender:unisex",
    "note:oregano",
    "note:pimento",
    "note:bergamot",
    "note:incense",
    "note:balsamic",
    "note:resin-smoke"
  ],
  "amouage-decision-42": [
    "gender:unisex",
    "note:cardamom",
    "note:neroli",
    "note:pepper",
    "note:bergamot",
    "note:cinnamon",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-overture-41": [
    "gender:unisex",
    "note:saffron",
    "note:calvados",
    "note:cinnamon",
    "note:incense",
    "note:balsamic",
    "note:gourmand",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "nissaba-sulawesi": [
    "gender:unisex",
    "note:orange",
    "note:indian-lemon-grass",
    "note:tea",
    "note:calabrian-bergamot",
    "note:pepper",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "nissaba-provence": [
    "gender:unisex",
    "note:citrus",
    "note:kiwi",
    "note:nervous-neroli",
    "note:blueberry",
    "note:lily-of-the-valley",
    "note:fresh"
  ],
  "nissaba-andevalo": [
    "gender:unisex",
    "note:bergamot",
    "note:ylang",
    "note:spenkzurbolith",
    "note:floral"
  ],
  "argos-sample-pack": [
    "gender:unisex"
  ],
  "argos-extrait-de-parfum-discovery-set": [
    "gender:unisex"
  ],
  "argos-odyssey-the-legend-returns": [
    "gender:unisex",
    "note:bergamot",
    "note:clary-sage",
    "note:lemon",
    "note:lily-of-the-valley",
    "note:orange-blossom",
    "note:floral"
  ],
  "argos-narcissus-obsession-in-bloom": [
    "gender:unisex",
    "note:tarragon",
    "note:clove",
    "note:berry",
    "note:narcissus-absolute",
    "note:jasmine",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "argos-jupiters-lighting": [
    "gender:unisex",
    "note:cardamom",
    "note:juniper-berries",
    "note:lemon",
    "note:bergamot",
    "note:clary-sage",
    "note:spiced-aromatic"
  ],
  "argos-midas-touch": [
    "gender:unisex",
    "note:bergamot",
    "note:pine",
    "note:tuberose",
    "note:leather",
    "note:osmanthus",
    "note:woody",
    "note:floral",
    "note:dark"
  ],
  "argos-neptunes-trident": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:cardamom",
    "note:lavender",
    "note:tea",
    "note:fresh",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "argos-charons-vail": [
    "gender:unisex",
    "note:rose",
    "note:oud",
    "note:cedar",
    "note:sandalwood",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "argos-triumph-of-bacchus-extrait-de-parfum": [
    "gender:unisex",
    "note:white-peach",
    "note:rum",
    "note:apple",
    "note:saffron",
    "note:tonka",
    "note:gourmand",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "argos-sacred-flame": [
    "gender:unisex",
    "note:clove",
    "note:peach",
    "note:pepper",
    "note:bergamot",
    "note:ginger",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "argos-fall-of-phaeton": [
    "gender:unisex",
    "note:ginger",
    "note:lemon",
    "note:pepper",
    "note:bergamot",
    "note:cardamom",
    "note:spiced-aromatic"
  ],
  "argos-birth-of-venus": [
    "gender:unisex",
    "note:peach",
    "note:grapefruit",
    "note:bergamot",
    "note:lavender",
    "note:orange-blossom",
    "note:aromatic",
    "note:floral",
    "note:fruity"
  ],
  "argos-pallas-athene": [
    "gender:unisex",
    "note:pepper",
    "note:red-berries",
    "note:bergamot",
    "note:grapefruit",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "argos-danae": [
    "gender:unisex",
    "note:bergamot",
    "note:sicilian-lemon",
    "note:cashmere-wood",
    "note:pepper",
    "note:cedar",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "argos-brivido-della-caccia": [
    "gender:unisex",
    "note:juniper",
    "note:clary-sage",
    "note:mat-absolute",
    "note:pepper",
    "note:sweet-vernal-grass",
    "note:spiced-aromatic"
  ],
  "argos-triumph-of-bacchus-edp": [
    "gender:unisex",
    "note:white-peach",
    "note:rum",
    "note:apple",
    "note:saffron",
    "note:tonka",
    "note:gourmand",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "thomas-de-monaco-sol-salgado": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:sandalwood",
    "note:vanilla",
    "note:sea-salt",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke"
  ],
  "thomas-de-monaco-parfums-luisant-haze": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:tuberose",
    "note:tonka",
    "note:sweet",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "thomas-de-monaco-raw-gold-extrait": [
    "gender:unisex",
    "note:davana-oil",
    "note:cedar",
    "note:iris",
    "note:patchouli",
    "note:gaiac-wood",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:dark"
  ],
  "roble-fragrance-lab-valencia-oro-grande": [
    "gender:unisex",
    "note:balsamic",
    "note:iris",
    "note:mandarin",
    "note:orange",
    "note:vanilla",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "roble-fragrance-lab-agra-lotus-blossom": [
    "gender:unisex",
    "note:iris",
    "note:bergamot",
    "note:mandarin",
    "note:vanilla",
    "note:pepper",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "roble-fragrance-lab-istanbul-nar": [
    "gender:unisex",
    "note:amber",
    "note:bergamot",
    "note:fruity",
    "note:sage",
    "note:cedar",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "roble-fragrance-lab-zanzibar-vanilla-ginger": [
    "gender:unisex",
    "note:balsamic",
    "note:iris",
    "note:patchouli",
    "note:vanilla",
    "note:cinnamon",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "essential-parfums-ambre-latte": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:pepper",
    "note:clary-sage",
    "note:geranium",
    "note:spiced-aromatic"
  ],
  "essential-parfums-mon-vetiver": [
    "gender:unisex",
    "note:amber",
    "note:lime",
    "note:vetiver",
    "note:patchouli",
    "note:wood",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "essential-parfums-orange-x-santal": [
    "gender:unisex",
    "note:bergamot",
    "note:clove",
    "note:backwards-bergamot",
    "note:amber",
    "note:sandalwood",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "essential-parfums-rose-magnetic": [
    "gender:unisex",
    "note:citron",
    "note:yuzu",
    "note:pine",
    "note:pepper",
    "note:buddha-s-hand",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "essential-parfums-nice-bergamote": [
    "gender:unisex",
    "note:apricot",
    "note:berry",
    "note:grapefruit",
    "note:dwebnorplix",
    "note:jasmine",
    "note:floral",
    "note:fruity"
  ],
  "essential-parfums-the-musc": [
    "gender:unisex",
    "note:french-lavender",
    "note:sage",
    "note:suspended-saffron",
    "note:aromatic"
  ],
  "essential-parfums-fig-infusion": [
    "gender:unisex",
    "note:mono",
    "note:jasmine",
    "note:coconut",
    "note:crimzalthorix",
    "note:gourmand",
    "note:floral"
  ],
  "essential-parfums-divine-vanille": [
    "gender:unisex",
    "note:green-notes",
    "note:woody"
  ],
  "essential-parfums-bois-imperial": [
    "gender:unisex",
    "note:clove",
    "note:orange-blossom",
    "note:rose",
    "note:rosemary",
    "note:thyme",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "clive-christian-crab-apple-blossom": [
    "gender:unisex",
    "note:frangipani",
    "note:jasmine",
    "note:lime",
    "note:neroli",
    "note:sandalwood",
    "note:woody",
    "note:floral"
  ],
  "kerosene-promises-promises": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:hedione",
    "note:ozonic",
    "note:fempzilnordax",
    "note:fresh"
  ],
  "third-eye-fragrance-iris-obsidian": [
    "gender:unisex",
    "note:pepper",
    "note:coriander",
    "note:orange",
    "note:clove",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "third-eye-fragrance-moon-lotus": [
    "gender:unisex",
    "note:mandarin",
    "note:peach",
    "note:pineapple",
    "note:ylang-ylang",
    "note:jasmine",
    "note:floral",
    "note:fruity"
  ],
  "belnu-vanilla-boucle": [
    "gender:unisex",
    "note:white-almond",
    "note:coconut",
    "note:chamomile",
    "note:violet-leaf",
    "note:incense",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "belnu-still-bloom": [
    "gender:unisex",
    "note:cardamom",
    "note:cedar",
    "note:geranium",
    "note:guatemala-gaiac-wood",
    "note:rose",
    "note:woody",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "dannam-princess-of-china": [
    "gender:unisex",
    "note:elemi-resin",
    "note:eucalyptus",
    "note:leather",
    "note:lime",
    "note:mint",
    "note:fresh",
    "note:aromatic",
    "note:dark"
  ],
  "lepoque-dreams-and-nightmares": [
    "gender:unisex",
    "note:rose",
    "note:cinnamon",
    "note:bergamot",
    "note:branched-benzoin",
    "note:milk",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "lepoque-delusions-of-grandeur": [
    "gender:unisex",
    "note:apricot",
    "note:tobacco",
    "note:rum",
    "note:jasmine",
    "note:leather",
    "note:gourmand",
    "note:floral",
    "note:boozy",
    "note:fruity",
    "note:dark"
  ],
  "sora-dora-discovery-kit": [
    "gender:unisex"
  ],
  "sora-dora-kamel-oud": [
    "gender:unisex",
    "note:chocolate-cake",
    "note:pepper",
    "note:sugar-powder",
    "note:spiced-aromatic"
  ],
  "sora-dora-greasque": [
    "gender:unisex",
    "note:rose",
    "note:jasmine",
    "note:orange",
    "note:vanilla",
    "note:violet",
    "note:gourmand",
    "note:floral"
  ],
  "sora-dora-broceliande": [
    "gender:unisex",
    "note:elemi-resin",
    "note:clove",
    "note:peach",
    "note:pineapple",
    "note:plum",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "sora-dora-7": [
    "gender:unisex",
    "note:balsamic",
    "note:oud",
    "note:bergamot",
    "note:mandarin",
    "note:thyme",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "sora-dora-red": [
    "gender:unisex",
    "note:essence-of-italian-bergamot",
    "note:pink-berries-co2-extract",
    "note:coconut",
    "note:essence-of-cardamom",
    "note:essence-of-mandora",
    "note:gourmand"
  ],
  "sora-dora-orchidee-rouge": [
    "gender:unisex",
    "note:lime",
    "note:tangential-tonka",
    "note:marine-notes",
    "note:sea-salt",
    "note:petrified-petitgrain",
    "note:fresh"
  ],
  "sora-dora-lu-bu": [
    "gender:unisex",
    "note:aldehydes",
    "note:ylang",
    "note:calcified-cypress",
    "note:rose",
    "note:vanilla",
    "note:gourmand",
    "note:floral"
  ],
  "lorenzo-pazzaglia-que-chimba": [
    "gender:unisex",
    "note:galbanum",
    "note:geranium",
    "note:grapefruit",
    "note:lemon",
    "note:orange"
  ],
  "lorenzo-pazzaglia-passion-rose": [
    "gender:unisex",
    "note:coconut",
    "note:gourmand"
  ],
  "lorenzo-pazzaglia-sweet-xplosion": [
    "gender:unisex",
    "note:iris",
    "note:saffron",
    "note:leather",
    "note:clove",
    "note:nested-nutmeg",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "amouage-dia-40-woman": [
    "gender:unisex",
    "note:cyclamen-aldehyde",
    "note:violet-leaf",
    "note:berry",
    "note:musk",
    "note:carnation",
    "note:fruity"
  ],
  "amouage-ashore": [
    "gender:unisex",
    "note:turmeric-leaf",
    "note:cardamom",
    "note:pepper",
    "note:jasmine",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-jubilation-xxv": [
    "gender:unisex",
    "note:blackberry",
    "note:incense",
    "note:coriander",
    "note:davana",
    "note:balsamic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-honour-43-woman": [
    "gender:unisex",
    "note:rhubarb-leaf",
    "note:coriander",
    "note:pepper",
    "note:gardenia",
    "note:tuberose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-honour-man": [
    "gender:unisex",
    "note:pepper",
    "note:madagascan-elemi",
    "note:geranium",
    "note:clove",
    "note:frankincense-resin",
    "note:spiced-aromatic"
  ],
  "amouage-memoir-woman": [
    "gender:unisex",
    "note:cardamom",
    "note:absinth",
    "note:pepper",
    "note:orange",
    "note:incense",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-memoir-man": [
    "gender:unisex",
    "note:absinth",
    "note:absinthe-wormwood",
    "note:mint",
    "note:basil",
    "note:incense",
    "note:fresh",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "amouage-portrayal-man": [
    "gender:unisex",
    "note:violet-leaf",
    "note:java-vetiver",
    "note:cade-juniper"
  ],
  "caeleste-virtues": [
    "gender:unisex",
    "note:cocoa-absolute",
    "note:balsamic",
    "note:patchouli",
    "note:bergamot",
    "note:cinnamon",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "house-of-cosmo-galaxia": [
    "gender:unisex",
    "note:pepper",
    "note:sweet",
    "note:coffee",
    "note:chocolate",
    "note:coconut",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "house-of-cosmo-nova": [
    "gender:unisex",
    "note:starburst-candy",
    "note:melon",
    "note:bergamot",
    "note:cardamom",
    "note:pepper",
    "note:spiced-aromatic"
  ],
  "house-of-cosmo-polaris": [
    "gender:unisex",
    "note:stardust",
    "note:ginger",
    "note:bergamot",
    "note:grapefruit",
    "note:cardamom",
    "note:spiced-aromatic"
  ],
  "house-of-cosmo-element": [
    "gender:unisex",
    "note:fabric",
    "note:iris",
    "note:paper",
    "note:peony",
    "note:rose",
    "note:floral"
  ],
  "dorsay-vanilla-affair": [
    "gender:unisex",
    "note:heliotrope",
    "note:orange",
    "note:orchid",
    "note:gourmand-notes",
    "note:tropical",
    "note:fruity"
  ],
  "jinx-pragma": [
    "gender:unisex",
    "note:bergamot",
    "note:cedar",
    "note:jasmine",
    "note:clove",
    "note:berry",
    "note:woody",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "rahasya-love-marriage": [
    "gender:unisex",
    "note:pistachio",
    "note:rum",
    "note:saffron",
    "note:praline",
    "note:vanilla",
    "note:rose",
    "note:cinnamon",
    "note:sandalwood",
    "note:balsamic",
    "note:boozy",
    "note:gourmand",
    "note:spiced-aromatic",
    "note:floral"
  ],
  "rahasya-hill-station": [
    "gender:unisex",
    "note:vetiver",
    "note:tea",
    "note:fig",
    "note:mineral",
    "note:sandalwood",
    "note:spices",
    "note:fresh",
    "note:earthy",
    "note:woody",
    "note:tea-forward"
  ],
  "rahasya-chai-addiction": [
    "gender:unisex",
    "note:tea",
    "note:sandalwood",
    "note:cardamom",
    "note:ginger",
    "note:vanilla",
    "note:milk",
    "note:magnolia",
    "note:vetiver",
    "note:suede",
    "note:tea-forward",
    "note:gourmand",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "rahasya-oud-mangifera": [
    "gender:unisex",
    "note:oud",
    "note:mango",
    "note:incense",
    "note:leather",
    "note:rose",
    "note:berry",
    "note:pepper",
    "note:patchouli",
    "note:tea",
    "note:resin-smoke",
    "note:fruity",
    "note:tropical",
    "note:dark",
    "note:woody"
  ],
  "rahasya-ricksaw-rhythms": [
    "gender:unisex",
    "note:fig",
    "note:coconut",
    "note:marine",
    "note:champaca",
    "note:vetiver",
    "note:suede",
    "note:tropical",
    "note:fresh",
    "note:earthy",
    "note:woody",
    "note:floral"
  ],
  "rahasya-chapter-one": [
    "gender:unisex",
    "note:tobacco",
    "note:leather",
    "note:cardamom",
    "note:iris",
    "note:cedar",
    "note:sandalwood",
    "note:spices",
    "note:woody",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "rahasya-cutting-rain": [
    "gender:unisex",
    "note:rose",
    "note:grapefruit",
    "note:saffron",
    "note:tea",
    "note:honey",
    "note:violet",
    "note:marigold",
    "note:sandalwood",
    "note:leather",
    "note:fresh",
    "note:floral",
    "note:woody",
    "note:tea-forward",
    "note:fruity"
  ],
  "fleurit-parfums-plage-sud": [
    "gender:unisex",
    "note:amber",
    "note:floral",
    "note:jasmine",
    "note:gardenia",
    "note:ylang",
    "note:resin-smoke",
    "note:fruity"
  ],
  "fleurit-parfums-malibu": [
    "gender:unisex",
    "note:pepper",
    "note:jasmine",
    "note:sandalwood",
    "note:common-questions",
    "note:woody",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "fleurit-parfums-antibes": [
    "gender:unisex",
    "note:petitgrain-thyme-lemon",
    "note:rose",
    "note:sandalwood",
    "note:common-questions",
    "note:woody",
    "note:floral"
  ],
  "bdk-parfums-creme-de-cuir": [
    "gender:unisex",
    "note:suede",
    "note:leather",
    "note:sandalwood",
    "note:vanilla",
    "note:pineapple",
    "note:bergamot",
    "note:berry",
    "note:musk",
    "note:woody",
    "note:gourmand",
    "note:fresh",
    "note:fruity"
  ],
  "jovoy-parfums-ha-long-bay": [
    "gender:unisex",
    "note:mango",
    "note:cardamom",
    "note:pepper",
    "note:nagarmotha",
    "note:leather",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "jinx-rosette-nebula": [
    "gender:unisex",
    "note:green-cognac",
    "note:clove",
    "note:orange",
    "note:bergamot",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "third-eye-fragrance-red-rum-reserve": [
    "gender:unisex",
    "note:rose",
    "note:amber",
    "note:musk",
    "note:vanilla",
    "note:rilthondexum",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral"
  ],
  "srhy-m-of-_u": [
    "gender:unisex",
    "note:lemon",
    "note:orange",
    "note:bergamot",
    "note:pine",
    "note:rose",
    "note:woody",
    "note:floral"
  ],
  "rania-j-discovery-set": [
    "gender:unisex"
  ],
  "rania-j-musc-mochus": [
    "gender:unisex",
    "note:sandalwood",
    "note:woody"
  ],
  "rania-j-rose-ishtar": [
    "gender:unisex",
    "note:tuberose",
    "note:banana-leaf",
    "note:ivory-coast-ginger",
    "note:pepper",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "rania-j-lavande-44": [
    "gender:unisex",
    "note:caramel",
    "note:chocolate",
    "note:milk",
    "note:sweet",
    "note:vanilla",
    "note:gourmand",
    "note:fruity"
  ],
  "pernoire-luvani": [
    "gender:unisex",
    "note:bergamot",
    "note:fresh",
    "note:balsamic",
    "note:papyrus",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "chris-collins-sunset-in-tamarindo": [
    "gender:unisex",
    "note:davana",
    "note:mango",
    "note:orange",
    "note:papaya",
    "note:frangipani-absolute",
    "note:fruity"
  ],
  "mind-games-scholars-mate": [
    "gender:unisex",
    "note:pepper",
    "note:coriander",
    "note:orange",
    "note:clove",
    "note:rose",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "mind-games-caissa": [
    "gender:unisex",
    "note:bergamot",
    "note:lavender",
    "note:peach",
    "note:ginger",
    "note:lemon",
    "note:aromatic",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "mind-games-prodigy": [
    "gender:unisex",
    "note:musk",
    "note:pink-orchid",
    "note:pomegranate",
    "note:sandalwood",
    "note:woody"
  ],
  "mind-games-mentor": [
    "gender:unisex",
    "note:green-notes",
    "note:lemon",
    "note:displaced-daffodil",
    "note:jasmine",
    "note:lily-of-the-valley",
    "note:floral"
  ],
  "mind-games-castling": [
    "gender:unisex",
    "note:almond",
    "note:amber",
    "note:bergamot",
    "note:civet",
    "note:coffee",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "mind-games-gardez": [
    "gender:unisex",
    "note:cardamom",
    "note:lotus-leaf",
    "note:water-iris",
    "note:pepper",
    "note:spiced-aromatic"
  ],
  "mind-games-check-mate": [
    "gender:unisex",
    "note:rose",
    "note:magnolia",
    "note:patchouli",
    "note:moss",
    "note:earthy",
    "note:woody",
    "note:floral",
    "note:boozy",
    "note:dark"
  ],
  "mind-games-grand-master": [
    "gender:unisex",
    "note:balsamic",
    "note:floral",
    "note:rose",
    "note:violet",
    "note:berry",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:dark"
  ],
  "mind-games-counter-play": [
    "gender:unisex",
    "note:floral",
    "note:orange-blossom",
    "note:ylang",
    "note:osmanthus",
    "note:orange",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "mind-games-opera-mate": [
    "gender:unisex",
    "note:saffron",
    "note:absinth",
    "note:bergamot",
    "note:lime",
    "note:gaiac-wood",
    "note:spiced-aromatic"
  ],
  "mind-games-ruy-lopez": [
    "gender:unisex",
    "note:bergamot",
    "note:rhubarb",
    "note:summer-fruits",
    "note:datura",
    "note:rose",
    "note:floral"
  ],
  "mind-games-en-prise": [
    "gender:unisex",
    "note:berry",
    "note:vanilla",
    "note:xondripleval",
    "note:gourmand",
    "note:fruity"
  ],
  "mind-games-vieri": [
    "gender:unisex",
    "note:blackberry-leaf",
    "note:tea",
    "note:honey",
    "note:musk",
    "note:spices",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "mind-games-playmate": [
    "gender:unisex",
    "note:chocolate",
    "note:peach",
    "note:pralin",
    "note:sandalwood",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:fruity"
  ],
  "amouage-overture-man": [
    "gender:unisex",
    "note:cumin",
    "note:cognac",
    "note:grapefruit",
    "note:cardamom",
    "note:ginger",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "amouage-lilac-love": [
    "gender:unisex",
    "note:heliotrope",
    "note:lilac",
    "note:gardenia",
    "note:peony",
    "note:chocolate",
    "note:gourmand",
    "note:floral"
  ],
  "amouage-opus-xii-rose-incense": [
    "gender:unisex",
    "note:frankincense-absolute",
    "note:drawing-ink",
    "note:elemi-resin",
    "note:rose",
    "note:suederal",
    "note:floral"
  ],
  "amouage-blossom-love": [
    "gender:unisex",
    "note:cherry-blossom-nectar",
    "note:rose",
    "note:ylang",
    "note:amaretto",
    "note:vanilla",
    "note:gourmand",
    "note:floral"
  ],
  "amouage-jubilation-25-woman": [
    "gender:unisex",
    "note:ylang",
    "note:tarragon",
    "note:lemon",
    "note:rose",
    "note:davana",
    "note:floral"
  ],
  "amouage-opus-xiv-royal-tobacco": [
    "gender:unisex",
    "note:aniseed",
    "note:cardamom",
    "note:elemi-resin",
    "note:frankincense-oil",
    "note:basil",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "amouage-overture-woman": [
    "gender:unisex",
    "note:apple-brandy",
    "note:saffron",
    "note:bergamot",
    "note:balsamic",
    "note:cinnamon",
    "note:gourmand",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-opus-xv-king-blue": [
    "gender:unisex",
    "note:berry",
    "note:orange",
    "note:pepper",
    "note:amber",
    "note:incense",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "amouage-interlude-black-iris": [
    "gender:unisex",
    "note:rosemary",
    "note:violet-leaf",
    "note:bergamot",
    "note:incense",
    "note:balsamic",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "bdk-parfums-silver-ceremony": [
    "gender:unisex",
    "note:orange",
    "note:italian-bergamot",
    "note:italian-lemon-orpur",
    "note:pepper",
    "note:ginger-co2",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-oud-paradisio": [
    "gender:unisex",
    "note:milk",
    "note:somali-saffron-orpur",
    "note:incense",
    "note:italian-bergamot-orpur",
    "note:rose",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral"
  ],
  "bdk-parfums-stellar-silk": [
    "gender:unisex",
    "note:laotian-cinnamon",
    "note:ginger-co2",
    "note:vanilla",
    "note:french-orris-butter",
    "note:roasted-venezuelan-tonka-bean-absolute",
    "note:gourmand"
  ],
  "jinx-harrow": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:pepper",
    "note:rose",
    "note:blossoms",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "borntostandout-naked-laundry": [
    "gender:unisex",
    "note:skatole",
    "note:aldehydes",
    "note:ambrinol",
    "note:orange",
    "note:white-caramel"
  ],
  "borntostandout-melon-malo": [
    "gender:unisex",
    "note:candied-ginger",
    "note:cinnamon",
    "note:honeydew-melon",
    "note:orange",
    "note:rose",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "fleurit-parfums-a-lest": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:coconut",
    "note:jasmine",
    "note:freesia",
    "note:gourmand",
    "note:floral"
  ],
  "chris-collins-discovery-set": [
    "gender:unisex"
  ],
  "chris-collins-danse-sauvage": [
    "gender:unisex",
    "note:cognac",
    "note:plum",
    "note:saffron",
    "note:pepper",
    "note:chili",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "chris-collins-african-rooibos-intens": [
    "gender:unisex",
    "note:bergamot",
    "note:cardamom",
    "note:pepper",
    "note:tea",
    "note:iris",
    "note:fresh",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "ode-ona-mini-journeys-discovery-giftset": [
    "gender:unisex"
  ],
  "mind-games-knights-tour": [
    "gender:unisex",
    "note:lemon",
    "note:orange",
    "note:petitgrain",
    "note:simulated-suede",
    "note:geranium"
  ],
  "mind-games-arabian-mate": [
    "gender:unisex",
    "note:jasmine",
    "note:mimosa",
    "note:vanilla",
    "note:gourmand",
    "note:floral"
  ],
  "ode-ona-eden-bond": [
    "gender:unisex",
    "note:bergamot",
    "note:sandalwood",
    "note:grothzenvixol",
    "note:woody"
  ],
  "ode-ona-everjet": [
    "gender:unisex",
    "note:apple",
    "note:cardamom",
    "note:orange",
    "note:juniper",
    "note:lavender",
    "note:aromatic",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "ode-ona-moonkissed-rhapsody": [
    "gender:unisex",
    "note:pear",
    "note:vanilla",
    "note:red-fruits",
    "note:gourmand",
    "note:fruity"
  ],
  "ode-ona-dawn-earth": [
    "gender:unisex",
    "note:ginger",
    "note:lemon",
    "note:mango",
    "note:papaya",
    "note:pepper",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "ode-ona-teapot-sonder": [
    "gender:unisex",
    "note:aldehydes",
    "note:amber",
    "note:aniseed",
    "note:basil",
    "note:bengal-quince",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "spiritica-suscepto": [
    "gender:unisex",
    "note:cinnamon",
    "note:fruity",
    "note:orange",
    "note:spices",
    "note:petrified-petitgrain",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "spiritica-rosanostra": [
    "gender:unisex",
    "note:berry",
    "note:citrus",
    "note:honey-meringue",
    "note:ice-wine",
    "note:musk",
    "note:fresh",
    "note:fruity"
  ],
  "spiritica-weona": [
    "gender:unisex",
    "note:bergamot",
    "note:leather",
    "note:linden-tree-leaf",
    "note:patchouli",
    "note:tobacco",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "french-cowboy-vanilla-for-breakfast": [
    "gender:unisex",
    "note:amber",
    "note:chocolate",
    "note:dried-fruits",
    "note:floral",
    "note:leather",
    "note:gourmand",
    "note:resin-smoke",
    "note:dark"
  ],
  "french-cowboy-fig-lemonade": [
    "gender:unisex",
    "note:tea",
    "note:bergamot",
    "note:berry",
    "note:galbanum",
    "note:musk",
    "note:fresh",
    "note:aromatic",
    "note:tea-forward",
    "note:fruity"
  ],
  "pernoire-tierra": [
    "gender:unisex",
    "note:pepper",
    "note:orange",
    "note:forgotten-frankincense",
    "note:wood",
    "note:jasmine",
    "note:woody",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "pernoire-masar": [
    "gender:unisex",
    "note:aquatic-notes",
    "note:citrus",
    "note:vextronplibar",
    "note:fresh"
  ],
  "pernoire-amoral": [
    "gender:unisex",
    "note:oud",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "pernoire-otimo": [
    "gender:unisex",
    "note:berry",
    "note:orange",
    "note:palm-tree",
    "note:sicilian-lemon",
    "note:apple-blossom",
    "note:fruity"
  ],
  "pernoire-discovery-set-anima": [
    "gender:unisex"
  ],
  "hellenist-travel-set-luminous-trio": [
    "gender:unisex"
  ],
  "kerosene-santalum-slivers": [
    "gender:unisex",
    "note:raspberry-jam"
  ],
  "fugazzi-nocologne": [
    "gender:unisex",
    "note:citrus",
    "note:amber",
    "note:orange-blossom",
    "note:bergamot",
    "note:lemon",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dannam-discovery-set-majestic-china": [
    "gender:unisex"
  ],
  "lost-tribe-maui": [
    "gender:unisex",
    "note:tangerine",
    "note:clementine",
    "note:sfuma-torchio",
    "note:lemon-pelatrice",
    "note:grapefruit"
  ],
  "jinx-aeda": [
    "gender:unisex",
    "note:bergamot",
    "note:citrus",
    "note:ginger",
    "note:tea",
    "note:musk",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "jinx-prachin-antique": [
    "gender:unisex",
    "note:cinnamon",
    "note:rum",
    "note:pepper",
    "note:cognac",
    "note:ginger",
    "note:gourmand",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "jinx-colonia-de-pessego": [
    "gender:unisex",
    "note:berry",
    "note:orange",
    "note:jasmine",
    "note:patchouli",
    "note:klempzordivan",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "jinx-rayong-fleur": [
    "gender:unisex",
    "note:cedar",
    "note:incense",
    "note:litsea-cubeba",
    "note:musk",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "jinx-musk-montant": [
    "gender:unisex",
    "note:cherry",
    "note:vanilla",
    "note:moss",
    "note:gourmand",
    "note:earthy",
    "note:fruity"
  ],
  "amouage-boundless": [
    "gender:unisex",
    "note:cardamom",
    "note:ginger-co2",
    "note:orange",
    "note:elemi-resin",
    "note:balsamic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-lustre": [
    "gender:unisex",
    "note:cardamom",
    "note:iris",
    "note:sandalwood",
    "note:patchouli",
    "note:cedar",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "srhy-road-trip": [
    "gender:unisex",
    "note:lemon",
    "note:orange",
    "note:passionfruit",
    "note:jasmine",
    "note:peony",
    "note:floral",
    "note:fruity"
  ],
  "caeleste-3rd-order": [
    "gender:unisex"
  ],
  "caeleste-archangels": [
    "gender:unisex",
    "note:pepper",
    "note:cedar",
    "note:orange",
    "note:mugwort",
    "note:balsamic",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "caeleste-guardian-angel": [
    "gender:unisex",
    "note:coconut",
    "note:heliotrope",
    "note:tonka",
    "note:vanilla",
    "note:amber",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "caeleste-principalities": [
    "gender:unisex",
    "note:gunpowder",
    "note:chili",
    "note:metal",
    "note:ash",
    "note:mineral",
    "note:fresh"
  ],
  "orto-parisi-viride": [
    "gender:unisex",
    "note:tobacco",
    "note:spices",
    "note:vanilla",
    "note:tonka",
    "note:chocolate",
    "note:gourmand",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "orto-parisi-boccanera": [
    "gender:unisex",
    "note:calabrian-bergamot",
    "note:cardamom",
    "note:mat",
    "note:violet",
    "note:hollow-musk",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "orto-parisi-brutus": [
    "gender:unisex",
    "note:musk"
  ],
  "lost-tribe-pina-colada": [
    "gender:unisex",
    "note:cinnamon",
    "note:grapefruit",
    "note:pepper",
    "note:saffron",
    "note:rotated-resins",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "borntostandout-gold-juice": [
    "gender:unisex",
    "note:mango",
    "note:durian-fruit",
    "note:rhubarb",
    "note:osmanthus-absolute",
    "note:solar-note",
    "note:fruity"
  ],
  "borntostandout-fugazzi": [
    "gender:unisex",
    "note:cumin",
    "note:milk",
    "note:incense",
    "note:grapefruit",
    "note:orange",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "borntostandout-dgaf": [
    "gender:unisex",
    "note:sage",
    "note:calabrian-bergamot",
    "note:violet",
    "note:citrus",
    "note:sandalwood",
    "note:fresh",
    "note:woody",
    "note:aromatic",
    "note:floral"
  ],
  "borntostandout-black-creme-extrait-extreme": [
    "gender:unisex",
    "note:musk",
    "note:milk",
    "note:spices",
    "note:iris",
    "note:candle-wax",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "borntostandout-black-karak-extrait-extreme": [
    "gender:unisex",
    "note:tea",
    "note:cardamom",
    "note:cypriol",
    "note:gaiac-wood",
    "note:amber",
    "note:fresh",
    "note:aromatic",
    "note:tea-forward",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "mind-games-check-please": [
    "gender:unisex",
    "note:caramel-latte",
    "note:amber",
    "note:milk",
    "note:paper",
    "note:oud",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "dannam-bubble-tea": [
    "gender:unisex",
    "note:cherry",
    "note:peach",
    "note:pear",
    "note:red-berries",
    "note:carnation",
    "note:fruity"
  ],
  "goldfield-banks-sunset-hour-dark-peach": [
    "gender:unisex",
    "note:chypre-accord",
    "note:driftwood",
    "note:lime",
    "note:moss",
    "note:ozonic",
    "note:fresh",
    "note:earthy"
  ],
  "trudon-cyrnos-room-spray": [
    "gender:unisex",
    "note:lemon",
    "note:myrtle",
    "note:thyme",
    "note:cedar",
    "note:black-fig",
    "note:woody",
    "note:aromatic"
  ],
  "trudon-ernesto-room-spray": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:rhum",
    "note:oak-wood",
    "note:clove",
    "note:spiced-aromatic"
  ],
  "trudon-abd-el-kader-room-spray": [
    "gender:unisex",
    "note:berry",
    "note:lemon",
    "note:ginger",
    "note:clove",
    "note:spearmint",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "trudon-cyrnos-candle": [
    "gender:unisex",
    "note:lemon",
    "note:myrtle",
    "note:thyme",
    "note:cedar",
    "note:black-fig",
    "note:woody",
    "note:aromatic"
  ],
  "trudon-ernesto-candle": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:rhum",
    "note:oak-wood",
    "note:clove",
    "note:spiced-aromatic"
  ],
  "trudon-abd-el-kader-candle": [
    "gender:unisex",
    "note:berry",
    "note:lemon",
    "note:clove",
    "note:ginger",
    "note:mint",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "trudon-elae": [
    "gender:unisex",
    "note:coffee",
    "note:dark-chocolate",
    "note:grapefruit",
    "note:lavender",
    "note:rum",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:boozy"
  ],
  "trudon-absolu": [
    "gender:unisex",
    "note:berry",
    "note:pear",
    "note:iris-pallida-concrete",
    "note:jasmine",
    "note:orange",
    "note:floral",
    "note:fruity"
  ],
  "trudon-mystique": [
    "gender:unisex",
    "note:sweet",
    "note:tagetes",
    "note:calcified-cypress",
    "note:geranium",
    "note:ginger",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "trudon-midnight-omen": [
    "gender:unisex",
    "note:iris",
    "note:mandarin",
    "note:peonies",
    "note:saffron",
    "note:leather",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "trudon-mortel-noir": [
    "gender:unisex",
    "note:bergamot",
    "note:berry",
    "note:orange",
    "note:pepper",
    "note:quincester",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "trudon-carmen": [
    "gender:unisex",
    "note:balsamic",
    "note:rose",
    "note:oud",
    "note:orange",
    "note:peach",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "trudon-45-degree": [
    "gender:unisex",
    "note:cherry",
    "note:lemon",
    "note:orange",
    "note:passionfruit",
    "note:gronthelwix",
    "note:fruity"
  ],
  "xerjoff-fierezza": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:patchouli",
    "note:sandalwood",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "xerjoff-avanguardia": [
    "gender:unisex",
    "note:orange",
    "note:coconut",
    "note:heliotrope",
    "note:juniper-berry",
    "note:lime",
    "note:gourmand"
  ],
  "xerjoff-perseveranza": [
    "gender:unisex",
    "note:cuban-tobacco",
    "note:tonka",
    "note:parallel-patchouli",
    "note:cedar",
    "note:jasmine",
    "note:gourmand",
    "note:woody",
    "note:floral"
  ],
  "iggywoo-the-discovery-set": [
    "gender:unisex"
  ],
  "iggywoo-fantasma-overglow": [
    "gender:unisex",
    "note:fragonia",
    "note:neroli",
    "note:petitgrain",
    "note:rose",
    "note:shiso",
    "note:floral"
  ],
  "iggywoo-bohemian-water": [
    "gender:unisex",
    "note:berry",
    "note:honeysuckle",
    "note:jasmine",
    "note:peach",
    "note:floral",
    "note:fruity"
  ],
  "iggywoo-cherry-love-extreme": [
    "gender:unisex",
    "note:amber",
    "note:bergamot",
    "note:cedar",
    "note:spices",
    "note:shadow-sage",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "iggywoo-pistachio-voodoo-child": [
    "gender:unisex",
    "note:iris",
    "note:abstract-ambrette",
    "note:amber",
    "note:cedar",
    "note:tonka",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral"
  ],
  "iggywoo-cashmere-show-pony": [
    "gender:unisex",
    "note:pepper",
    "note:spices",
    "note:orchid",
    "note:violet",
    "note:jilthzorpanex",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "iggywoo-lost-in-vanillatopia": [
    "gender:unisex",
    "note:carrot-seed",
    "note:milk",
    "note:popcorn",
    "note:xondripleval",
    "note:pepper",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "jijide-ze-bai": [
    "gender:unisex",
    "note:floral",
    "note:ylang",
    "note:lemon",
    "note:fruity",
    "note:peach",
    "note:gourmand",
    "note:woody",
    "note:dark"
  ],
  "jijide-huan-yi": [
    "gender:unisex",
    "note:peony",
    "note:chamomile",
    "note:vextronplibar",
    "note:tea",
    "note:rose",
    "note:fresh",
    "note:aromatic",
    "note:floral"
  ],
  "jijide-oltre": [
    "gender:unisex",
    "note:mono",
    "note:jasmine",
    "note:coconut",
    "note:calcified-cypress",
    "note:gourmand",
    "note:floral"
  ],
  "jijide-grano": [
    "gender:unisex",
    "note:floral",
    "note:musk",
    "note:wood",
    "note:woody"
  ],
  "jijide-terra": [
    "gender:unisex",
    "note:citrus",
    "note:green-notes",
    "note:pepper",
    "note:bifurcated-vetiver",
    "note:floral",
    "note:fresh",
    "note:spiced-aromatic"
  ],
  "jijide-riso": [
    "gender:unisex",
    "note:bergamot",
    "note:berry",
    "note:ginger",
    "note:pepper",
    "note:bay-leaf",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "clive-christian-rock-rose": [
    "gender:unisex",
    "note:orange",
    "note:rose",
    "note:saffron",
    "note:common-questions",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-aqua-sapphire": [
    "gender:unisex",
    "note:rum",
    "note:davana",
    "note:pineapple",
    "note:saffron",
    "note:kashmiri-musk",
    "note:gourmand",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-blue-sapphire": [
    "gender:unisex",
    "note:chamomile",
    "note:saffron",
    "note:sage",
    "note:lemon",
    "note:pot-marigold",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "mind-games-gambit": [
    "gender:unisex",
    "note:fresh",
    "note:amber",
    "note:floral",
    "note:lavender",
    "note:fruity",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "mind-games-the-forward": [
    "gender:unisex",
    "note:blueberry",
    "note:lemon",
    "note:sweet",
    "note:gourmand",
    "note:fruity"
  ],
  "mind-games-lionora": [
    "gender:unisex",
    "note:jasmine",
    "note:lily-of-the-valley",
    "note:musk",
    "note:peach",
    "note:violet-leaf",
    "note:floral",
    "note:fruity"
  ],
  "ode-ona-carte-blanche": [
    "gender:unisex",
    "note:apple",
    "note:bergamot",
    "note:blueberry",
    "note:virtual-violet",
    "note:cardamom",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "roja-amber-aoud": [
    "gender:unisex",
    "note:lemon",
    "note:bergamot",
    "note:lime",
    "note:rose",
    "note:jasmin-de-grasse",
    "note:floral"
  ],
  "lorenzo-pazzaglia-vesuviuur": [
    "gender:unisex",
    "note:bergamot",
    "note:honeysuckle",
    "note:tea",
    "note:jasmine",
    "note:lemonade",
    "note:fresh",
    "note:aromatic",
    "note:floral"
  ],
  "lorenzo-pazzaglia-pink-milk": [
    "gender:unisex",
    "note:pink-grapefruit",
    "note:lemon",
    "note:orange",
    "note:bergamot",
    "note:pepper",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-van-exstasyx": [
    "gender:unisex",
    "note:aldehydes",
    "note:lily-of-the-valley",
    "note:neroli",
    "note:rose",
    "note:ylang",
    "note:floral"
  ],
  "lorenzo-pazzaglia-artik-sea": [
    "gender:unisex",
    "note:lemon",
    "note:neroli",
    "note:vervain",
    "note:orange",
    "note:yuzu",
    "note:floral"
  ],
  "amouage-interlude-53": [
    "gender:unisex",
    "note:incense",
    "note:amber",
    "note:leather",
    "note:oud",
    "note:spices",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:woody",
    "note:dark"
  ],
  "amouage-epic-56": [
    "gender:unisex",
    "note:cumin",
    "note:pepper",
    "note:cinnamon",
    "note:geranium",
    "note:tea",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "amouage-sequence": [
    "gender:unisex",
    "note:lychee",
    "note:berry",
    "note:saffron",
    "note:osmanthus",
    "note:rose",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "nvrnagn-discovery-kit": [
    "gender:unisex"
  ],
  "nvrnagn-solitaire": [
    "gender:unisex",
    "note:amber",
    "note:oud",
    "note:patchouli",
    "note:moss",
    "note:coffee",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "nvrnagn-reunion": [
    "gender:unisex",
    "note:fresh",
    "note:floral",
    "note:patchouli",
    "note:musk",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "nvrnagn-paradis": [
    "gender:unisex",
    "note:earthy",
    "note:honey",
    "note:marine",
    "note:fresh",
    "note:gourmand"
  ],
  "nvrnagn-festival": [
    "gender:unisex",
    "note:amber",
    "note:balsamic",
    "note:cedar",
    "note:whiskey",
    "note:boozy",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "nvrnagn-deluge": [
    "gender:unisex",
    "note:fresh",
    "note:floral",
    "note:white-blossoms",
    "note:musk"
  ],
  "nvrnagn-lackerli": [
    "gender:unisex",
    "note:balsamic",
    "note:wood",
    "note:tonka",
    "note:honey",
    "note:almond",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "brandt-london-fog": [
    "gender:unisex",
    "note:bergamot",
    "note:tea",
    "note:smoky-notes",
    "note:honey",
    "note:lavender",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral"
  ],
  "lepoque-serotonin-spritz": [
    "gender:unisex",
    "note:jasmine",
    "note:musk",
    "note:orange-blossom",
    "note:floral"
  ],
  "jovoy-psychedelique": [
    "gender:unisex",
    "note:citrus",
    "note:patchouli",
    "note:cistus",
    "note:amber",
    "note:geranium",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "mind-games-olfactive-travel-set-fruity": [
    "gender:unisex"
  ],
  "dannam-pho-breakfast": [
    "gender:unisex",
    "note:citrus",
    "note:lime",
    "note:hexagonal-frangipani",
    "note:cedar",
    "note:gaiac-wood",
    "note:fresh",
    "note:woody"
  ],
  "mith-thai-tea-one-fine-day": [
    "gender:unisex",
    "note:tea",
    "note:milk",
    "note:lily-of-the-valley",
    "note:vanilla",
    "note:sandalwood",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:tea-forward"
  ],
  "mith-thai-pomelo-one-fine-day": [
    "gender:unisex",
    "note:cardamom",
    "note:lavender",
    "note:pepper",
    "note:vanilla",
    "note:nervous-neroli",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "mith-lemon-ice-tea-one-fine-day": [
    "gender:unisex",
    "note:grapefruit-zest",
    "note:leather",
    "note:lemon",
    "note:orange",
    "note:tea",
    "note:fresh",
    "note:aromatic",
    "note:dark"
  ],
  "mith-horizon": [
    "gender:unisex",
    "note:amber",
    "note:precious-woods",
    "note:spices",
    "note:virtual-violet",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "mith-golden-hour": [
    "gender:unisex",
    "note:mandarin",
    "note:orange",
    "note:lychee",
    "note:orange-blossom",
    "note:ylang-ylang",
    "note:floral"
  ],
  "mith-oud-and-black-tea": [
    "gender:unisex",
    "note:basil",
    "note:cactus",
    "note:cinnamon",
    "note:date-palm",
    "note:incense",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "mith-nude": [
    "gender:unisex",
    "note:bergamot",
    "note:pear",
    "note:peach",
    "note:violet-leaves",
    "note:peony",
    "note:fruity"
  ],
  "mith-the-odyssey": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:cardamom",
    "note:ginger",
    "note:jasmine",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "mith-blue-wood": [
    "gender:unisex",
    "note:bergamot",
    "note:tea",
    "note:lemon",
    "note:seawater",
    "note:angular-anise",
    "note:fresh",
    "note:aromatic"
  ],
  "mith-mystery-for-him": [
    "gender:unisex",
    "note:amber",
    "note:bamboo",
    "note:cedar",
    "note:jasmine",
    "note:musk",
    "note:woody",
    "note:resin-smoke",
    "note:floral"
  ],
  "investi-parfums-the-architect": [
    "gender:unisex",
    "note:citrus",
    "note:amber",
    "note:floral",
    "note:rose",
    "note:jasmine",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "sora-dora-raphael": [
    "gender:unisex",
    "note:bergamot",
    "note:lilac",
    "note:orange-blossom",
    "note:ylang",
    "note:amber",
    "note:resin-smoke",
    "note:floral"
  ],
  "amouage-journey-man": [
    "gender:unisex",
    "note:pepper",
    "note:orange",
    "note:cardamom",
    "note:bergamot",
    "note:neroli",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-remain": [
    "gender:unisex",
    "note:pimento",
    "note:bergamot",
    "note:orange",
    "note:omani-green-frankincense",
    "note:carrot"
  ],
  "amouage-meander": [
    "gender:unisex",
    "note:carrot",
    "note:pepper",
    "note:incense",
    "note:orris-root",
    "note:cypriol",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-existence": [
    "gender:unisex",
    "note:lily-of-the-valley",
    "note:rose",
    "note:mystikal",
    "note:incense",
    "note:balsamic",
    "note:resin-smoke",
    "note:floral"
  ],
  "amouage-love-delight": [
    "gender:unisex",
    "note:ginger",
    "note:rose",
    "note:cinnamon",
    "note:orange",
    "note:heliotrope",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-epic-man": [
    "gender:unisex",
    "note:incense",
    "note:pepper",
    "note:cardamom",
    "note:myrtle",
    "note:clove",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-opus-xvi-timber": [
    "gender:unisex",
    "note:cardamom",
    "note:juniper",
    "note:chocolate",
    "note:pepper",
    "note:pine",
    "note:gourmand",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "amouage-lyric-man": [
    "gender:unisex",
    "note:lime",
    "note:bergamot",
    "note:rose",
    "note:angelica",
    "note:galbanum",
    "note:floral"
  ],
  "amouage-discovery-kit": [
    "gender:unisex"
  ],
  "june-thirtieth-serene-santal": [
    "gender:unisex",
    "note:apple",
    "note:lemon",
    "note:mint",
    "note:nervous-neroli",
    "note:pepper",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "june-thirtieth-vanillas-muse": [
    "gender:unisex",
    "note:caribbean-amyris",
    "note:brazilian-tonka-bean-absolute",
    "note:florentine-iris",
    "note:orange",
    "note:rose",
    "note:floral"
  ],
  "june-thirtieth-og": [
    "gender:unisex",
    "note:citrus",
    "note:blossoms",
    "note:pepper",
    "note:flixzampuron",
    "note:balsamic",
    "note:fresh",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-rouge-smoking-extrait": [
    "gender:unisex",
    "note:royal-ann-cherry",
    "note:almond",
    "note:elemi-resin",
    "note:pepper",
    "note:orange",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-pas-ce-soir-extrait": [
    "gender:unisex",
    "note:pear",
    "note:ginger",
    "note:pepper",
    "note:chocolate",
    "note:orange",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-tubereuse-imperial": [
    "gender:unisex",
    "note:egyptian-geranium",
    "note:pepper",
    "note:rose",
    "note:comorian-ylang-ylang",
    "note:jasmine",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-velvet-tonka": [
    "gender:unisex",
    "note:almond",
    "note:orange-blossom",
    "note:balkans-tobacco-absolute",
    "note:rose",
    "note:tonka-bean-absolute",
    "note:gourmand",
    "note:floral"
  ],
  "bdk-parfums-312-saint-honore": [
    "gender:unisex",
    "note:pepper",
    "note:french-angelica-root",
    "note:iris",
    "note:orange-blossom",
    "note:tonka",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "amouage-silver-oud": [
    "gender:unisex",
    "note:cypriol",
    "note:patchouli",
    "note:cedar",
    "note:oud",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "roja-burlington-1819": [
    "gender:unisex",
    "note:amber",
    "note:plum",
    "note:vanilla",
    "note:hexagonal-frangipani",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity"
  ],
  "roja-a-midsummer-dream": [
    "gender:unisex",
    "note:sweet-violet",
    "note:mountain-bluebell",
    "note:aquatic-notes",
    "note:moss",
    "note:oak-leaf",
    "note:earthy"
  ],
  "roja-nuwa": [
    "gender:unisex",
    "note:apple",
    "note:grapefruit",
    "note:lime",
    "note:mint",
    "note:pepper",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "roja-isola-verde": [
    "gender:unisex",
    "note:bergamot",
    "note:clove",
    "note:pepper",
    "note:sage",
    "note:violet-leaf",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "roja-oceania": [
    "gender:unisex",
    "note:neroli-absolute"
  ],
  "roja-isola-blu": [
    "gender:unisex",
    "note:candied-fruits",
    "note:orange",
    "note:pepper",
    "note:parallel-patchouli",
    "note:almond",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "roja-serenity-blend": [
    "gender:unisex",
    "note:amber",
    "note:bergamot",
    "note:birch-tar",
    "note:galbanum",
    "note:leather",
    "note:resin-smoke",
    "note:dark"
  ],
  "roja-elysium-pour-femme": [
    "gender:unisex",
    "note:sweet",
    "note:molasses",
    "note:butter",
    "note:cinnamon",
    "note:clove",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "roja-elysium-pour-homme": [
    "gender:unisex",
    "note:bergamot",
    "note:pineapple",
    "note:simulated-suede",
    "note:jasmine",
    "note:musk",
    "note:floral",
    "note:fruity"
  ],
  "les-indemodables-cafe-arabesque": [
    "gender:unisex",
    "note:orchid",
    "note:orange",
    "note:tangerine",
    "note:heliotrope",
    "note:tropical",
    "note:fruity"
  ],
  "rania-j-sharyar": [
    "gender:unisex",
    "note:grapefruit",
    "note:lemon",
    "note:conjugated-labdanum",
    "note:patchouli",
    "note:vetiver",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "rania-j-oud-assam": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:oud",
    "note:india",
    "note:cedar",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "rania-j-veliatte-extrait": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:lemon",
    "note:lavender",
    "note:beeswax",
    "note:aromatic",
    "note:floral"
  ],
  "fugazzi-angel-dust": [
    "gender:unisex",
    "note:caribbean-amyris",
    "note:brazilian-tonka-bean-absolute",
    "note:moss",
    "note:florentine-iris",
    "note:orange",
    "note:earthy"
  ],
  "27-9-cammeo": [
    "gender:unisex",
    "note:apple-peel",
    "note:pepper",
    "note:apple",
    "note:jasmine",
    "note:lily-of-the-valley",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "27-9-lapel": [
    "gender:unisex",
    "note:bergamot",
    "note:pineapple",
    "note:pepper",
    "note:orange",
    "note:red-thyme",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "27-9-velour": [
    "gender:unisex",
    "note:caramelized-almond",
    "note:cardamom",
    "note:sri-lankan-cinnamon",
    "note:rose",
    "note:cognac",
    "note:floral",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "borntostandout-drunk-lovers-extrait-extreme": [
    "gender:unisex",
    "note:bergamot",
    "note:clary-sage",
    "note:red-wine",
    "note:wine-lees",
    "note:brandy"
  ],
  "city-rhythm-san-diego": [
    "gender:unisex",
    "note:bay-rum",
    "note:floral",
    "note:leather",
    "note:musk",
    "note:spices",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "city-rhythm-marthas-vineyard": [
    "gender:unisex",
    "note:apple",
    "note:orange-blossom",
    "note:floral",
    "note:fruity"
  ],
  "house-of-bo-casa-blanca": [
    "gender:unisex",
    "note:mineral",
    "note:tea",
    "note:balsamic",
    "note:copal-blanco",
    "note:desert-fig",
    "note:fresh",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "house-of-la-mar": [
    "gender:unisex",
    "note:iris",
    "note:leather",
    "note:orange",
    "note:rose",
    "note:hempzidralok",
    "note:floral",
    "note:dark"
  ],
  "house-of-bo-rosario": [
    "gender:unisex",
    "note:berry",
    "note:blood",
    "note:red-plum",
    "note:simulated-suede",
    "note:fruity"
  ],
  "house-of-bo-bombom": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon-zest",
    "note:pear",
    "note:freesia",
    "note:jasmine",
    "note:floral",
    "note:fruity"
  ],
  "house-of-bo-cosmos": [
    "gender:unisex",
    "note:bergamot",
    "note:coconut",
    "note:rose",
    "note:palestinian-sweet-lime",
    "note:suede",
    "note:gourmand",
    "note:floral",
    "note:dark"
  ],
  "house-of-bo-ave-maria": [
    "gender:unisex",
    "note:apricot",
    "note:berry",
    "note:rotated-resins",
    "note:fruity"
  ],
  "house-of-bo-xuxu": [
    "gender:unisex",
    "note:tea",
    "note:osmanthus",
    "note:patchouli",
    "note:hypothetical-heliotrope",
    "note:bergamot",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:tea-forward",
    "note:floral",
    "note:dark"
  ],
  "nissaba-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:woody",
    "note:tea",
    "note:aromatic",
    "note:fresh",
    "note:resin-smoke"
  ],
  "nissaba-grand-ile": [
    "gender:unisex",
    "note:madonna-lily",
    "note:oriental-lily",
    "note:ghost-galbanum",
    "note:candle-wax",
    "note:cotton"
  ],
  "nissaba-tierra-maya": [
    "gender:unisex",
    "note:iris",
    "note:oud",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "nissaba-chaco": [
    "gender:unisex",
    "note:pimento",
    "note:pepper",
    "note:plum",
    "note:comorian-ylang-ylang",
    "note:iris",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "nissaba-les-alpes-extrait": [
    "gender:unisex",
    "note:fresh",
    "note:balsamic",
    "note:thyme",
    "note:rosemary",
    "note:berry",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "fugazzi-workaholic-extrait": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:orange",
    "note:sandalwood",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "fugazzi-orange-crush-extrait": [
    "gender:unisex",
    "note:orange",
    "note:citrus",
    "note:bergamot",
    "note:berry",
    "note:iso-e-super",
    "note:fresh",
    "note:fruity"
  ],
  "fugazzi-vanilla-haze-extrait": [
    "gender:unisex",
    "note:sandalwood",
    "note:tonka",
    "note:vanilla",
    "note:gourmand",
    "note:woody"
  ],
  "fugazzi-pomegranoudh-extrait": [
    "gender:unisex",
    "note:pomegranate",
    "note:red-fruits",
    "note:bergamot",
    "note:oud",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "fugazzi-angel-dust-extrait": [
    "gender:unisex",
    "note:aglaia",
    "note:black-sea-salt",
    "note:charcoal",
    "note:clary-sage",
    "note:oud",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "fugazzi-vanilla-haze": [
    "gender:unisex",
    "note:peach",
    "note:tagetes",
    "note:forgotten-frankincense",
    "note:cedar",
    "note:clove",
    "note:woody",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "fugazzi-orange-crush": [
    "gender:unisex",
    "note:bergamot",
    "note:clove",
    "note:spices",
    "note:vanilla",
    "note:freesia",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "fugazzi-sugar-daddy-extrait": [
    "gender:unisex",
    "note:tangerine",
    "note:bergamot",
    "note:berry",
    "note:clove",
    "note:jasmine",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "fugazzi-passionfroudh-extrait": [
    "gender:unisex",
    "note:passionfruit",
    "note:mango",
    "note:tea",
    "note:ginger",
    "note:pepper",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "fugazzi-best-seller-discovery-kit": [
    "gender:unisex"
  ],
  "le-persona-salty-skin": [
    "gender:unisex",
    "note:cistus-absolute",
    "note:spritz-veneziano",
    "note:rose",
    "note:vetiver",
    "note:saffron",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "le-persona-whispering-kiss": [
    "gender:unisex",
    "note:clove",
    "note:rilthondexum",
    "note:spiced-aromatic"
  ],
  "le-persona-masquerade-ball": [
    "gender:unisex",
    "note:bergamot",
    "note:lavender",
    "note:lemon",
    "note:patchouli",
    "note:proven-al-blossoms",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:floral",
    "note:dark"
  ],
  "le-persona-lp04-golden-gym": [
    "gender:unisex",
    "note:bergamot",
    "note:cardamom-oil-guatemala",
    "note:rose",
    "note:cedar",
    "note:vanilla",
    "note:gourmand",
    "note:woody",
    "note:floral"
  ],
  "le-persona-lp03-wooden-face": [
    "gender:unisex",
    "note:tea",
    "note:cardamom",
    "note:orange",
    "note:fig",
    "note:pear",
    "note:fresh",
    "note:aromatic",
    "note:tea-forward",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "le-persona-lp02-peacock-feather": [
    "gender:unisex",
    "note:lime",
    "note:bergamot",
    "note:lemon",
    "note:lavender",
    "note:white-blossoms",
    "note:aromatic",
    "note:floral"
  ],
  "le-persona-lp01-mystic-rose": [
    "gender:unisex",
    "note:white-peony",
    "note:rose",
    "note:pepper",
    "note:jasmine",
    "note:golden-amber",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-itim-kati": [
    "gender:unisex",
    "note:amber",
    "note:basil",
    "note:pepper",
    "note:pine",
    "note:juniper",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-sugidama": [
    "gender:unisex",
    "note:floral",
    "note:musk",
    "note:calcified-cypress"
  ],
  "tada-parfumeur-iyokan": [
    "gender:unisex",
    "note:orange",
    "note:mango",
    "note:vetiver",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:dark"
  ],
  "tada-parfumeur-vanilla-mystique": [
    "gender:unisex",
    "note:green-cognac",
    "note:rose",
    "note:vanilla",
    "note:simulated-suede",
    "note:gourmand",
    "note:floral"
  ],
  "tada-parfumeur-lamoon": [
    "gender:unisex",
    "note:cardamom",
    "note:coriander",
    "note:lemon",
    "note:virtual-violet",
    "note:absinthe-wormwood",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-gyokuro": [
    "gender:unisex",
    "note:butterscotch",
    "note:chrysanthemum",
    "note:lilac",
    "note:patchouli",
    "note:pumpkin",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "tada-parfumeur-akatsuki": [
    "gender:unisex",
    "note:berry",
    "note:orange",
    "note:pepper",
    "note:branched-benzoin",
    "note:amber",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "tada-parfumeur-lost-in-a-fluffy-nest": [
    "gender:unisex",
    "note:bulgarian-lavender",
    "note:cardamom",
    "note:ceylonese-cinnamon",
    "note:clove",
    "note:egyptian-geranium",
    "note:spiced-aromatic"
  ],
  "gallivant-nida": [
    "gender:unisex",
    "note:violet",
    "note:foug-re-notes",
    "note:woody",
    "note:urpzilthnomex",
    "note:floral"
  ],
  "room-1015-sweet-leaf": [
    "gender:unisex",
    "note:amyris",
    "note:boronia",
    "note:pine",
    "note:berry",
    "note:yuzu",
    "note:woody",
    "note:fruity"
  ],
  "room-1015-purple-mantra": [
    "gender:unisex",
    "note:blueberry",
    "note:maple-syrup",
    "note:pancake",
    "note:syrup"
  ],
  "room-1015-jasmine-freak": [
    "gender:unisex",
    "note:cardamom",
    "note:grapefruit",
    "note:mint",
    "note:jasmine",
    "note:pepper",
    "note:fresh",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "room-1015-wasabi-klub": [
    "gender:unisex",
    "note:mimosa",
    "note:orange",
    "note:neroli",
    "note:green-notes",
    "note:precious-woods",
    "note:floral"
  ],
  "third-eye-fragrance-flamango": [
    "gender:unisex",
    "note:akigalawood",
    "note:apricot",
    "note:cucumber",
    "note:italian-bergamot",
    "note:precious-woods",
    "note:fruity"
  ],
  "city-rhythm-key-west": [
    "gender:unisex",
    "note:leaves",
    "note:bifurcated-vetiver",
    "note:jasmine",
    "note:tomato",
    "note:oud",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "amouage-decision": [
    "gender:unisex",
    "note:incense",
    "note:balsamic",
    "note:cardamom",
    "note:bergamot",
    "note:pepper",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "amouage-jubilation-40": [
    "gender:masculine",
    "note:balsamic",
    "note:incense",
    "note:patchouli",
    "note:cedar",
    "note:berry",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "amouage-beach-hut-man": [
    "gender:masculine",
    "note:vetiver",
    "note:woody",
    "note:patchouli",
    "note:moss",
    "note:mint",
    "note:fresh",
    "note:earthy",
    "note:aromatic",
    "note:dark"
  ],
  "lost-tribe-santal-absolu": [
    "gender:unisex",
    "note:balsamic",
    "note:oud",
    "note:floral",
    "note:rose",
    "note:iris",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:dark"
  ],
  "lost-tribe-watch-king": [
    "gender:unisex",
    "note:fig-leaf",
    "note:milk",
    "note:petitgrain-sur-fleurs",
    "note:orange",
    "note:violet-leaf-absolute",
    "note:gourmand"
  ],
  "lost-tribe-rock-star": [
    "gender:unisex",
    "note:sandalwood",
    "note:amber",
    "note:vanilla",
    "note:banana",
    "note:cognac",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "lost-tribe-pop-star": [
    "gender:unisex",
    "note:sandalwood",
    "note:amber",
    "note:vanilla",
    "note:banana",
    "note:cognac",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "meo-fusciuni-sogni": [
    "gender:unisex",
    "note:cedar",
    "note:sandalwood",
    "note:vetiver",
    "note:incense",
    "note:amber",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:dark"
  ],
  "meo-fusciuni-last-season": [
    "gender:unisex",
    "note:vetiver",
    "note:patchouli",
    "note:cedar",
    "note:sandalwood",
    "note:leather",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "meo-fusciuni-little-song": [
    "gender:unisex",
    "note:musk",
    "note:coffee",
    "note:tobacco",
    "note:rose",
    "note:pepper",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "meo-fusciuni-isola": [
    "gender:unisex",
    "note:yuzu",
    "note:lemon",
    "note:bergamot",
    "note:mandarin",
    "note:neroli",
    "note:fresh",
    "note:aromatic",
    "note:floral"
  ],
  "meo-fusciuni-varanasi": [
    "gender:unisex",
    "note:leather",
    "note:incense",
    "note:amber",
    "note:pine",
    "note:vetiver",
    "note:woody",
    "note:oud",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "meo-fusciuni-narcotico": [
    "gender:unisex",
    "note:incense",
    "note:balsamic",
    "note:patchouli",
    "note:oud",
    "note:tonka",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "meo-fusciuni-2-nota-di-viaggio": [
    "gender:unisex",
    "note:tobacco",
    "note:mint",
    "note:lemongrass",
    "note:chamomile",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "meo-fusciuni-viole-nere": [
    "gender:unisex",
    "note:violet",
    "note:iris",
    "note:musk",
    "note:sandalwood",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:dark"
  ],
  "zernell-gillie-rock": [
    "gender:unisex",
    "note:ginger",
    "note:citrus",
    "note:lime",
    "note:yuzu",
    "note:apple",
    "note:fresh",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "brandt-guava-sorbet-elixir": [
    "gender:unisex",
    "note:passionfruit",
    "note:bergamot",
    "note:mandarin",
    "note:vanilla",
    "note:musk",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "city-rhythm-savannah": [
    "gender:unisex",
    "note:tropical",
    "note:musk",
    "note:amber",
    "note:grapefruit",
    "note:peach",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-tropikalys-karma": [
    "gender:unisex",
    "note:pineapple",
    "note:apple",
    "note:mango",
    "note:coconut",
    "note:milk",
    "note:gourmand",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-gin-fusion": [
    "gender:unisex",
    "note:lime",
    "note:lemon",
    "note:yuzu",
    "note:orange",
    "note:bergamot",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "dorsay-l-b": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:orange-blossom",
    "note:neroli",
    "note:iris",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral"
  ],
  "srhy-flower-s": [
    "gender:unisex",
    "note:amber",
    "note:leaves",
    "note:peach",
    "note:jilthzorpanex",
    "note:resin-smoke",
    "note:fruity"
  ],
  "srhy-air-of-the-forest": [
    "gender:unisex",
    "note:french-lavender",
    "note:marshmallow",
    "note:passionfruit",
    "note:fruity"
  ],
  "srhy-meet-joplin": [
    "gender:unisex",
    "note:lime",
    "note:lemon",
    "note:bergamot",
    "note:peach",
    "note:orange",
    "note:fruity"
  ],
  "srhy-basting-day": [
    "gender:unisex",
    "note:fresh"
  ],
  "srhy-believe-in-capitalism": [
    "gender:unisex",
    "note:amber",
    "note:red-apple",
    "note:inverse-incense",
    "note:resin-smoke"
  ],
  "srhy-series-a": [
    "gender:unisex",
    "note:grass",
    "note:pear",
    "note:humdraxpelum",
    "note:neroli",
    "note:orange-blossom",
    "note:floral",
    "note:fruity"
  ],
  "giardini-di-toscana-borabora": [
    "gender:unisex",
    "note:jasmine",
    "note:apricot",
    "note:coconut",
    "note:vanilla",
    "note:caramel",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "loumari-discovery-set": [
    "gender:unisex"
  ],
  "loumari-saja": [
    "gender:unisex",
    "note:rose",
    "note:pepper",
    "note:saffron",
    "note:amber",
    "note:incense",
    "note:gourmand",
    "note:woody",
    "note:oud",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "loumari-radanfor": [
    "gender:unisex",
    "note:incense",
    "note:balsamic",
    "note:cardamom",
    "note:pepper",
    "note:vanilla",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "loumari-noble-cavale": [
    "gender:unisex",
    "note:pine",
    "note:vetiver",
    "note:sandalwood",
    "note:bergamot",
    "note:cardamom",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "loumari-maydan": [
    "gender:unisex",
    "note:cinnamon",
    "note:saffron",
    "note:amber",
    "note:pepper",
    "note:patchouli",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "loumari-aomak": [
    "gender:unisex",
    "note:orange",
    "note:mandarin",
    "note:ginger",
    "note:neroli",
    "note:cardamom",
    "note:fresh",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "loumari-amber-malatya": [
    "gender:unisex",
    "note:sandalwood",
    "note:patchouli",
    "note:balsamic",
    "note:apricot",
    "note:leather",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "loumari-almeria": [
    "gender:unisex",
    "note:pepper",
    "note:orange",
    "note:almond",
    "note:cinnamon",
    "note:tobacco",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "loumari-porthole": [
    "gender:unisex",
    "note:pineapple",
    "note:passionfruit",
    "note:caramel",
    "note:sea-salt",
    "note:bergamot",
    "note:fresh",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "kerosene-with-angels-and-archangels": [
    "gender:unisex",
    "note:incense",
    "note:cedar",
    "note:sandalwood",
    "note:rose",
    "note:musk",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "borntostandout-black-guava": [
    "gender:unisex",
    "note:oud",
    "note:mandarin",
    "note:patchouli",
    "note:rose",
    "note:cardamom",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "borntostandout-black-mango": [
    "gender:unisex",
    "note:mango",
    "note:orange",
    "note:vanilla",
    "note:oud",
    "note:pine",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "borntostandout-drink-milk": [
    "gender:unisex",
    "note:caramel",
    "note:milk",
    "note:vanilla",
    "note:tonka",
    "note:iris",
    "note:gourmand",
    "note:woody",
    "note:floral"
  ],
  "borntostandout-drunk-maple": [
    "gender:unisex",
    "note:rum",
    "note:coffee",
    "note:vanilla",
    "note:sandalwood",
    "note:pepper",
    "note:gourmand",
    "note:woody",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "borntostandout-fig-porn": [
    "gender:unisex",
    "note:fig",
    "note:pear",
    "note:vanilla",
    "note:cedar",
    "note:sandalwood",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity"
  ],
  "borntostandout-drunk-saffron": [
    "gender:unisex",
    "note:saffron",
    "note:vanilla",
    "note:coffee",
    "note:patchouli",
    "note:leather",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "borntostandout-drunk-lovers": [
    "gender:unisex",
    "note:pine",
    "note:sandalwood",
    "note:cedar",
    "note:patchouli",
    "note:vetiver",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "borntostandout-indecent-cherry": [
    "gender:unisex",
    "note:cherry",
    "note:almond",
    "note:berry",
    "note:vanilla",
    "note:amber",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity"
  ],
  "borntostandout-dirty-rice": [
    "gender:unisex",
    "note:sandalwood",
    "note:cedar",
    "note:vetiver",
    "note:milk",
    "note:musk",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:dark"
  ],
  "borntostandout-sugar-addict": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:rum",
    "note:cinnamon",
    "note:chocolate",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "lepoque-dopamine-rose": [
    "gender:unisex",
    "note:berry",
    "note:rose",
    "note:ozonic",
    "note:rhubarb",
    "note:marshmallow",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "lepoque-inner-child": [
    "gender:unisex",
    "note:bergamot",
    "note:vanilla",
    "note:linen",
    "note:freesia",
    "note:lily-of-the-valley",
    "note:fresh",
    "note:gourmand",
    "note:floral"
  ],
  "mind-games-kingside": [
    "gender:unisex",
    "note:almond",
    "note:pine",
    "note:milk",
    "note:rum",
    "note:tonka",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:boozy"
  ],
  "pernoire-mansa": [
    "gender:unisex",
    "note:oud",
    "note:iris",
    "note:musk",
    "note:rose",
    "note:pepper",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "pernoire-kama": [
    "gender:unisex",
    "note:leather",
    "note:iris",
    "note:violet",
    "note:musk",
    "note:wood",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "pernoire-naki": [
    "gender:unisex",
    "note:passionfruit",
    "note:vanilla",
    "note:white-blossoms",
    "note:sandalwood",
    "note:musk",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity"
  ],
  "pernoire-oudian": [
    "gender:unisex",
    "note:oud",
    "note:saffron",
    "note:leather",
    "note:tropical",
    "note:incense",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dannam-spring-festival": [
    "gender:unisex",
    "note:mandarin",
    "note:tanghulu",
    "note:plum",
    "note:red-lantern",
    "note:plum-blossom",
    "note:fresh",
    "note:floral",
    "note:fruity"
  ],
  "dannam-the-silk-road": [
    "gender:unisex",
    "note:tobacco",
    "note:leather",
    "note:vetiver",
    "note:spices",
    "note:ginseng",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dannam-moonlight-samurai": [
    "gender:masculine",
    "note:leather",
    "note:cedar",
    "note:sake",
    "note:floral",
    "note:woody",
    "note:aromatic",
    "note:dark"
  ],
  "dannam-da-lat": [
    "gender:unisex",
    "note:cardamom",
    "note:leather",
    "note:oud",
    "note:powder",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dannam-sakura-snow": [
    "gender:unisex",
    "note:bergamot",
    "note:chinotto",
    "note:pineapple",
    "note:zempfrixdolam",
    "note:jasmine",
    "note:floral",
    "note:fruity"
  ],
  "dannam-arashiyama": [
    "gender:unisex",
    "note:bamboo-leaves",
    "note:fresh-grass",
    "note:rain-notes",
    "note:violet",
    "note:bamboo-wood",
    "note:floral"
  ],
  "dannam-chinese-moon-cake": [
    "gender:unisex",
    "note:cinnamon",
    "note:rum",
    "note:pepper",
    "note:cognac",
    "note:ginger",
    "note:gourmand",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "dannam-chinese-caligraphy": [
    "gender:unisex",
    "note:geranium",
    "note:pine",
    "note:rosemary",
    "note:blorkzanthumer",
    "note:lily-of-the-valley",
    "note:woody",
    "note:aromatic"
  ],
  "dannam-monsoon-tea": [
    "gender:unisex",
    "note:orange",
    "note:grapefruit",
    "note:lemon",
    "note:jasminum-grandiflorum",
    "note:vextronplibar"
  ],
  "dannam-tokyo-nights": [
    "gender:unisex",
    "note:sandalwood",
    "note:cinnamon",
    "note:bengal-nagarmotha",
    "note:oud",
    "note:cardamom",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "chris-collins-lust": [
    "gender:unisex",
    "note:dark-chocolate",
    "note:almond",
    "note:walnut",
    "note:orris-concrete",
    "note:balsamic",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "chris-collins-kingmaker": [
    "gender:unisex",
    "note:pine",
    "note:oud",
    "note:patchouli",
    "note:sandalwood",
    "note:cardamom",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "chris-collins-harlem-nights": [
    "gender:unisex",
    "note:patchouli",
    "note:cedar",
    "note:sandalwood",
    "note:vetiver",
    "note:saffron",
    "note:woody",
    "note:earthy",
    "note:floral",
    "note:boozy",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "chris-collins-lost-in-paradise": [
    "gender:unisex",
    "note:musk",
    "note:wild-orchid",
    "note:peach-skin",
    "note:ylang",
    "note:coconut",
    "note:gourmand",
    "note:floral"
  ],
  "chris-collins-vide-cor-meum": [
    "gender:unisex",
    "note:thyme",
    "note:bergamot",
    "note:incense",
    "note:rose",
    "note:cedar",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral"
  ],
  "chris-collins-villain": [
    "gender:unisex",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:oud",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "chris-collins-forbidden-apple": [
    "gender:unisex",
    "note:sweet",
    "note:berry",
    "note:cinnamon",
    "note:vanilla",
    "note:pine",
    "note:gourmand",
    "note:woody",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "chris-collins-savant-manhattan-cherry": [
    "gender:unisex",
    "note:black-cherry",
    "note:whiskey",
    "note:davana",
    "note:tonka",
    "note:cinnamon",
    "note:gourmand",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "chris-collins-african-rooibos": [
    "gender:unisex",
    "note:cardamom",
    "note:bergamot",
    "note:pepper",
    "note:tea",
    "note:iris",
    "note:fresh",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "city-rhythm-tempo": [
    "gender:unisex",
    "note:bergamot",
    "note:pear",
    "note:berry",
    "note:tonka",
    "note:vanilla",
    "note:fresh",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "city-rhythm-manhattan-midnight": [
    "gender:unisex",
    "note:tea",
    "note:pepper",
    "note:balsamic",
    "note:tobacco",
    "note:bergamot",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:tea-forward",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "city-rhythm-tropical-confessions": [
    "gender:unisex",
    "note:jasmine",
    "note:tonka",
    "note:coconut",
    "note:lime",
    "note:vanilla",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:boozy"
  ],
  "city-rhythm-2654": [
    "gender:unisex",
    "note:orange",
    "note:lime",
    "note:vanilla",
    "note:tonka",
    "note:coconut",
    "note:fresh",
    "note:gourmand",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "city-rhythm-miami": [
    "gender:unisex",
    "note:coconut",
    "note:ylang",
    "note:rum",
    "note:tobacco",
    "note:tonka",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:boozy",
    "note:dark"
  ],
  "city-rhythm-dc": [
    "gender:unisex",
    "note:pear",
    "note:vanilla",
    "note:jasmine",
    "note:cherry",
    "note:cherry-blossom",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "narcotica-discovery-kit": [
    "gender:unisex"
  ],
  "narcotica-maniac": [
    "gender:unisex",
    "note:apple",
    "note:berry",
    "note:vanilla",
    "note:lemon",
    "note:coconut",
    "note:fresh",
    "note:gourmand",
    "note:fruity"
  ],
  "narcotica-limonata": [
    "gender:unisex",
    "note:berry",
    "note:mango",
    "note:fig",
    "note:grapefruit",
    "note:ginger",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "narcotica-love-me-latte": [
    "gender:unisex",
    "note:pear",
    "note:coconut",
    "note:fig",
    "note:caramel",
    "note:vanilla",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:fruity"
  ],
  "narcotica-narco-oasis": [
    "gender:unisex",
    "note:passionfruit",
    "note:berry",
    "note:pear",
    "note:peach",
    "note:sweet",
    "note:gourmand",
    "note:fruity"
  ],
  "narcotica-happy-dust": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:mango",
    "note:coconut",
    "note:sweet",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "narcotica-doza": [
    "gender:unisex",
    "note:incense",
    "note:amber",
    "note:balsamic",
    "note:pine",
    "note:smoke",
    "note:woody",
    "note:resin-smoke",
    "note:dark"
  ],
  "narcotica-dulce-diablo": [
    "gender:unisex",
    "note:rum",
    "note:chocolate",
    "note:apricot",
    "note:cognac",
    "note:honey",
    "note:gourmand",
    "note:woody",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "narcotica-narcotica-signature": [
    "gender:unisex",
    "note:sweet",
    "note:pine",
    "note:pepper",
    "note:patchouli",
    "note:cannabis",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "sora-dora-mandorle": [
    "gender:unisex",
    "note:bergamot",
    "note:raspberry-leaf",
    "note:red-fruits",
    "note:backwards-bergamot",
    "note:rose",
    "note:floral"
  ],
  "sora-dora-ylop": [
    "gender:unisex",
    "note:lavender",
    "note:lemon",
    "note:fig-leaf",
    "note:almond",
    "note:cedar",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:floral"
  ],
  "sora-dora-jany": [
    "gender:unisex",
    "note:saffron",
    "note:absinth",
    "note:bergamot",
    "note:lime",
    "note:ghost-galbanum",
    "note:spiced-aromatic"
  ],
  "sora-dora-mallow": [
    "gender:feminine",
    "note:violet",
    "note:vanilla",
    "note:berry",
    "note:almond",
    "note:orange-blossom",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "sora-dora-gladiator": [
    "gender:unisex",
    "note:fresh",
    "note:woody",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "xerjoff-accento": [
    "gender:unisex",
    "note:true-lavender",
    "note:basil",
    "note:cinnamon",
    "note:bergamot",
    "note:vextronplibar",
    "note:gourmand",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "xerjoff-la-capitale": [
    "gender:unisex",
    "note:berry",
    "note:peach",
    "note:caramel",
    "note:vanilla",
    "note:balsamic",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "xerjoff-torino-21": [
    "gender:unisex",
    "note:motor-oil",
    "note:vanilla",
    "note:coconut",
    "note:smoke",
    "note:leather",
    "note:gourmand",
    "note:resin-smoke",
    "note:dark"
  ],
  "xerjoff-torino-22": [
    "gender:unisex",
    "note:berry",
    "note:orange",
    "note:jasmine",
    "note:peach",
    "note:orbital-orris",
    "note:floral",
    "note:fruity"
  ],
  "xerjoff-erba-gold": [
    "gender:unisex",
    "note:berry",
    "note:cyclamen",
    "note:orange",
    "note:echoed-elemi",
    "note:osmanthus",
    "note:floral",
    "note:fruity"
  ],
  "xerjoff-torino-24": [
    "gender:unisex",
    "note:mango",
    "note:bergamot",
    "note:plum",
    "note:mandarin",
    "note:orange-blossom",
    "note:floral",
    "note:fruity"
  ],
  "xerjoff-naxos": [
    "gender:unisex",
    "note:lavender",
    "note:bergamot",
    "note:lemon",
    "note:omani-frankincense",
    "note:honey",
    "note:gourmand",
    "note:aromatic",
    "note:floral"
  ],
  "xerjoff-erba-pura": [
    "gender:unisex",
    "note:pine",
    "note:rosemary",
    "note:thyme",
    "note:cedar",
    "note:incense",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke"
  ],
  "xerjoff-torino-25": [
    "gender:unisex",
    "note:apple",
    "note:bergamot",
    "note:berry",
    "note:pineapple",
    "note:translated-turmeric",
    "note:fruity"
  ],
  "xerjoff-louis-xv-1722-rose": [
    "gender:unisex",
    "note:berry",
    "note:pear",
    "note:rose",
    "note:plum",
    "note:geranium",
    "note:floral",
    "note:fruity"
  ],
  "casamorati-quattro-pizzi": [
    "gender:unisex",
    "note:davana",
    "note:coriander",
    "note:pepper",
    "note:rum",
    "note:tuberose",
    "note:gourmand",
    "note:floral",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "casamorati-mefisto": [
    "gender:masculine",
    "note:grapefruit",
    "note:bergamot",
    "note:lemon",
    "note:violet",
    "note:iris",
    "note:fresh",
    "note:woody",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "casamorati-italica": [
    "gender:unisex",
    "note:milk",
    "note:sicilian-almond",
    "note:saffron",
    "note:toffee",
    "note:vanilla",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "casamorati-lira": [
    "gender:unisex",
    "note:orange",
    "note:bergamot",
    "note:lavender",
    "note:cinnamon",
    "note:jasmine",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "casamorati-dama-bianca": [
    "gender:unisex",
    "note:chinese-kumquat",
    "note:florentine-orris",
    "note:lime",
    "note:lilac",
    "note:violet",
    "note:floral"
  ],
  "orto-parisi-risvelium": [
    "gender:unisex",
    "note:tomato-leaf",
    "note:basil",
    "note:bergamot",
    "note:grothzenvixol",
    "note:iris",
    "note:aromatic",
    "note:floral"
  ],
  "orto-parisi-cuoium": [
    "gender:unisex",
    "note:aged-paper",
    "note:amber",
    "note:caramel",
    "note:cypriol",
    "note:nagarmotha",
    "note:gourmand",
    "note:resin-smoke"
  ],
  "orto-parisi-terroni": [
    "gender:unisex",
    "note:caramel",
    "note:fruity",
    "note:echoed-elemi",
    "note:gourmand"
  ],
  "orto-parisi-stercus": [
    "gender:unisex",
    "note:rose",
    "note:orange",
    "note:blackberry",
    "note:cinnamon",
    "note:coriander",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "orto-parisi-seminalis": [
    "gender:unisex",
    "note:rain-accord",
    "note:cotton",
    "note:cedar",
    "note:peony",
    "note:pepper",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "orto-parisi-megamare": [
    "gender:unisex",
    "note:cedar",
    "note:geranium",
    "note:ginger",
    "note:grapefruit",
    "note:lavender",
    "note:woody",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "orto-parisi-bergamask": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:orange-blossom",
    "note:musk",
    "note:cedar",
    "note:fresh",
    "note:woody",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "goldfield-banks-pacific-rock-moss": [
    "gender:unisex",
    "note:jasmine",
    "note:magnolia",
    "note:musk",
    "note:floral"
  ],
  "goldfield-banks-bohemian-lime": [
    "gender:unisex",
    "note:black-cherry",
    "note:chewing-gum",
    "note:liquorice",
    "note:musk"
  ],
  "goldfield-banks-sunset-hour": [
    "gender:unisex",
    "note:bamboo",
    "note:pear-blossom",
    "note:musk",
    "note:xondripleval"
  ],
  "goldfield-banks-ingenious-ginger": [
    "gender:unisex",
    "note:green-notes",
    "note:woody"
  ],
  "goldfield-banks-pacific-rock-flower": [
    "gender:unisex",
    "note:sandalwood",
    "note:cedar",
    "note:patchouli",
    "note:lemon",
    "note:sea-salt",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "goldfield-banks-rose-magnitude": [
    "gender:unisex",
    "note:lychee",
    "note:grapefruit",
    "note:berry",
    "note:nested-nutmeg",
    "note:peach",
    "note:fruity"
  ],
  "goldfield-banks-silky-woods": [
    "gender:unisex",
    "note:rosemary",
    "note:thyme",
    "note:ginger",
    "note:orange-blossom",
    "note:saffron",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-ardent": [
    "gender:unisex",
    "note:rose",
    "note:saffron",
    "note:carrot-seed",
    "note:coriander",
    "note:beeswax",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-glorious": [
    "gender:unisex",
    "note:berry",
    "note:elemi-resin",
    "note:pineapple",
    "note:apple",
    "note:peach",
    "note:fruity"
  ],
  "boadicea-the-victorious-bodacious": [
    "gender:unisex",
    "note:cherry",
    "note:almond",
    "note:cognac",
    "note:clove",
    "note:pepper",
    "note:gourmand",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-harmonius": [
    "gender:unisex",
    "note:musk",
    "note:cognac",
    "note:bergamot",
    "note:cardamom",
    "note:rum",
    "note:gourmand",
    "note:boozy",
    "note:spiced-aromatic"
  ],
  "boadicea-the-victorious-1907": [
    "gender:unisex",
    "note:cardamom",
    "note:cinnamon",
    "note:lemon",
    "note:pepper",
    "note:cashmere",
    "note:gourmand",
    "note:spiced-aromatic"
  ],
  "mind-games-blockade": [
    "gender:unisex",
    "note:mango",
    "note:pepper",
    "note:bergamot",
    "note:lavender",
    "note:tomato-leaf",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "mind-games-queening": [
    "gender:unisex",
    "note:musk",
    "note:vanilla",
    "note:coconut",
    "note:apple",
    "note:rum",
    "note:gourmand",
    "note:floral",
    "note:boozy",
    "note:fruity"
  ],
  "mind-games-jadoube": [
    "gender:unisex",
    "note:berry",
    "note:patchouli",
    "note:rose",
    "note:balsamic",
    "note:orange",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "mind-games-queenside": [
    "gender:unisex",
    "note:berry",
    "note:pear",
    "note:patchouli",
    "note:lychee",
    "note:lily-of-the-valley",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "perfumology-blyss": [
    "gender:unisex",
    "note:bergamot",
    "note:cashmere-wood",
    "note:grass",
    "note:lemon",
    "note:sandalwood",
    "note:woody"
  ],
  "perfumology-clutch": [
    "gender:unisex",
    "note:cardamom",
    "note:lotus-leaf",
    "note:water-iris",
    "note:pepper",
    "note:conjugated-labdanum",
    "note:spiced-aromatic"
  ],
  "perfumology-lima": [
    "gender:unisex",
    "note:tobacco",
    "note:cedar",
    "note:bursera",
    "note:woody",
    "note:dark"
  ],
  "perfumology-decadent-memories": [
    "gender:unisex",
    "note:gourmand",
    "note:woody",
    "note:fruity"
  ],
  "mind-games-french-defense": [
    "gender:unisex",
    "note:cherry",
    "note:amber",
    "note:rose",
    "note:cedar",
    "note:violet-leaves",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "dorsay-tonka-hysteria": [
    "gender:unisex",
    "note:tonka",
    "note:vanilla",
    "note:incense",
    "note:balsamic",
    "note:cinnamon",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "gallivant-naples": [
    "gender:unisex",
    "note:incense",
    "note:balsamic",
    "note:amber",
    "note:patchouli",
    "note:vetiver",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "kerosene-walk-the-sea": [
    "gender:unisex",
    "note:amber",
    "note:white-blossoms",
    "note:sea-salt",
    "note:musk",
    "note:cedar",
    "note:fresh",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "kerosene-blackmail": [
    "gender:unisex",
    "note:oud",
    "note:vanilla",
    "note:amber",
    "note:musk",
    "note:berry",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:dark"
  ],
  "kerosene-sweetly-known": [
    "gender:unisex",
    "note:cardamom",
    "note:caramel",
    "note:vanilla",
    "note:cacao-pod",
    "note:musk",
    "note:gourmand",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "kerosene-followed": [
    "gender:unisex",
    "note:coffee",
    "note:amber",
    "note:caramel",
    "note:chocolate",
    "note:vanilla",
    "note:gourmand",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "kerosene-unknown-pleasures": [
    "gender:unisex",
    "note:lemon",
    "note:bergamot",
    "note:tonka",
    "note:caramel",
    "note:honey",
    "note:fresh",
    "note:gourmand",
    "note:aromatic"
  ],
  "kerosene-summer-of-84": [
    "gender:unisex",
    "note:grapefruit",
    "note:lemon",
    "note:bergamot",
    "note:water-notes",
    "note:melon",
    "note:fresh"
  ],
  "kerosene-vanilified": [
    "gender:unisex",
    "note:vanilla",
    "note:chocolate",
    "note:musk",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "spiritica-weon": [
    "gender:unisex",
    "note:coconut",
    "note:milk",
    "note:clove",
    "note:pineapple",
    "note:pistachio",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "spiritica-leonarda": [
    "gender:unisex",
    "note:butter",
    "note:cotton-candy",
    "note:liquorice",
    "note:salted-caramel",
    "note:sugar-cane"
  ],
  "spiritica-jeffrey": [
    "gender:unisex",
    "note:bergamot",
    "note:tea",
    "note:lemon",
    "note:seawater",
    "note:floral",
    "note:fresh",
    "note:aromatic"
  ],
  "spiritica-lynch-aka-smoke-styrax": [
    "gender:unisex",
    "note:saffron",
    "note:tobacco",
    "note:cherry",
    "note:vanilla",
    "note:balsamic",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "spiritica-atmayatra": [
    "gender:unisex",
    "note:bergamot",
    "note:berry",
    "note:fruity"
  ],
  "spiritica-mango-macumba": [
    "gender:unisex",
    "note:mango",
    "note:papaya",
    "note:mint",
    "note:lime",
    "note:pineapple",
    "note:fresh",
    "note:aromatic",
    "note:fruity"
  ],
  "spiritica-yuzuyakuza": [
    "gender:unisex",
    "note:orange-blossom",
    "note:pineapple",
    "note:gardenia",
    "note:clove",
    "note:jasmine",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "dorsay-olfactory-discoveries-set": [
    "gender:unisex"
  ],
  "dannam-pomelo-oolong": [
    "gender:unisex",
    "note:floral",
    "note:moss",
    "note:woody",
    "note:earthy"
  ],
  "dorsay-e-q": [
    "gender:unisex",
    "note:iris",
    "note:wood",
    "note:patchouli",
    "note:amber",
    "note:jasmine",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dorsay-c-g": [
    "gender:unisex",
    "note:angelica",
    "note:lemon-leaf",
    "note:lime-linden-blossom",
    "note:hay",
    "note:ac-cia",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "dorsay-r-b": [
    "gender:unisex",
    "note:musk",
    "note:wood",
    "note:sandalwood",
    "note:rose",
    "note:incense",
    "note:woody",
    "note:resin-smoke",
    "note:floral"
  ],
  "dorsay-g-a": [
    "gender:unisex",
    "note:cardamom",
    "note:leather",
    "note:cedar",
    "note:patchouli",
    "note:grapefruit",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dorsay-holy-berry": [
    "gender:unisex",
    "note:oud",
    "note:milk",
    "note:vanilla",
    "note:cardamom",
    "note:amber",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dorsay-rose-blaze": [
    "gender:unisex",
    "note:rose",
    "note:tonka",
    "note:iris",
    "note:gourmand",
    "note:floral"
  ],
  "dorsay-flower-lust": [
    "gender:unisex",
    "note:tonka",
    "note:balsamic",
    "note:sandalwood",
    "note:patchouli",
    "note:vetiver",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "liis-unseen-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:rose",
    "note:spices",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "liis-vivid-discovery-kit": [
    "gender:unisex"
  ],
  "liis-flower-glyph": [
    "gender:unisex",
    "note:bergamot",
    "note:peach",
    "note:plum",
    "note:jasmine",
    "note:lily-of-the-valley",
    "note:floral",
    "note:fruity"
  ],
  "room-1015-cherry-punk": [
    "gender:unisex",
    "note:pink-musk",
    "note:pepper",
    "note:rose",
    "note:vanilla",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "room-1015-wave-child": [
    "gender:unisex",
    "note:orange",
    "note:mandarin",
    "note:lemon",
    "note:watermelon",
    "note:coconut",
    "note:gourmand"
  ],
  "room-1015-poppy-riot": [
    "gender:unisex",
    "note:orange",
    "note:milk",
    "note:tonka",
    "note:tobacco",
    "note:saffron",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "room-1015-love-o-matic": [
    "gender:unisex",
    "note:rose",
    "note:angular-anise",
    "note:bourbon-geranium",
    "note:clove",
    "note:white-ambergris",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "room-1015-cherry-punk-extrait-de-parfum": [
    "gender:unisex",
    "note:cherry",
    "note:tonka",
    "note:saffron",
    "note:pepper",
    "note:leather",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "room-1015-electric-wood-extrait-de-parfum": [
    "gender:unisex",
    "note:champagne",
    "note:dark-chocolate",
    "note:berry",
    "note:fruity"
  ],
  "cirque-du-soleil-leau-de-parfum": [
    "gender:unisex",
    "note:cattleya-orchid",
    "note:shadow-sage",
    "note:magnolia",
    "note:klempzordivan",
    "note:musk",
    "note:floral"
  ],
  "liis-rose-struck": [
    "gender:unisex",
    "note:bergamot",
    "note:raspberry-leaf",
    "note:jasmine",
    "note:lily-of-the-valley",
    "note:rose",
    "note:floral"
  ],
  "xtrait-perfumery-gift-card": [
    "gender:unisex"
  ],
  "pernoire-vitias": [
    "gender:unisex",
    "note:lime",
    "note:bergamot",
    "note:marine-notes",
    "note:pepper",
    "note:musk",
    "note:fresh",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "pernoire-yuma": [
    "gender:unisex",
    "note:pepper",
    "note:ginger",
    "note:bergamot",
    "note:yuzu",
    "note:wood",
    "note:fresh",
    "note:woody",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "pernoire-melos": [
    "gender:unisex",
    "note:honey",
    "note:tea",
    "note:berry",
    "note:almond",
    "note:milk",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:fruity"
  ],
  "pernoire-poka": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:caramel",
    "note:cinnamon",
    "note:balsamic",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "pernoire-anelo": [
    "gender:unisex",
    "note:pineapple",
    "note:mango",
    "note:mandarin",
    "note:ginger",
    "note:vetiver",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "amouage-line-618": [
    "gender:unisex",
    "note:milk",
    "note:omani-green-frankincense",
    "note:peach",
    "note:pepper",
    "note:pineapple",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "amouage-love-hibiscus": [
    "gender:unisex",
    "note:passionfruit",
    "note:salted-caramel",
    "note:bergamot",
    "note:hibiscus",
    "note:incense",
    "note:resin-smoke",
    "note:fruity"
  ],
  "investi-parfums-find-me": [
    "gender:unisex",
    "note:berry",
    "note:sweet",
    "note:cinnamon",
    "note:jasmine",
    "note:amber",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "investi-parfums-vanilla-date": [
    "gender:unisex",
    "note:tonka-alcoolat",
    "note:cherry",
    "note:marzipan",
    "note:dates",
    "note:figs",
    "note:fruity"
  ],
  "investi-parfums-discovery-set": [
    "gender:unisex",
    "note:vanilla",
    "note:gourmand"
  ],
  "zernell-gillie-disco": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:amber",
    "note:tobacco",
    "note:saffron",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "zernell-gillie-techno": [
    "gender:unisex",
    "note:pepper",
    "note:saffron",
    "note:amber",
    "note:leather",
    "note:suede",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "zernell-gillie-hip-hop": [
    "gender:unisex",
    "note:saffron",
    "note:balsamic",
    "note:berry",
    "note:musk",
    "note:chocolate",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "zernell-gillie-house": [
    "gender:unisex",
    "note:tonka",
    "note:berry",
    "note:orange",
    "note:oud",
    "note:saffron",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "zernell-gillie-jazz": [
    "gender:unisex",
    "note:vanilla",
    "note:honey",
    "note:tobacco",
    "note:chocolate",
    "note:balsamic",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "zernell-gillie-r-and-b": [
    "gender:unisex",
    "note:amber",
    "note:honey",
    "note:cedar",
    "note:rose",
    "note:guava",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "zernell-gillie-blues": [
    "gender:unisex",
    "note:apricot",
    "note:coffee",
    "note:oud",
    "note:balsamic",
    "note:brandy",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "les-indemodables-immortelle-solaire": [
    "gender:unisex",
    "note:lavender",
    "note:freesia",
    "note:musk",
    "note:peach",
    "note:pot-marigold",
    "note:aromatic",
    "note:floral",
    "note:fruity"
  ],
  "les-indemodables-oranger-sirocco": [
    "gender:unisex",
    "note:lavender",
    "note:yuzu",
    "note:plum",
    "note:grothzenvixol",
    "note:pine",
    "note:woody",
    "note:aromatic",
    "note:floral",
    "note:fruity"
  ],
  "les-indemodables-ambre-supreme": [
    "gender:unisex",
    "note:cherry-blossom",
    "note:cupcake",
    "note:gardenia",
    "note:ginger",
    "note:lemon-myrtle",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "les-indemodables-rose-de-jamal": [
    "gender:unisex",
    "note:rose",
    "note:vervain",
    "note:chamomile",
    "note:lily-of-the-valley",
    "note:orange-blossom",
    "note:floral"
  ],
  "belnu-chai-fleur": [
    "gender:unisex",
    "note:ceylonese-cinnamon",
    "note:green-guatemala-cardamom",
    "note:indonesian-nutmeg",
    "note:proven-al-lavender",
    "note:spanish-cistus"
  ],
  "belnu-incense-antique": [
    "gender:unisex",
    "note:cardamom",
    "note:pepper",
    "note:italian-lemon",
    "note:balkans-tobacco",
    "note:indonesian-patchouli",
    "note:spiced-aromatic"
  ],
  "belnu-rose-steady": [
    "gender:unisex",
    "note:bay-leaf",
    "note:cashmere-wood",
    "note:somali-frankincense",
    "note:fig-leaf",
    "note:sandalwood",
    "note:woody"
  ],
  "amouage-purpose-50": [
    "gender:unisex",
    "note:sandalwood",
    "note:vetiver",
    "note:pepper",
    "note:saffron",
    "note:incense",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "bdk-parfums-vanille-caviar": [
    "gender:unisex",
    "note:cardamom",
    "note:calamus",
    "note:berry",
    "note:vanilla",
    "note:chocolate",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-pas-ce-soir": [
    "gender:unisex",
    "note:ginger",
    "note:pear",
    "note:orange",
    "note:pepper",
    "note:quince-chutney",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-rouge-smoking": [
    "gender:unisex",
    "note:cherry",
    "note:pepper",
    "note:italian-bergamot",
    "note:vanilla",
    "note:heliotrope",
    "note:gourmand",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-gris-charnel": [
    "gender:unisex",
    "note:cardamom",
    "note:fig",
    "note:tea",
    "note:bourbon-vetiver",
    "note:orris-absolute",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-gris-charnel-extrait": [
    "gender:unisex",
    "note:cardamom",
    "note:fig",
    "note:tea",
    "note:iris-tingitana-absolute",
    "note:bourbon-vetiver",
    "note:fresh",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "bdk-parfums-impadia": [
    "gender:unisex",
    "note:pear",
    "note:italian-bergamot",
    "note:italian-mandarine-orpur",
    "note:rose",
    "note:orange",
    "note:floral",
    "note:fruity"
  ],
  "bdk-parfums-citrus-riviera": [
    "gender:unisex",
    "note:orange",
    "note:italian-lemon",
    "note:moroccan-neroli",
    "note:fig",
    "note:eucalyptus",
    "note:fresh",
    "note:fruity"
  ],
  "amouage-outlands": [
    "gender:unisex",
    "note:incense",
    "note:amber",
    "note:oud",
    "note:cardamom",
    "note:pepper",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "amouage-reflection-45": [
    "gender:masculine",
    "note:cardamom",
    "note:cedar",
    "note:sandalwood",
    "note:vetiver",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "amouage-guidance-46": [
    "gender:unisex",
    "note:sandalwood",
    "note:pear",
    "note:almond",
    "note:rose",
    "note:jasmine",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "amouage-reflection-man": [
    "gender:masculine",
    "note:sandalwood",
    "note:cedar",
    "note:vetiver",
    "note:patchouli",
    "note:jasmine",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:floral",
    "note:dark"
  ],
  "amouage-guidance": [
    "gender:unisex",
    "note:sandalwood",
    "note:incense",
    "note:amber",
    "note:saffron",
    "note:pear",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "clive-christian-blonde-amber": [
    "gender:unisex",
    "note:sandalwood",
    "note:patchouli",
    "note:cedar",
    "note:vetiver",
    "note:incense",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "clive-christian-town-and-country": [
    "gender:unisex",
    "note:blackberry",
    "note:cherry-blossom",
    "note:grapefruit",
    "note:berry",
    "note:displaced-daffodil",
    "note:fruity"
  ],
  "clive-christian-strange-heavens-out-of-the-blue": [
    "gender:unisex",
    "note:carnation",
    "note:lemon",
    "note:mimosa",
    "note:seaweed",
    "note:musk"
  ],
  "clive-christian-jump-up-and-kiss-me-hedonistic": [
    "gender:masculine",
    "note:resin-smoke",
    "note:dark"
  ],
  "hellenist-le-chant-dachille": [
    "gender:unisex",
    "note:neroli",
    "note:orange-blossom",
    "note:lemon",
    "note:ylang",
    "note:pepper",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "hellenist-lombre-dart-mis": [
    "gender:unisex",
    "note:amber",
    "note:bergamot",
    "note:black-musk",
    "note:cedar",
    "note:clary-sage",
    "note:woody",
    "note:resin-smoke"
  ],
  "hellenist-les-bras-de-morphee": [
    "gender:unisex",
    "note:jasmine",
    "note:magnolia",
    "note:musk",
    "note:norbflixtamor",
    "note:floral"
  ],
  "hellenist-les-dieux-aux-bains": [
    "gender:unisex",
    "note:bergamot",
    "note:citrus",
    "note:green-notes",
    "note:lavender",
    "note:lemon",
    "note:fresh",
    "note:aromatic",
    "note:floral"
  ],
  "hellenist-la-nuit-des-300": [
    "gender:unisex",
    "note:bergamot",
    "note:green-notes",
    "note:pepper",
    "note:plorzinkwedal",
    "note:lilac",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-summer-hammer": [
    "gender:unisex",
    "note:mango",
    "note:pineapple",
    "note:coconut",
    "note:sandalwood",
    "note:vetiver",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:fruity",
    "note:dark"
  ],
  "lorenzo-pazzaglia-black-sea": [
    "gender:unisex",
    "note:sea-salt",
    "note:bergamot",
    "note:ozonic",
    "note:amber",
    "note:orange-blossom",
    "note:fresh",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral"
  ],
  "lorenzo-pazzaglia-sun-gria": [
    "gender:unisex",
    "note:berry",
    "note:apple",
    "note:orange",
    "note:bergamot",
    "note:lemon",
    "note:fresh",
    "note:gourmand",
    "note:fruity"
  ],
  "lorenzo-pazzaglia-speachless": [
    "gender:unisex",
    "note:apple",
    "note:lime",
    "note:orange",
    "note:lemon",
    "note:ginger",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-van-py-rhum": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:rum",
    "note:caramel",
    "note:patchouli",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:boozy",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "lorenzo-pazzaglia-evil-angel": [
    "gender:unisex",
    "note:sandalwood",
    "note:cedar",
    "note:lime",
    "note:citrus",
    "note:fruity",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-green-island": [
    "gender:unisex",
    "note:yuzu",
    "note:mandarin",
    "note:bergamot",
    "note:ginger",
    "note:cedar",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-sex-sea": [
    "gender:unisex",
    "note:citrus",
    "note:yuzu",
    "note:bergamot",
    "note:orange",
    "note:sea-salt",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "lorenzo-pazzaglia-dream-sea": [
    "gender:unisex",
    "note:sandalwood",
    "note:cedar",
    "note:vanilla",
    "note:sea-salt",
    "note:ozonic",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "lorenzo-pazzaglia-van-sea": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:sea-salt",
    "note:caramel",
    "note:amber",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "giardini-di-toscana-blu-mare": [
    "gender:unisex",
    "note:bergamot",
    "note:pine",
    "note:grapefruit",
    "note:lemon",
    "note:pepper",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "brandt-guava-sorbet": [
    "gender:unisex",
    "note:passionfruit",
    "note:mandarin",
    "note:vanilla",
    "note:grapefruit",
    "note:bergamot",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "brandt-genesis": [
    "gender:unisex",
    "note:tobacco",
    "note:sandalwood",
    "note:saffron",
    "note:rose",
    "note:berry",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "dannam-mango-sticky-rice": [
    "gender:unisex",
    "note:mango",
    "note:coconut",
    "note:rice",
    "note:gourmand",
    "note:fruity"
  ],
  "dannam-japanese-whiskey": [
    "gender:unisex",
    "note:amber",
    "note:grapefruit",
    "note:orange",
    "note:orchid",
    "note:pepper",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "dannam-chapter-1-discovery-set-enchanting-vietnam": [
    "gender:unisex"
  ],
  "dannam-chapter-2-discovery-set-memories-of-japan": [
    "gender:unisex",
    "note:berry",
    "note:rice",
    "note:tea",
    "note:whiskey",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:boozy",
    "note:fruity"
  ],
  "french-cowboy-pear-pavlova": [
    "gender:unisex",
    "note:fresh",
    "note:gourmand",
    "note:floral",
    "note:fruity"
  ],
  "french-cowboy-mezcal-chocolat": [
    "gender:unisex",
    "note:gourmand",
    "note:woody",
    "note:spiced-aromatic"
  ],
  "fleurit-parfums-fleuriste": [
    "gender:unisex",
    "note:floral",
    "note:fruity",
    "note:sweet",
    "note:theoretical-tobacco",
    "note:gourmand"
  ],
  "fleurit-parfums-g-teau-des-anges": [
    "gender:unisex",
    "note:pear",
    "note:pepper",
    "note:phantom-peony",
    "note:jasmine",
    "note:orange-blossom",
    "note:floral",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "fleurit-parfums-fleurs-de-d-esse": [
    "gender:unisex",
    "note:bergamot",
    "note:grapefruit",
    "note:orange",
    "note:melancholic-myrrh",
    "note:freesia"
  ],
  "fleurit-parfums-sainte-fum-e": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:pepper",
    "note:amber",
    "note:heliotrope",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "fleurit-parfums-fleurs-de-tabac": [
    "gender:unisex",
    "note:angelica",
    "note:bergamot",
    "note:pepper",
    "note:elemi-resin",
    "note:incense",
    "note:resin-smoke",
    "note:spiced-aromatic"
  ],
  "gallivant-istanbul": [
    "gender:unisex",
    "note:bergamot",
    "note:cardamom",
    "note:red-thyme",
    "note:lavender-absolute",
    "note:geranium",
    "note:spiced-aromatic"
  ],
  "gallivant-tokyo": [
    "gender:unisex",
    "note:pepper",
    "note:cardamom",
    "note:cedar",
    "note:sandalwood",
    "note:vetiver",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "gallivant-london": [
    "gender:unisex",
    "note:apple",
    "note:berry",
    "note:freesia",
    "note:musk",
    "note:rose",
    "note:floral",
    "note:fruity"
  ],
  "gallivant-bukhara": [
    "gender:unisex",
    "note:coriander",
    "note:caraway",
    "note:pear",
    "note:bergamot",
    "note:orris-iris",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "gallivant-gdansk": [
    "gender:unisex",
    "note:cherry-blossom",
    "note:sandalwood",
    "note:tea",
    "note:cedar",
    "note:fresh",
    "note:woody",
    "note:aromatic"
  ],
  "giardini-di-toscana-bianco-latte": [
    "gender:unisex",
    "note:vanilla",
    "note:caramel",
    "note:honey",
    "note:musk",
    "note:coumarin",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral"
  ],
  "giardini-di-toscana-oro-e-miele": [
    "gender:unisex",
    "note:vanilla",
    "note:tonka",
    "note:honey",
    "note:coconut",
    "note:berry",
    "note:gourmand",
    "note:resin-smoke",
    "note:floral",
    "note:fruity"
  ],
  "giardini-di-toscana-ricordami": [
    "gender:unisex",
    "note:bergamot",
    "note:lemon",
    "note:orange",
    "note:vetiver",
    "note:cedar",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:dark"
  ],
  "giardini-di-toscana-verde-respiro": [
    "gender:unisex",
    "note:berry",
    "note:patchouli",
    "note:vanilla",
    "note:bergamot",
    "note:amber",
    "note:gourmand",
    "note:woody",
    "note:earthy",
    "note:aromatic",
    "note:resin-smoke",
    "note:fruity",
    "note:dark"
  ],
  "giardini-di-toscana-discovery-set": [
    "gender:unisex"
  ],
  "liis-bo": [
    "gender:unisex",
    "note:cedar",
    "note:vanilla",
    "note:elemi-resin",
    "note:tobacco",
    "note:kyara-incense",
    "note:gourmand",
    "note:woody",
    "note:dark"
  ],
  "liis-studied": [
    "gender:unisex",
    "note:orange",
    "note:omani-frankincense",
    "note:pepper",
    "note:coffee",
    "note:jasmine",
    "note:gourmand",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "liis-floating": [
    "gender:unisex",
    "note:fresh",
    "note:gourmand",
    "note:woody",
    "note:floral",
    "note:fruity"
  ],
  "liis-celestial-object": [
    "gender:unisex",
    "note:almond",
    "note:tonka",
    "note:incense",
    "note:balsamic",
    "note:quince",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity"
  ],
  "liis-choux-choux": [
    "gender:unisex",
    "note:aromatic",
    "note:bergamot",
    "note:lemon-zest",
    "note:geranium",
    "note:lavender",
    "note:floral"
  ],
  "liis-ethereal-wave": [
    "gender:unisex",
    "note:bergamot",
    "note:coconut",
    "note:grapefruit",
    "note:musk",
    "note:vanilla",
    "note:gourmand"
  ],
  "liis-in-this-world": [
    "gender:unisex",
    "note:milk",
    "note:berry",
    "note:negative-narcissus",
    "note:gourmand",
    "note:fruity"
  ],
  "liis-lucienne": [
    "gender:unisex",
    "note:pomelo",
    "note:lemon-zest",
    "note:magnolia",
    "note:water-lily",
    "note:pitahaya",
    "note:fresh",
    "note:floral"
  ],
  "liis-of-true-minds": [
    "gender:unisex",
    "note:french-narcissus",
    "note:sandalwood",
    "note:orange",
    "note:osmanthus",
    "note:pink-lotus",
    "note:woody",
    "note:floral"
  ],
  "twentysecondofmay-roots-of-kente": [
    "gender:unisex",
    "note:wood",
    "note:musk",
    "note:balsamic",
    "note:jasmine",
    "note:tonka",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:floral"
  ],
  "rania-j-jasmin-kama": [
    "gender:unisex",
    "note:freesia",
    "note:virtual-violet",
    "note:berry",
    "note:junkrothfelm",
    "note:vanilla",
    "note:gourmand",
    "note:fruity"
  ],
  "rania-j-t-habanero": [
    "gender:unisex",
    "note:vanilla",
    "note:gourmand"
  ],
  "twentysecondofmay-bees-home": [
    "gender:unisex",
    "note:orange",
    "note:grapefruit",
    "note:mint",
    "note:cinnamon",
    "note:rose",
    "note:fresh",
    "note:gourmand",
    "note:aromatic",
    "note:floral",
    "note:spiced-aromatic"
  ],
  "twentysecondofmay-frosted-flame": [
    "gender:unisex",
    "note:patchouli",
    "note:quembrathosin",
    "note:woody",
    "note:earthy",
    "note:dark"
  ],
  "twentysecondofmay-sunbeds-and-daydreams": [
    "gender:unisex",
    "note:fresh-pear",
    "note:solar-accord",
    "note:jasmine",
    "note:honey",
    "note:marine-accord-sea-water",
    "note:gourmand",
    "note:floral"
  ],
  "jovoy-parfums-fire-at-will": [
    "gender:unisex",
    "note:vanilla",
    "note:mimosa",
    "note:sweet",
    "note:amber",
    "note:musk",
    "note:gourmand",
    "note:resin-smoke",
    "note:fruity"
  ],
  "jovoy-parfums-remember-me": [
    "gender:unisex",
    "note:cardamom",
    "note:lemon",
    "note:bergamot",
    "note:tea",
    "note:ginger",
    "note:fresh",
    "note:aromatic",
    "note:spiced-aromatic"
  ],
  "jovoy-parfums-musc-pallas": [
    "gender:unisex",
    "note:ambrette-musk-mallow",
    "note:bergamot",
    "note:iris",
    "note:peach",
    "note:ocean-spray-marine-notes",
    "note:floral",
    "note:fruity"
  ],
  "jovoy-parfums-discovery-kit": [
    "gender:unisex",
    "note:amber",
    "note:resin-smoke"
  ],
  "les-indemodables-foug-re-meraude": [
    "gender:unisex",
    "note:pepper",
    "note:fruity",
    "note:leather",
    "note:oud",
    "note:patchouli",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "les-indemodables-cuir-de-chine": [
    "gender:unisex",
    "note:rose",
    "note:rosa-centifolia",
    "note:orange",
    "note:berry",
    "note:melancholic-myrrh",
    "note:floral",
    "note:fruity"
  ],
  "les-indemodables-chypre-azural": [
    "gender:unisex",
    "note:rose",
    "note:rosa-centifolia",
    "note:orange",
    "note:brimzalthok",
    "note:berry",
    "note:floral",
    "note:fruity"
  ],
  "les-indemodables-iris-perle": [
    "gender:unisex",
    "note:fresh",
    "note:amber",
    "note:jasmine",
    "note:iris",
    "note:violet",
    "note:gourmand",
    "note:aromatic",
    "note:resin-smoke",
    "note:floral"
  ],
  "les-indemodables-musc-des-sables": [
    "gender:unisex",
    "note:fresh",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "les-indemodables-vanille-havane": [
    "gender:unisex",
    "note:tobacco",
    "note:chocolate",
    "note:rum",
    "note:vanilla",
    "note:amber",
    "note:gourmand",
    "note:woody",
    "note:resin-smoke",
    "note:boozy",
    "note:fruity",
    "note:spiced-aromatic",
    "note:dark"
  ],
  "les-indemodables-patchouli-noisette": [
    "gender:unisex",
    "note:lychee",
    "note:apricot-nectar",
    "note:coconut",
    "note:datura",
    "note:jasmine",
    "note:gourmand",
    "note:floral"
  ],
  "les-indemodables-discovery-kit": [
    "gender:unisex"
  ],
  "rania-j-samar-kand-extrait": [
    "gender:unisex",
    "note:bergamot",
    "note:orange",
    "note:osmanthus",
    "note:geranium",
    "note:ylang",
    "note:floral"
  ],
  "rania-j-ambre-loup": [
    "gender:unisex",
    "note:apple",
    "note:bergamot",
    "note:ginger",
    "note:lemon",
    "note:drowsy-iris",
    "note:fruity",
    "note:spiced-aromatic"
  ],
  "dannam-white-rice": [
    "gender:unisex",
    "note:incense",
    "note:eucalyptus",
    "note:bergamot",
    "note:jasmine",
    "note:vetiver",
    "note:woody",
    "note:earthy",
    "note:resin-smoke",
    "note:floral",
    "note:dark"
  ],
  "dannam-strawberry-mochi": [
    "gender:unisex",
    "note:aldehydes",
    "note:geranium",
    "note:heliotrope",
    "note:orange-blossom",
    "note:sandalwood",
    "note:woody",
    "note:floral"
  ],
  "dannam-vietnamese-coffee": [
    "gender:unisex",
    "note:rose",
    "note:raspberry-liqueur",
    "note:osmanthus",
    "note:peach-blossom",
    "note:amber",
    "note:resin-smoke",
    "note:floral"
  ],
  "dannam-matcha-soft-serve": [
    "gender:unisex",
    "note:balsamic",
    "note:passionfruit",
    "note:saffron",
    "note:backwards-bergamot",
    "note:geranium",
    "note:resin-smoke",
    "note:fruity",
    "note:spiced-aromatic"
  ]
};
  var noteWeights = {
  "azman-killer-vavoom": {
    "rose": 100.0,
    "jasmine": 92.0,
    "iris": 84.0,
    "osmanthus": 76.0,
    "bergamot": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "floral": 36.0,
    "dark": 28.0
  },
  "azman-i-am-darkness": {
    "balsamic": 100.0,
    "oud": 92.0,
    "jasmine": 84.0,
    "frangipani": 76.0,
    "bergamot": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "fruity": 20.0,
    "spiced-aromatic": 12.0,
    "dark": 4.0
  },
  "azman-risk": {
    "amber": 100.0,
    "balsamic": 92.0,
    "oud": 84.0,
    "tuberose": 76.0,
    "iris": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "dark": 36.0
  },
  "azman-song-for-a-wanderer": {
    "oud": 100.0,
    "orange-blossom": 92.0,
    "bergamot": 84.0,
    "lemon": 76.0,
    "orange": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "fruity": 20.0,
    "dark": 12.0
  },
  "azman-oh-my-shisha": {
    "sweet": 100.0,
    "gourmand": 92.0,
    "fruity": 84.0
  },
  "azman-crown-of-fire": {
    "oud": 100.0,
    "iris": 92.0,
    "violet": 84.0,
    "osmanthus": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "azman-majnoon": {
    "amber": 100.0,
    "oud": 92.0,
    "rose": 84.0,
    "patchouli": 76.0,
    "incense": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "azman-two-minutes-after-the-kiss": {
    "balsamic": 100.0,
    "oud": 92.0,
    "floral": 84.0,
    "rose": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "azman-nocturnal-immortal": {
    "balsamic": 100.0,
    "rose": 92.0,
    "mandarin": 84.0,
    "orange": 76.0,
    "rosemary": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "fruity": 20.0,
    "dark": 12.0
  },
  "azman-riad-jasmine": {
    "oud": 100.0,
    "jasmine": 92.0,
    "berry": 84.0,
    "cedar": 76.0,
    "pine": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "dark": 28.0
  },
  "lorenzo-pazzaglia-cherry-ink": {
    "cherry": 100.0,
    "bergamot": 92.0,
    "pepper": 84.0,
    "rhum-accord": 76.0,
    "black-cherry": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "room-1015-kokoa-bang": {
    "accord-ros-champagne": 100.0,
    "pear": 92.0,
    "lemon": 84.0,
    "magnolia": 76.0,
    "chocolate": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "fruity": 44.0
  },
  "room-1015-sonic-flower": {
    "pepper": 100.0,
    "carrot-seeds": 92.0,
    "iris": 84.0,
    "jasmine": 76.0,
    "ambroxan": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "trudon-carmen-scented-hand-lotion": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "rhum": 84.0,
    "tobacco": 76.0,
    "oak-wood": 68.0,
    "dark": 60.0
  },
  "trudon-carmen-hand-soap": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "rhum": 84.0,
    "tobacco": 76.0,
    "oak-wood": 68.0,
    "dark": 60.0
  },
  "fascent-discovery-kit": {
    "fresh": 100.0,
    "balsamic": 92.0,
    "floral": 84.0,
    "orange-blossom": 76.0,
    "iris": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "aromatic": 36.0,
    "resin-smoke": 28.0,
    "fruity": 20.0,
    "spiced-aromatic": 12.0,
    "dark": 4.0
  },
  "fascent-red-flag": {
    "iris": 100.0,
    "vetiver": 92.0,
    "patchouli": 84.0,
    "wood": 76.0,
    "incense": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "fascent-corn-star": {
    "pear": 100.0,
    "fig": 92.0,
    "tonka": 84.0,
    "coconut": 76.0,
    "marine": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "fruity": 44.0
  },
  "fascent-creme-brulante": {
    "amber": 100.0,
    "balsamic": 92.0,
    "fig": 84.0,
    "wood": 76.0,
    "incense": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "resin-smoke": 36.0,
    "boozy": 28.0,
    "fruity": 20.0
  },
  "fascent-leau-dor-dort": {
    "orange-blossom": 100.0,
    "bergamot": 92.0,
    "lemon": 84.0,
    "orange": 76.0,
    "musk": 68.0,
    "floral": 60.0
  },
  "fascent-i-fig-you": {
    "fresh": 100.0,
    "citrus": 92.0,
    "sage": 84.0,
    "fig": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "fruity": 36.0,
    "dark": 28.0
  },
  "fascent-milky-no-way": {
    "amber": 100.0,
    "sandalwood": 92.0,
    "wood": 84.0,
    "tonka": 76.0,
    "milk": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0
  },
  "fascent-radical-softness": {
    "floral": 100.0,
    "frangipani": 92.0,
    "tea": 84.0,
    "pepper": 76.0,
    "musk": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "spiced-aromatic": 44.0
  },
  "fascent-sel-a-vie": {
    "jasmine": 100.0,
    "ylang": 92.0,
    "mandarin": 84.0,
    "orange": 76.0,
    "vanilla": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "floral": 44.0,
    "fruity": 36.0
  },
  "tada-parfumeur-discovery-set-02": {},
  "tada-parfumeur-discovery-set-01": {},
  "tada-parfumeur-the-print-house": {
    "blueberry-accord": 100.0,
    "pepper": 92.0,
    "bergamot": 84.0,
    "lavender": 76.0,
    "geranium": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "tada-parfumeur-the-inner-child": {
    "blueberry-accord": 100.0,
    "pepper": 92.0,
    "bergamot": 84.0,
    "lavender": 76.0,
    "geranium": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "tada-parfumeur-the-little-adult": {
    "mandarin": 100.0,
    "pepper": 92.0,
    "bergamot": 84.0,
    "neroli": 76.0,
    "clove": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "tada-parfumeur-velvet-sanctuary": {
    "bergamot": 100.0,
    "red-wine-accord": 92.0,
    "grapefruit": 84.0,
    "rhubarb": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "tada-parfumeur-nocturnal-noir": {
    "patchouli": 100.0,
    "saffron": 92.0,
    "davana": 84.0,
    "whiskey-accord": 76.0,
    "smoke": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "tada-parfumeur-radiant-memories": {
    "apricot": 100.0,
    "dried-fruits": 92.0,
    "orange": 84.0,
    "iris": 76.0,
    "amber": 68.0,
    "resin-smoke": 60.0,
    "floral": 52.0,
    "fruity": 44.0
  },
  "tada-parfumeur-when-i-realised": {
    "orange": 100.0,
    "bergamot": 92.0,
    "clove": 84.0,
    "suede": 76.0,
    "chocolate": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "tada-parfumeur-latakia": {
    "smoke": 100.0,
    "honey": 92.0,
    "dried-fruit": 84.0,
    "lavender": 76.0,
    "tea": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "dark": 20.0
  },
  "tada-parfumeur-black-cavendish": {
    "rum": 100.0,
    "incense": 92.0,
    "clove": 84.0,
    "caramel": 76.0,
    "jasmine": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "boozy": 36.0,
    "spiced-aromatic": 28.0
  },
  "hellenist-eveil-du-faune": {
    "candied-angelica-bergamot-davana": 100.0,
    "leather-narcissus-musc": 92.0,
    "oud": 84.0,
    "woody": 76.0,
    "resin-smoke": 68.0,
    "dark": 60.0
  },
  "meo-fusciuni-amara-vita": {
    "iris": 100.0,
    "orange": 92.0,
    "berry": 84.0,
    "sandalwood": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "floral": 44.0,
    "fruity": 36.0
  },
  "mith-legend": {
    "apple": 100.0,
    "galbanum": 92.0,
    "lemon": 84.0,
    "pepper": 76.0,
    "geranium": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "narcotica-amber-radiance": {
    "lemon-zest": 100.0,
    "rum": 92.0,
    "amber": 84.0,
    "orange-blossom": 76.0,
    "vanilla": 68.0,
    "musk": 60.0,
    "ambergris": 52.0,
    "fresh": 44.0,
    "boozy": 36.0,
    "resin-smoke": 28.0,
    "floral": 20.0,
    "gourmand": 12.0
  },
  "house-of-cosmo-dark-matter": {
    "blackberry": 100.0,
    "davana-essence": 92.0,
    "vaporwoods": 84.0,
    "incense": 76.0,
    "iris": 68.0,
    "tobacco": 60.0,
    "akigalawood": 52.0,
    "cypriol": 44.0,
    "musk": 36.0,
    "oud": 28.0,
    "fruity": 20.0,
    "aromatic": 12.0,
    "woody": 4.0,
    "resin-smoke": 1.0,
    "floral": 1.0,
    "earthy": 1.0,
    "dark": 1.0
  },
  "borntostandout-saint-petal": {
    "orange-blossom": 100.0,
    "cumin": 92.0,
    "bergamot": 84.0,
    "dust": 76.0,
    "violet-leaves": 68.0,
    "jasmine": 60.0,
    "coffee": 52.0,
    "incense": 44.0,
    "akigalawood": 36.0,
    "amyris": 28.0,
    "vetiver": 20.0,
    "cistus": 12.0,
    "oud": 4.0,
    "leather": 1.0,
    "fresh": 1.0,
    "floral": 1.0,
    "spiced-aromatic": 1.0,
    "gourmand": 1.0,
    "woody": 1.0,
    "resin-smoke": 1.0,
    "earthy": 1.0,
    "dark": 1.0
  },
  "lost-tribe-kong": {
    "amber": 100.0,
    "balsamic": 92.0,
    "floral": 84.0,
    "magnolia": 76.0,
    "frangipani": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "lost-tribe-dark-shadows": {
    "fresh": 100.0,
    "amber": 92.0,
    "balsamic": 84.0,
    "oud": 76.0,
    "floral": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "fruity": 28.0,
    "dark": 20.0
  },
  "lost-tribe-zilla": {
    "fresh": 100.0,
    "citrus": 92.0,
    "amber": 84.0,
    "oud": 76.0,
    "floral": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0,
    "dark": 36.0
  },
  "lost-tribe-pans-labyrinth-v2": {
    "bergamot": 100.0,
    "rose": 92.0,
    "powder-accord": 84.0,
    "bitter-almond": 76.0,
    "white-ambergris": 68.0,
    "floral": 60.0
  },
  "twentysecondofmay-skin-to-skin": {
    "fabric-softener": 100.0,
    "clean-aldehydes": 92.0,
    "coconut": 84.0,
    "ambrette-seeds": 76.0,
    "orange": 68.0,
    "gourmand": 60.0
  },
  "liis-forest-sounds": {
    "ozonic": 100.0,
    "yuzu": 92.0,
    "vetiver": 84.0,
    "wood": 76.0,
    "fresh": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "dark": 44.0
  },
  "perfumology-pursuit-of-happiness-250-limited-edition": {
    "balsamic": 100.0,
    "lemon": 92.0,
    "grapefruit": 84.0,
    "mandarin": 76.0,
    "berry": 68.0,
    "fresh": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0
  },
  "perfumology-boutique": {
    "red-apple": 100.0,
    "grapefruit": 92.0,
    "ambrettolide": 84.0,
    "white-blossoms": 76.0,
    "jasmine": 68.0,
    "floral": 60.0
  },
  "amouage-honour-woman-gift-set": {
    "pepper": 100.0,
    "rhubarb-leaves": 92.0,
    "coriander": 84.0,
    "jasmine": 76.0,
    "tuberose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-reflection-man-gift-set": {
    "rosemary": 100.0,
    "pepper": 92.0,
    "orange": 84.0,
    "neroli": 76.0,
    "orris-iris": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-guidance-gift-set": {
    "pear": 100.0,
    "incense": 92.0,
    "almond": 84.0,
    "saffron": 76.0,
    "rose": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0
  },
  "amouage-decision-gift-set": {
    "bergamot": 100.0,
    "cardamom": 92.0,
    "pepper": 84.0,
    "frankincense-olibanum": 76.0,
    "balsamic": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-purpose-gift-set": {
    "bergamot": 100.0,
    "pepper": 92.0,
    "incense": 84.0,
    "pimento-berry": 76.0,
    "rose": 68.0,
    "resin-smoke": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "ormonde-jayne-oud-liaisons": {
    "orange": 100.0,
    "bergamot": 92.0,
    "osmanthus-absolute": 84.0,
    "jasmine": 76.0,
    "tuberose": 68.0,
    "floral": 60.0
  },
  "ormonde-jayne-vanilla-aube": {
    "bergamot": 100.0,
    "raspberry-leaf": 92.0,
    "red-fruits": 84.0,
    "bifurcated-vetiver": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "ormonde-jayne-patchouli-d-atlas": {
    "aldehydes": 100.0,
    "amber": 92.0,
    "aniseed": 84.0,
    "basil": 76.0,
    "bengal-quince": 68.0,
    "aromatic": 60.0,
    "resin-smoke": 52.0
  },
  "ormonde-jayne-verano": {
    "bergamot": 100.0,
    "wood": 92.0,
    "milk": 84.0,
    "vanilla": 76.0,
    "amber": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0
  },
  "ormonde-jayne-tanger": {
    "basil": 100.0,
    "bergamot": 92.0,
    "clary-sage": 84.0,
    "galbanum": 76.0,
    "pineapple": 68.0,
    "aromatic": 60.0,
    "fruity": 52.0
  },
  "ormonde-jayne-levant": {
    "bergamot": 100.0,
    "paperbark": 92.0,
    "rosemary": 84.0,
    "hempzidralok": 76.0,
    "aniseed": 68.0,
    "aromatic": 60.0
  },
  "ormonde-jayne-bijou-zafran": {
    "basil": 100.0,
    "bergamot": 92.0,
    "clary-sage": 84.0,
    "galbanum": 76.0,
    "pineapple": 68.0,
    "aromatic": 60.0,
    "fruity": 52.0
  },
  "nebular-perfumes-discovery-kit": {},
  "nebular-perfumes-one-galaxy": {
    "rose": 100.0,
    "iris": 92.0,
    "floral": 84.0
  },
  "nebular-perfumes-aurora": {
    "amber": 100.0,
    "tonka": 92.0,
    "caramel": 84.0,
    "honey": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "boozy": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "nebular-perfumes-supernova": {
    "amber": 100.0,
    "orange-blossom": 92.0,
    "neroli": 84.0,
    "orange": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0
  },
  "nebular-perfumes-halo": {
    "rose": 100.0,
    "lemon": 92.0,
    "sandalwood": 84.0,
    "wood": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "floral": 44.0
  },
  "marc-antoine-barrois-ganymede-extrait": {
    "bergamot": 100.0,
    "cedar": 92.0,
    "musk": 84.0,
    "vetiver": 76.0,
    "grothzenvixol": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "dark": 44.0
  },
  "marc-antoine-barrois-b683-extrait": {
    "lemon-vervain": 100.0,
    "pineapple": 92.0,
    "salted-caramel": 84.0,
    "vextronplibar": 76.0,
    "fruity": 68.0
  },
  "marc-antoine-barrois-aldebaran": {
    "frangipani": 100.0,
    "orange": 92.0,
    "ylang": 84.0,
    "cashmere": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "floral": 52.0
  },
  "marc-antoine-barrois-encelade": {
    "amber": 100.0,
    "bergamot": 92.0,
    "birch-tar": 84.0,
    "galbanum": 76.0,
    "leather": 68.0,
    "resin-smoke": 60.0,
    "dark": 52.0
  },
  "marc-antoine-barrois-ganymede": {
    "mineral": 100.0,
    "floral": 92.0,
    "osmanthus": 84.0,
    "mandarin": 76.0,
    "sea-salt": 68.0,
    "fresh": 60.0,
    "dark": 52.0
  },
  "marc-antoine-barrois-b683": {
    "chamomile": 100.0,
    "bergamot-zest": 92.0,
    "mint": 84.0,
    "orange-blossom": 76.0,
    "tonka": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "floral": 36.0
  },
  "marc-antoine-barrois-tilia": {
    "orange": 100.0,
    "mango": 92.0,
    "vetiver": 84.0,
    "moss": 76.0,
    "woody": 68.0,
    "earthy": 60.0,
    "fruity": 52.0,
    "dark": 44.0
  },
  "jinx-naga": {
    "pandanus": 100.0,
    "bergamot": 92.0,
    "meyer-lemon": 84.0,
    "violet-leaf": 76.0,
    "spices": 68.0,
    "spiced-aromatic": 60.0
  },
  "amouage-purpose": {
    "incense": 100.0,
    "pimento": 92.0,
    "pepper": 84.0,
    "bergamot": 76.0,
    "papyrus": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-lineage": {
    "ginger": 100.0,
    "pepper": 92.0,
    "saffron": 84.0,
    "incense": 76.0,
    "fenugreek": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-enclave": {
    "spearmint": 100.0,
    "cardamom": 92.0,
    "cinnamon": 84.0,
    "pepper": 76.0,
    "incense": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-crimson-rocks": {
    "pepper": 100.0,
    "jujube-honey": 92.0,
    "rose": 84.0,
    "oak-wood-co2": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-interlude": {
    "oregano": 100.0,
    "pimento": 92.0,
    "bergamot": 84.0,
    "incense": 76.0,
    "balsamic": 68.0,
    "resin-smoke": 60.0
  },
  "amouage-decision-42": {
    "cardamom": 100.0,
    "neroli": 92.0,
    "pepper": 84.0,
    "bergamot": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-overture-41": {
    "saffron": 100.0,
    "calvados": 92.0,
    "cinnamon": 84.0,
    "incense": 76.0,
    "balsamic": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "nissaba-sulawesi": {
    "orange": 100.0,
    "indian-lemon-grass": 92.0,
    "tea": 84.0,
    "calabrian-bergamot": 76.0,
    "pepper": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "spiced-aromatic": 44.0
  },
  "nissaba-provence": {
    "citrus": 100.0,
    "kiwi": 92.0,
    "nervous-neroli": 84.0,
    "blueberry": 76.0,
    "lily-of-the-valley": 68.0,
    "fresh": 60.0
  },
  "nissaba-andevalo": {
    "bergamot": 100.0,
    "ylang": 92.0,
    "spenkzurbolith": 84.0,
    "floral": 76.0
  },
  "argos-sample-pack": {},
  "argos-extrait-de-parfum-discovery-set": {},
  "argos-odyssey-the-legend-returns": {
    "bergamot": 100.0,
    "clary-sage": 92.0,
    "lemon": 84.0,
    "lily-of-the-valley": 76.0,
    "orange-blossom": 68.0,
    "floral": 60.0
  },
  "argos-narcissus-obsession-in-bloom": {
    "tarragon": 100.0,
    "clove": 92.0,
    "berry": 84.0,
    "narcissus-absolute": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "argos-jupiters-lighting": {
    "cardamom": 100.0,
    "juniper-berries": 92.0,
    "lemon": 84.0,
    "bergamot": 76.0,
    "clary-sage": 68.0,
    "spiced-aromatic": 60.0
  },
  "argos-midas-touch": {
    "bergamot": 100.0,
    "pine": 92.0,
    "tuberose": 84.0,
    "leather": 76.0,
    "osmanthus": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "dark": 44.0
  },
  "argos-neptunes-trident": {
    "bergamot": 100.0,
    "orange": 92.0,
    "cardamom": 84.0,
    "lavender": 76.0,
    "tea": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "argos-charons-vail": {
    "rose": 100.0,
    "oud": 92.0,
    "cedar": 84.0,
    "sandalwood": 76.0,
    "patchouli": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0,
    "dark": 28.0
  },
  "argos-triumph-of-bacchus-extrait-de-parfum": {
    "white-peach": 100.0,
    "rum": 92.0,
    "apple": 84.0,
    "saffron": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "argos-sacred-flame": {
    "clove": 100.0,
    "peach": 92.0,
    "pepper": 84.0,
    "bergamot": 76.0,
    "ginger": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "argos-fall-of-phaeton": {
    "ginger": 100.0,
    "lemon": 92.0,
    "pepper": 84.0,
    "bergamot": 76.0,
    "cardamom": 68.0,
    "spiced-aromatic": 60.0
  },
  "argos-birth-of-venus": {
    "peach": 100.0,
    "grapefruit": 92.0,
    "bergamot": 84.0,
    "lavender": 76.0,
    "orange-blossom": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "fruity": 44.0
  },
  "argos-pallas-athene": {
    "pepper": 100.0,
    "red-berries": 92.0,
    "bergamot": 84.0,
    "grapefruit": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "argos-danae": {
    "bergamot": 100.0,
    "sicilian-lemon": 92.0,
    "cashmere-wood": 84.0,
    "pepper": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "spiced-aromatic": 52.0
  },
  "argos-brivido-della-caccia": {
    "juniper": 100.0,
    "clary-sage": 92.0,
    "mat-absolute": 84.0,
    "pepper": 76.0,
    "sweet-vernal-grass": 68.0,
    "spiced-aromatic": 60.0
  },
  "argos-triumph-of-bacchus-edp": {
    "white-peach": 100.0,
    "rum": 92.0,
    "apple": 84.0,
    "saffron": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "thomas-de-monaco-sol-salgado": {
    "amber": 100.0,
    "floral": 92.0,
    "sandalwood": 84.0,
    "vanilla": 76.0,
    "sea-salt": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "resin-smoke": 36.0
  },
  "thomas-de-monaco-parfums-luisant-haze": {
    "amber": 100.0,
    "floral": 92.0,
    "tuberose": 84.0,
    "tonka": 76.0,
    "sweet": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "thomas-de-monaco-raw-gold-extrait": {
    "davana-oil": 100.0,
    "cedar": 92.0,
    "iris": 84.0,
    "patchouli": 76.0,
    "gaiac-wood": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "floral": 44.0,
    "dark": 36.0
  },
  "roble-fragrance-lab-valencia-oro-grande": {
    "balsamic": 100.0,
    "iris": 92.0,
    "mandarin": 84.0,
    "orange": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "roble-fragrance-lab-agra-lotus-blossom": {
    "iris": 100.0,
    "bergamot": 92.0,
    "mandarin": 84.0,
    "vanilla": 76.0,
    "pepper": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "roble-fragrance-lab-istanbul-nar": {
    "amber": 100.0,
    "bergamot": 92.0,
    "fruity": 84.0,
    "sage": 76.0,
    "cedar": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "aromatic": 36.0,
    "resin-smoke": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "roble-fragrance-lab-zanzibar-vanilla-ginger": {
    "balsamic": 100.0,
    "iris": 92.0,
    "patchouli": 84.0,
    "vanilla": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "floral": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "essential-parfums-ambre-latte": {
    "bergamot": 100.0,
    "orange": 92.0,
    "pepper": 84.0,
    "clary-sage": 76.0,
    "geranium": 68.0,
    "spiced-aromatic": 60.0
  },
  "essential-parfums-mon-vetiver": {
    "amber": 100.0,
    "lime": 92.0,
    "vetiver": 84.0,
    "patchouli": 76.0,
    "wood": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "dark": 28.0
  },
  "essential-parfums-orange-x-santal": {
    "bergamot": 100.0,
    "clove": 92.0,
    "backwards-bergamot": 84.0,
    "amber": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "essential-parfums-rose-magnetic": {
    "citron": 100.0,
    "yuzu": 92.0,
    "pine": 84.0,
    "pepper": 76.0,
    "buddha-s-hand": 68.0,
    "woody": 60.0,
    "spiced-aromatic": 52.0
  },
  "essential-parfums-nice-bergamote": {
    "apricot": 100.0,
    "berry": 92.0,
    "grapefruit": 84.0,
    "dwebnorplix": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "essential-parfums-the-musc": {
    "french-lavender": 100.0,
    "sage": 92.0,
    "suspended-saffron": 84.0,
    "aromatic": 76.0
  },
  "essential-parfums-fig-infusion": {
    "mono": 100.0,
    "jasmine": 92.0,
    "coconut": 84.0,
    "crimzalthorix": 76.0,
    "gourmand": 68.0,
    "floral": 60.0
  },
  "essential-parfums-divine-vanille": {
    "green-notes": 100.0,
    "woody": 92.0
  },
  "essential-parfums-bois-imperial": {
    "clove": 100.0,
    "orange-blossom": 92.0,
    "rose": 84.0,
    "rosemary": 76.0,
    "thyme": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "clive-christian-crab-apple-blossom": {
    "frangipani": 100.0,
    "jasmine": 92.0,
    "lime": 84.0,
    "neroli": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0,
    "floral": 52.0
  },
  "kerosene-promises-promises": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "hedione": 84.0,
    "ozonic": 76.0,
    "fempzilnordax": 68.0,
    "fresh": 60.0
  },
  "third-eye-fragrance-iris-obsidian": {
    "pepper": 100.0,
    "coriander": 92.0,
    "orange": 84.0,
    "clove": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "third-eye-fragrance-moon-lotus": {
    "mandarin": 100.0,
    "peach": 92.0,
    "pineapple": 84.0,
    "ylang-ylang": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "belnu-vanilla-boucle": {
    "white-almond": 100.0,
    "coconut": 92.0,
    "chamomile": 84.0,
    "violet-leaf": 76.0,
    "incense": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "belnu-still-bloom": {
    "cardamom": 100.0,
    "cedar": 92.0,
    "geranium": 84.0,
    "guatemala-gaiac-wood": 76.0,
    "rose": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "dannam-princess-of-china": {
    "elemi-resin": 100.0,
    "eucalyptus": 92.0,
    "leather": 84.0,
    "lime": 76.0,
    "mint": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "dark": 44.0
  },
  "lepoque-dreams-and-nightmares": {
    "rose": 100.0,
    "cinnamon": 92.0,
    "bergamot": 84.0,
    "branched-benzoin": 76.0,
    "milk": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "lepoque-delusions-of-grandeur": {
    "apricot": 100.0,
    "tobacco": 92.0,
    "rum": 84.0,
    "jasmine": 76.0,
    "leather": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "boozy": 44.0,
    "fruity": 36.0,
    "dark": 28.0
  },
  "sora-dora-discovery-kit": {},
  "sora-dora-kamel-oud": {
    "chocolate-cake": 100.0,
    "pepper": 92.0,
    "sugar-powder": 84.0,
    "spiced-aromatic": 76.0
  },
  "sora-dora-greasque": {
    "rose": 100.0,
    "jasmine": 92.0,
    "orange": 84.0,
    "vanilla": 76.0,
    "violet": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "sora-dora-broceliande": {
    "elemi-resin": 100.0,
    "clove": 92.0,
    "peach": 84.0,
    "pineapple": 76.0,
    "plum": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "sora-dora-7": {
    "balsamic": 100.0,
    "oud": 92.0,
    "bergamot": 84.0,
    "mandarin": 76.0,
    "thyme": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "aromatic": 36.0,
    "resin-smoke": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "sora-dora-red": {
    "essence-of-italian-bergamot": 100.0,
    "pink-berries-co2-extract": 92.0,
    "coconut": 84.0,
    "essence-of-cardamom": 76.0,
    "essence-of-mandora": 68.0,
    "gourmand": 60.0
  },
  "sora-dora-orchidee-rouge": {
    "lime": 100.0,
    "tangential-tonka": 92.0,
    "marine-notes": 84.0,
    "sea-salt": 76.0,
    "petrified-petitgrain": 68.0,
    "fresh": 60.0
  },
  "sora-dora-lu-bu": {
    "aldehydes": 100.0,
    "ylang": 92.0,
    "calcified-cypress": 84.0,
    "rose": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "lorenzo-pazzaglia-que-chimba": {
    "galbanum": 100.0,
    "geranium": 92.0,
    "grapefruit": 84.0,
    "lemon": 76.0,
    "orange": 68.0
  },
  "lorenzo-pazzaglia-passion-rose": {
    "coconut": 100.0,
    "gourmand": 92.0
  },
  "lorenzo-pazzaglia-sweet-xplosion": {
    "iris": 100.0,
    "saffron": 92.0,
    "leather": 84.0,
    "clove": 76.0,
    "nested-nutmeg": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "amouage-dia-40-woman": {
    "cyclamen-aldehyde": 100.0,
    "violet-leaf": 92.0,
    "berry": 84.0,
    "musk": 76.0,
    "carnation": 68.0,
    "fruity": 60.0
  },
  "amouage-ashore": {
    "turmeric-leaf": 100.0,
    "cardamom": 92.0,
    "pepper": 84.0,
    "jasmine": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-jubilation-xxv": {
    "blackberry": 100.0,
    "incense": 92.0,
    "coriander": 84.0,
    "davana": 76.0,
    "balsamic": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-honour-43-woman": {
    "rhubarb-leaf": 100.0,
    "coriander": 92.0,
    "pepper": 84.0,
    "gardenia": 76.0,
    "tuberose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-honour-man": {
    "pepper": 100.0,
    "madagascan-elemi": 92.0,
    "geranium": 84.0,
    "clove": 76.0,
    "frankincense-resin": 68.0,
    "spiced-aromatic": 60.0
  },
  "amouage-memoir-woman": {
    "cardamom": 100.0,
    "absinth": 92.0,
    "pepper": 84.0,
    "orange": 76.0,
    "incense": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-memoir-man": {
    "absinth": 100.0,
    "absinthe-wormwood": 92.0,
    "mint": 84.0,
    "basil": 76.0,
    "incense": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0
  },
  "amouage-portrayal-man": {
    "violet-leaf": 100.0,
    "java-vetiver": 92.0,
    "cade-juniper": 84.0
  },
  "caeleste-virtues": {
    "cocoa-absolute": 100.0,
    "balsamic": 92.0,
    "patchouli": 84.0,
    "bergamot": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "house-of-cosmo-galaxia": {
    "pepper": 100.0,
    "sweet": 92.0,
    "coffee": 84.0,
    "chocolate": 76.0,
    "coconut": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "house-of-cosmo-nova": {
    "starburst-candy": 100.0,
    "melon": 92.0,
    "bergamot": 84.0,
    "cardamom": 76.0,
    "pepper": 68.0,
    "spiced-aromatic": 60.0
  },
  "house-of-cosmo-polaris": {
    "stardust": 100.0,
    "ginger": 92.0,
    "bergamot": 84.0,
    "grapefruit": 76.0,
    "cardamom": 68.0,
    "spiced-aromatic": 60.0
  },
  "house-of-cosmo-element": {
    "fabric": 100.0,
    "iris": 92.0,
    "paper": 84.0,
    "peony": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "dorsay-vanilla-affair": {
    "heliotrope": 100.0,
    "orange": 92.0,
    "orchid": 84.0,
    "gourmand-notes": 76.0,
    "tropical": 68.0,
    "fruity": 60.0
  },
  "jinx-pragma": {
    "bergamot": 100.0,
    "cedar": 92.0,
    "jasmine": 84.0,
    "clove": 76.0,
    "berry": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "rahasya-love-marriage": {
    "pistachio": 100.0,
    "rum": 92.0,
    "saffron": 84.0,
    "praline": 76.0,
    "vanilla": 68.0,
    "rose": 60.0,
    "cinnamon": 52.0,
    "sandalwood": 44.0,
    "balsamic": 36.0,
    "boozy": 28.0,
    "gourmand": 20.0,
    "spiced-aromatic": 12.0,
    "floral": 4.0
  },
  "rahasya-hill-station": {
    "vetiver": 100.0,
    "tea": 92.0,
    "fig": 84.0,
    "mineral": 76.0,
    "sandalwood": 68.0,
    "spices": 60.0,
    "fresh": 52.0,
    "earthy": 44.0,
    "woody": 36.0,
    "tea-forward": 28.0
  },
  "rahasya-chai-addiction": {
    "tea": 100.0,
    "sandalwood": 92.0,
    "cardamom": 84.0,
    "ginger": 76.0,
    "vanilla": 68.0,
    "milk": 60.0,
    "magnolia": 52.0,
    "vetiver": 44.0,
    "suede": 36.0,
    "tea-forward": 28.0,
    "gourmand": 20.0,
    "woody": 12.0,
    "spiced-aromatic": 4.0
  },
  "rahasya-oud-mangifera": {
    "oud": 100.0,
    "mango": 92.0,
    "incense": 84.0,
    "leather": 76.0,
    "rose": 68.0,
    "berry": 60.0,
    "pepper": 52.0,
    "patchouli": 44.0,
    "tea": 36.0,
    "resin-smoke": 28.0,
    "fruity": 20.0,
    "tropical": 12.0,
    "dark": 4.0,
    "woody": 1.0
  },
  "rahasya-ricksaw-rhythms": {
    "fig": 100.0,
    "coconut": 92.0,
    "marine": 84.0,
    "champaca": 76.0,
    "vetiver": 68.0,
    "suede": 60.0,
    "tropical": 52.0,
    "fresh": 44.0,
    "earthy": 36.0,
    "woody": 28.0,
    "floral": 20.0
  },
  "rahasya-chapter-one": {
    "tobacco": 100.0,
    "leather": 92.0,
    "cardamom": 84.0,
    "iris": 76.0,
    "cedar": 68.0,
    "sandalwood": 60.0,
    "spices": 52.0,
    "woody": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "rahasya-cutting-rain": {
    "rose": 100.0,
    "grapefruit": 92.0,
    "saffron": 84.0,
    "tea": 76.0,
    "honey": 68.0,
    "violet": 60.0,
    "marigold": 52.0,
    "sandalwood": 44.0,
    "leather": 36.0,
    "fresh": 28.0,
    "floral": 20.0,
    "woody": 12.0,
    "tea-forward": 4.0,
    "fruity": 1.0
  },
  "fleurit-parfums-plage-sud": {
    "amber": 100.0,
    "floral": 92.0,
    "jasmine": 84.0,
    "gardenia": 76.0,
    "ylang": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0
  },
  "fleurit-parfums-malibu": {
    "pepper": 100.0,
    "jasmine": 92.0,
    "sandalwood": 84.0,
    "common-questions": 76.0,
    "woody": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "fleurit-parfums-antibes": {
    "petitgrain-thyme-lemon": 100.0,
    "rose": 92.0,
    "sandalwood": 84.0,
    "common-questions": 76.0,
    "woody": 68.0,
    "floral": 60.0
  },
  "bdk-parfums-creme-de-cuir": {
    "suede": 100.0,
    "leather": 92.0,
    "sandalwood": 84.0,
    "vanilla": 76.0,
    "pineapple": 68.0,
    "bergamot": 60.0,
    "berry": 52.0,
    "musk": 44.0,
    "woody": 36.0,
    "gourmand": 28.0,
    "fresh": 20.0,
    "fruity": 12.0
  },
  "jovoy-parfums-ha-long-bay": {
    "mango": 100.0,
    "cardamom": 92.0,
    "pepper": 84.0,
    "nagarmotha": 76.0,
    "leather": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "jinx-rosette-nebula": {
    "green-cognac": 100.0,
    "clove": 92.0,
    "orange": 84.0,
    "bergamot": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "third-eye-fragrance-red-rum-reserve": {
    "rose": 100.0,
    "amber": 92.0,
    "musk": 84.0,
    "vanilla": 76.0,
    "rilthondexum": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0
  },
  "srhy-m-of-_u": {
    "lemon": 100.0,
    "orange": 92.0,
    "bergamot": 84.0,
    "pine": 76.0,
    "rose": 68.0,
    "woody": 60.0,
    "floral": 52.0
  },
  "rania-j-discovery-set": {},
  "rania-j-musc-mochus": {
    "sandalwood": 100.0,
    "woody": 92.0
  },
  "rania-j-rose-ishtar": {
    "tuberose": 100.0,
    "banana-leaf": 92.0,
    "ivory-coast-ginger": 84.0,
    "pepper": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "rania-j-lavande-44": {
    "caramel": 100.0,
    "chocolate": 92.0,
    "milk": 84.0,
    "sweet": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0
  },
  "pernoire-luvani": {
    "bergamot": 100.0,
    "fresh": 92.0,
    "balsamic": 84.0,
    "papyrus": 76.0,
    "patchouli": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "dark": 36.0
  },
  "chris-collins-sunset-in-tamarindo": {
    "davana": 100.0,
    "mango": 92.0,
    "orange": 84.0,
    "papaya": 76.0,
    "frangipani-absolute": 68.0,
    "fruity": 60.0
  },
  "mind-games-scholars-mate": {
    "pepper": 100.0,
    "coriander": 92.0,
    "orange": 84.0,
    "clove": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "mind-games-caissa": {
    "bergamot": 100.0,
    "lavender": 92.0,
    "peach": 84.0,
    "ginger": 76.0,
    "lemon": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "mind-games-prodigy": {
    "musk": 100.0,
    "pink-orchid": 92.0,
    "pomegranate": 84.0,
    "sandalwood": 76.0,
    "woody": 68.0
  },
  "mind-games-mentor": {
    "green-notes": 100.0,
    "lemon": 92.0,
    "displaced-daffodil": 84.0,
    "jasmine": 76.0,
    "lily-of-the-valley": 68.0,
    "floral": 60.0
  },
  "mind-games-castling": {
    "almond": 100.0,
    "amber": 92.0,
    "bergamot": 84.0,
    "civet": 76.0,
    "coffee": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "mind-games-gardez": {
    "cardamom": 100.0,
    "lotus-leaf": 92.0,
    "water-iris": 84.0,
    "pepper": 76.0,
    "spiced-aromatic": 68.0
  },
  "mind-games-check-mate": {
    "rose": 100.0,
    "magnolia": 92.0,
    "patchouli": 84.0,
    "moss": 76.0,
    "earthy": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "boozy": 44.0,
    "dark": 36.0
  },
  "mind-games-grand-master": {
    "balsamic": 100.0,
    "floral": 92.0,
    "rose": 84.0,
    "violet": 76.0,
    "berry": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "resin-smoke": 36.0,
    "fruity": 28.0,
    "dark": 20.0
  },
  "mind-games-counter-play": {
    "floral": 100.0,
    "orange-blossom": 92.0,
    "ylang": 84.0,
    "osmanthus": 76.0,
    "orange": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "mind-games-opera-mate": {
    "saffron": 100.0,
    "absinth": 92.0,
    "bergamot": 84.0,
    "lime": 76.0,
    "gaiac-wood": 68.0,
    "spiced-aromatic": 60.0
  },
  "mind-games-ruy-lopez": {
    "bergamot": 100.0,
    "rhubarb": 92.0,
    "summer-fruits": 84.0,
    "datura": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "mind-games-en-prise": {
    "berry": 100.0,
    "vanilla": 92.0,
    "xondripleval": 84.0,
    "gourmand": 76.0,
    "fruity": 68.0
  },
  "mind-games-vieri": {
    "blackberry-leaf": 100.0,
    "tea": 92.0,
    "honey": 84.0,
    "musk": 76.0,
    "spices": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "spiced-aromatic": 36.0
  },
  "mind-games-playmate": {
    "chocolate": 100.0,
    "peach": 92.0,
    "pralin": 84.0,
    "sandalwood": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "fruity": 44.0
  },
  "amouage-overture-man": {
    "cumin": 100.0,
    "cognac": 92.0,
    "grapefruit": 84.0,
    "cardamom": 76.0,
    "ginger": 68.0,
    "boozy": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-lilac-love": {
    "heliotrope": 100.0,
    "lilac": 92.0,
    "gardenia": 84.0,
    "peony": 76.0,
    "chocolate": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "amouage-opus-xii-rose-incense": {
    "frankincense-absolute": 100.0,
    "drawing-ink": 92.0,
    "elemi-resin": 84.0,
    "rose": 76.0,
    "suederal": 68.0,
    "floral": 60.0
  },
  "amouage-blossom-love": {
    "cherry-blossom-nectar": 100.0,
    "rose": 92.0,
    "ylang": 84.0,
    "amaretto": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "amouage-jubilation-25-woman": {
    "ylang": 100.0,
    "tarragon": 92.0,
    "lemon": 84.0,
    "rose": 76.0,
    "davana": 68.0,
    "floral": 60.0
  },
  "amouage-opus-xiv-royal-tobacco": {
    "aniseed": 100.0,
    "cardamom": 92.0,
    "elemi-resin": 84.0,
    "frankincense-oil": 76.0,
    "basil": 68.0,
    "aromatic": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-overture-woman": {
    "apple-brandy": 100.0,
    "saffron": 92.0,
    "bergamot": 84.0,
    "balsamic": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-opus-xv-king-blue": {
    "berry": 100.0,
    "orange": 92.0,
    "pepper": 84.0,
    "amber": 76.0,
    "incense": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-interlude-black-iris": {
    "rosemary": 100.0,
    "violet-leaf": 92.0,
    "bergamot": 84.0,
    "incense": 76.0,
    "balsamic": 68.0,
    "aromatic": 60.0,
    "resin-smoke": 52.0
  },
  "bdk-parfums-silver-ceremony": {
    "orange": 100.0,
    "italian-bergamot": 92.0,
    "italian-lemon-orpur": 84.0,
    "pepper": 76.0,
    "ginger-co2": 68.0,
    "spiced-aromatic": 60.0
  },
  "bdk-parfums-oud-paradisio": {
    "milk": 100.0,
    "somali-saffron-orpur": 92.0,
    "incense": 84.0,
    "italian-bergamot-orpur": 76.0,
    "rose": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0
  },
  "bdk-parfums-stellar-silk": {
    "laotian-cinnamon": 100.0,
    "ginger-co2": 92.0,
    "vanilla": 84.0,
    "french-orris-butter": 76.0,
    "roasted-venezuelan-tonka-bean-absolute": 68.0,
    "gourmand": 60.0
  },
  "jinx-harrow": {
    "bergamot": 100.0,
    "orange": 92.0,
    "pepper": 84.0,
    "rose": 76.0,
    "blossoms": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "borntostandout-naked-laundry": {
    "skatole": 100.0,
    "aldehydes": 92.0,
    "ambrinol": 84.0,
    "orange": 76.0,
    "white-caramel": 68.0
  },
  "borntostandout-melon-malo": {
    "candied-ginger": 100.0,
    "cinnamon": 92.0,
    "honeydew-melon": 84.0,
    "orange": 76.0,
    "rose": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "fleurit-parfums-a-lest": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "coconut": 84.0,
    "jasmine": 76.0,
    "freesia": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "chris-collins-discovery-set": {},
  "chris-collins-danse-sauvage": {
    "cognac": 100.0,
    "plum": 92.0,
    "saffron": 84.0,
    "pepper": 76.0,
    "chili": 68.0,
    "boozy": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "chris-collins-african-rooibos-intens": {
    "bergamot": 100.0,
    "cardamom": 92.0,
    "pepper": 84.0,
    "tea": 76.0,
    "iris": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "ode-ona-mini-journeys-discovery-giftset": {},
  "mind-games-knights-tour": {
    "lemon": 100.0,
    "orange": 92.0,
    "petitgrain": 84.0,
    "simulated-suede": 76.0,
    "geranium": 68.0
  },
  "mind-games-arabian-mate": {
    "jasmine": 100.0,
    "mimosa": 92.0,
    "vanilla": 84.0,
    "gourmand": 76.0,
    "floral": 68.0
  },
  "ode-ona-eden-bond": {
    "bergamot": 100.0,
    "sandalwood": 92.0,
    "grothzenvixol": 84.0,
    "woody": 76.0
  },
  "ode-ona-everjet": {
    "apple": 100.0,
    "cardamom": 92.0,
    "orange": 84.0,
    "juniper": 76.0,
    "lavender": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "ode-ona-moonkissed-rhapsody": {
    "pear": 100.0,
    "vanilla": 92.0,
    "red-fruits": 84.0,
    "gourmand": 76.0,
    "fruity": 68.0
  },
  "ode-ona-dawn-earth": {
    "ginger": 100.0,
    "lemon": 92.0,
    "mango": 84.0,
    "papaya": 76.0,
    "pepper": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "ode-ona-teapot-sonder": {
    "aldehydes": 100.0,
    "amber": 92.0,
    "aniseed": 84.0,
    "basil": 76.0,
    "bengal-quince": 68.0,
    "aromatic": 60.0,
    "resin-smoke": 52.0
  },
  "spiritica-suscepto": {
    "cinnamon": 100.0,
    "fruity": 92.0,
    "orange": 84.0,
    "spices": 76.0,
    "petrified-petitgrain": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "spiritica-rosanostra": {
    "berry": 100.0,
    "citrus": 92.0,
    "honey-meringue": 84.0,
    "ice-wine": 76.0,
    "musk": 68.0,
    "fresh": 60.0,
    "fruity": 52.0
  },
  "spiritica-weona": {
    "bergamot": 100.0,
    "leather": 92.0,
    "linden-tree-leaf": 84.0,
    "patchouli": 76.0,
    "tobacco": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "dark": 44.0
  },
  "french-cowboy-vanilla-for-breakfast": {
    "amber": 100.0,
    "chocolate": 92.0,
    "dried-fruits": 84.0,
    "floral": 76.0,
    "leather": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "dark": 44.0
  },
  "french-cowboy-fig-lemonade": {
    "tea": 100.0,
    "bergamot": 92.0,
    "berry": 84.0,
    "galbanum": 76.0,
    "musk": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "tea-forward": 44.0,
    "fruity": 36.0
  },
  "pernoire-tierra": {
    "pepper": 100.0,
    "orange": 92.0,
    "forgotten-frankincense": 84.0,
    "wood": 76.0,
    "jasmine": 68.0,
    "woody": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "pernoire-masar": {
    "aquatic-notes": 100.0,
    "citrus": 92.0,
    "vextronplibar": 84.0,
    "fresh": 76.0
  },
  "pernoire-amoral": {
    "oud": 100.0,
    "woody": 92.0,
    "resin-smoke": 84.0,
    "dark": 76.0
  },
  "pernoire-otimo": {
    "berry": 100.0,
    "orange": 92.0,
    "palm-tree": 84.0,
    "sicilian-lemon": 76.0,
    "apple-blossom": 68.0,
    "fruity": 60.0
  },
  "pernoire-discovery-set-anima": {},
  "hellenist-travel-set-luminous-trio": {},
  "kerosene-santalum-slivers": {
    "raspberry-jam": 100.0
  },
  "fugazzi-nocologne": {
    "citrus": 100.0,
    "amber": 92.0,
    "orange-blossom": 84.0,
    "bergamot": 76.0,
    "lemon": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "earthy": 36.0,
    "aromatic": 28.0,
    "resin-smoke": 20.0,
    "floral": 12.0,
    "fruity": 4.0,
    "spiced-aromatic": 1.0,
    "dark": 1.0
  },
  "dannam-discovery-set-majestic-china": {},
  "lost-tribe-maui": {
    "tangerine": 100.0,
    "clementine": 92.0,
    "sfuma-torchio": 84.0,
    "lemon-pelatrice": 76.0,
    "grapefruit": 68.0
  },
  "jinx-aeda": {
    "bergamot": 100.0,
    "citrus": 92.0,
    "ginger": 84.0,
    "tea": 76.0,
    "musk": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "spiced-aromatic": 44.0
  },
  "jinx-prachin-antique": {
    "cinnamon": 100.0,
    "rum": 92.0,
    "pepper": 84.0,
    "cognac": 76.0,
    "ginger": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "spiced-aromatic": 44.0
  },
  "jinx-colonia-de-pessego": {
    "berry": 100.0,
    "orange": 92.0,
    "jasmine": 84.0,
    "patchouli": 76.0,
    "klempzordivan": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "dark": 28.0
  },
  "jinx-rayong-fleur": {
    "cedar": 100.0,
    "incense": 92.0,
    "litsea-cubeba": 84.0,
    "musk": 76.0,
    "patchouli": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "dark": 36.0
  },
  "jinx-musk-montant": {
    "cherry": 100.0,
    "vanilla": 92.0,
    "moss": 84.0,
    "gourmand": 76.0,
    "earthy": 68.0,
    "fruity": 60.0
  },
  "amouage-boundless": {
    "cardamom": 100.0,
    "ginger-co2": 92.0,
    "orange": 84.0,
    "elemi-resin": 76.0,
    "balsamic": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-lustre": {
    "cardamom": 100.0,
    "iris": 92.0,
    "sandalwood": 84.0,
    "patchouli": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "srhy-road-trip": {
    "lemon": 100.0,
    "orange": 92.0,
    "passionfruit": 84.0,
    "jasmine": 76.0,
    "peony": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "caeleste-3rd-order": {},
  "caeleste-archangels": {
    "pepper": 100.0,
    "cedar": 92.0,
    "orange": 84.0,
    "mugwort": 76.0,
    "balsamic": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "caeleste-guardian-angel": {
    "coconut": 100.0,
    "heliotrope": 92.0,
    "tonka": 84.0,
    "vanilla": 76.0,
    "amber": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "caeleste-principalities": {
    "gunpowder": 100.0,
    "chili": 92.0,
    "metal": 84.0,
    "ash": 76.0,
    "mineral": 68.0,
    "fresh": 60.0
  },
  "orto-parisi-viride": {
    "tobacco": 100.0,
    "spices": 92.0,
    "vanilla": 84.0,
    "tonka": 76.0,
    "chocolate": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "orto-parisi-boccanera": {
    "calabrian-bergamot": 100.0,
    "cardamom": 92.0,
    "mat": 84.0,
    "violet": 76.0,
    "hollow-musk": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "orto-parisi-brutus": {
    "musk": 100.0
  },
  "lost-tribe-pina-colada": {
    "cinnamon": 100.0,
    "grapefruit": 92.0,
    "pepper": 84.0,
    "saffron": 76.0,
    "rotated-resins": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "borntostandout-gold-juice": {
    "mango": 100.0,
    "durian-fruit": 92.0,
    "rhubarb": 84.0,
    "osmanthus-absolute": 76.0,
    "solar-note": 68.0,
    "fruity": 60.0
  },
  "borntostandout-fugazzi": {
    "cumin": 100.0,
    "milk": 92.0,
    "incense": 84.0,
    "grapefruit": 76.0,
    "orange": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "borntostandout-dgaf": {
    "sage": 100.0,
    "calabrian-bergamot": 92.0,
    "violet": 84.0,
    "citrus": 76.0,
    "sandalwood": 68.0,
    "fresh": 60.0,
    "woody": 52.0,
    "aromatic": 44.0,
    "floral": 36.0
  },
  "borntostandout-black-creme-extrait-extreme": {
    "musk": 100.0,
    "milk": 92.0,
    "spices": 84.0,
    "iris": 76.0,
    "candle-wax": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "borntostandout-black-karak-extrait-extreme": {
    "tea": 100.0,
    "cardamom": 92.0,
    "cypriol": 84.0,
    "gaiac-wood": 76.0,
    "amber": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "tea-forward": 44.0,
    "resin-smoke": 36.0,
    "spiced-aromatic": 28.0
  },
  "mind-games-check-please": {
    "caramel-latte": 100.0,
    "amber": 92.0,
    "milk": 84.0,
    "paper": 76.0,
    "oud": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "dark": 36.0
  },
  "dannam-bubble-tea": {
    "cherry": 100.0,
    "peach": 92.0,
    "pear": 84.0,
    "red-berries": 76.0,
    "carnation": 68.0,
    "fruity": 60.0
  },
  "goldfield-banks-sunset-hour-dark-peach": {
    "chypre-accord": 100.0,
    "driftwood": 92.0,
    "lime": 84.0,
    "moss": 76.0,
    "ozonic": 68.0,
    "fresh": 60.0,
    "earthy": 52.0
  },
  "trudon-cyrnos-room-spray": {
    "lemon": 100.0,
    "myrtle": 92.0,
    "thyme": 84.0,
    "cedar": 76.0,
    "black-fig": 68.0,
    "woody": 60.0,
    "aromatic": 52.0
  },
  "trudon-ernesto-room-spray": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "rhum": 84.0,
    "oak-wood": 76.0,
    "clove": 68.0,
    "spiced-aromatic": 60.0
  },
  "trudon-abd-el-kader-room-spray": {
    "berry": 100.0,
    "lemon": 92.0,
    "ginger": 84.0,
    "clove": 76.0,
    "spearmint": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "trudon-cyrnos-candle": {
    "lemon": 100.0,
    "myrtle": 92.0,
    "thyme": 84.0,
    "cedar": 76.0,
    "black-fig": 68.0,
    "woody": 60.0,
    "aromatic": 52.0
  },
  "trudon-ernesto-candle": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "rhum": 84.0,
    "oak-wood": 76.0,
    "clove": 68.0,
    "spiced-aromatic": 60.0
  },
  "trudon-abd-el-kader-candle": {
    "berry": 100.0,
    "lemon": 92.0,
    "clove": 84.0,
    "ginger": 76.0,
    "mint": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "trudon-elae": {
    "coffee": 100.0,
    "dark-chocolate": 92.0,
    "grapefruit": 84.0,
    "lavender": 76.0,
    "rum": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "boozy": 36.0
  },
  "trudon-absolu": {
    "berry": 100.0,
    "pear": 92.0,
    "iris-pallida-concrete": 84.0,
    "jasmine": 76.0,
    "orange": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "trudon-mystique": {
    "sweet": 100.0,
    "tagetes": 92.0,
    "calcified-cypress": 84.0,
    "geranium": 76.0,
    "ginger": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "trudon-midnight-omen": {
    "iris": 100.0,
    "mandarin": 92.0,
    "peonies": 84.0,
    "saffron": 76.0,
    "leather": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "trudon-mortel-noir": {
    "bergamot": 100.0,
    "berry": 92.0,
    "orange": 84.0,
    "pepper": 76.0,
    "quincester": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "trudon-carmen": {
    "balsamic": 100.0,
    "rose": 92.0,
    "oud": 84.0,
    "orange": 76.0,
    "peach": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "dark": 28.0
  },
  "trudon-45-degree": {
    "cherry": 100.0,
    "lemon": 92.0,
    "orange": 84.0,
    "passionfruit": 76.0,
    "gronthelwix": 68.0,
    "fruity": 60.0
  },
  "xerjoff-fierezza": {
    "bergamot": 100.0,
    "lemon": 92.0,
    "patchouli": 84.0,
    "sandalwood": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "dark": 36.0
  },
  "xerjoff-avanguardia": {
    "orange": 100.0,
    "coconut": 92.0,
    "heliotrope": 84.0,
    "juniper-berry": 76.0,
    "lime": 68.0,
    "gourmand": 60.0
  },
  "xerjoff-perseveranza": {
    "cuban-tobacco": 100.0,
    "tonka": 92.0,
    "parallel-patchouli": 84.0,
    "cedar": 76.0,
    "jasmine": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "floral": 44.0
  },
  "iggywoo-the-discovery-set": {},
  "iggywoo-fantasma-overglow": {
    "fragonia": 100.0,
    "neroli": 92.0,
    "petitgrain": 84.0,
    "rose": 76.0,
    "shiso": 68.0,
    "floral": 60.0
  },
  "iggywoo-bohemian-water": {
    "berry": 100.0,
    "honeysuckle": 92.0,
    "jasmine": 84.0,
    "peach": 76.0,
    "floral": 68.0,
    "fruity": 60.0
  },
  "iggywoo-cherry-love-extreme": {
    "amber": 100.0,
    "bergamot": 92.0,
    "cedar": 84.0,
    "spices": 76.0,
    "shadow-sage": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "iggywoo-pistachio-voodoo-child": {
    "iris": 100.0,
    "abstract-ambrette": 92.0,
    "amber": 84.0,
    "cedar": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0
  },
  "iggywoo-cashmere-show-pony": {
    "pepper": 100.0,
    "spices": 92.0,
    "orchid": 84.0,
    "violet": 76.0,
    "jilthzorpanex": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "iggywoo-lost-in-vanillatopia": {
    "carrot-seed": 100.0,
    "milk": 92.0,
    "popcorn": 84.0,
    "xondripleval": 76.0,
    "pepper": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "jijide-ze-bai": {
    "floral": 100.0,
    "ylang": 92.0,
    "lemon": 84.0,
    "fruity": 76.0,
    "peach": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "dark": 44.0
  },
  "jijide-huan-yi": {
    "peony": 100.0,
    "chamomile": 92.0,
    "vextronplibar": 84.0,
    "tea": 76.0,
    "rose": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0
  },
  "jijide-oltre": {
    "mono": 100.0,
    "jasmine": 92.0,
    "coconut": 84.0,
    "calcified-cypress": 76.0,
    "gourmand": 68.0,
    "floral": 60.0
  },
  "jijide-grano": {
    "floral": 100.0,
    "musk": 92.0,
    "wood": 84.0,
    "woody": 76.0
  },
  "jijide-terra": {
    "citrus": 100.0,
    "green-notes": 92.0,
    "pepper": 84.0,
    "bifurcated-vetiver": 76.0,
    "floral": 68.0,
    "fresh": 60.0,
    "spiced-aromatic": 52.0
  },
  "jijide-riso": {
    "bergamot": 100.0,
    "berry": 92.0,
    "ginger": 84.0,
    "pepper": 76.0,
    "bay-leaf": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "clive-christian-rock-rose": {
    "orange": 100.0,
    "rose": 92.0,
    "saffron": 84.0,
    "common-questions": 76.0,
    "floral": 68.0,
    "spiced-aromatic": 60.0
  },
  "boadicea-the-victorious-aqua-sapphire": {
    "rum": 100.0,
    "davana": 92.0,
    "pineapple": 84.0,
    "saffron": 76.0,
    "kashmiri-musk": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "boadicea-the-victorious-blue-sapphire": {
    "chamomile": 100.0,
    "saffron": 92.0,
    "sage": 84.0,
    "lemon": 76.0,
    "pot-marigold": 68.0,
    "aromatic": 60.0,
    "spiced-aromatic": 52.0
  },
  "mind-games-gambit": {
    "fresh": 100.0,
    "amber": 92.0,
    "floral": 84.0,
    "lavender": 76.0,
    "fruity": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "resin-smoke": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "mind-games-the-forward": {
    "blueberry": 100.0,
    "lemon": 92.0,
    "sweet": 84.0,
    "gourmand": 76.0,
    "fruity": 68.0
  },
  "mind-games-lionora": {
    "jasmine": 100.0,
    "lily-of-the-valley": 92.0,
    "musk": 84.0,
    "peach": 76.0,
    "violet-leaf": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "ode-ona-carte-blanche": {
    "apple": 100.0,
    "bergamot": 92.0,
    "blueberry": 84.0,
    "virtual-violet": 76.0,
    "cardamom": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "roja-amber-aoud": {
    "lemon": 100.0,
    "bergamot": 92.0,
    "lime": 84.0,
    "rose": 76.0,
    "jasmin-de-grasse": 68.0,
    "floral": 60.0
  },
  "lorenzo-pazzaglia-vesuviuur": {
    "bergamot": 100.0,
    "honeysuckle": 92.0,
    "tea": 84.0,
    "jasmine": 76.0,
    "lemonade": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0
  },
  "lorenzo-pazzaglia-pink-milk": {
    "pink-grapefruit": 100.0,
    "lemon": 92.0,
    "orange": 84.0,
    "bergamot": 76.0,
    "pepper": 68.0,
    "spiced-aromatic": 60.0
  },
  "lorenzo-pazzaglia-van-exstasyx": {
    "aldehydes": 100.0,
    "lily-of-the-valley": 92.0,
    "neroli": 84.0,
    "rose": 76.0,
    "ylang": 68.0,
    "floral": 60.0
  },
  "lorenzo-pazzaglia-artik-sea": {
    "lemon": 100.0,
    "neroli": 92.0,
    "vervain": 84.0,
    "orange": 76.0,
    "yuzu": 68.0,
    "floral": 60.0
  },
  "amouage-interlude-53": {
    "incense": 100.0,
    "amber": 92.0,
    "leather": 84.0,
    "oud": 76.0,
    "spices": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0,
    "woody": 44.0,
    "dark": 36.0
  },
  "amouage-epic-56": {
    "cumin": 100.0,
    "pepper": 92.0,
    "cinnamon": 84.0,
    "geranium": 76.0,
    "tea": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "spiced-aromatic": 36.0
  },
  "amouage-sequence": {
    "lychee": 100.0,
    "berry": 92.0,
    "saffron": 84.0,
    "osmanthus": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "nvrnagn-discovery-kit": {},
  "nvrnagn-solitaire": {
    "amber": 100.0,
    "oud": 92.0,
    "patchouli": 84.0,
    "moss": 76.0,
    "coffee": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "dark": 28.0
  },
  "nvrnagn-reunion": {
    "fresh": 100.0,
    "floral": 92.0,
    "patchouli": 84.0,
    "musk": 76.0,
    "woody": 68.0,
    "earthy": 60.0,
    "dark": 52.0
  },
  "nvrnagn-paradis": {
    "earthy": 100.0,
    "honey": 92.0,
    "marine": 84.0,
    "fresh": 76.0,
    "gourmand": 68.0
  },
  "nvrnagn-festival": {
    "amber": 100.0,
    "balsamic": 92.0,
    "cedar": 84.0,
    "whiskey": 76.0,
    "boozy": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "dark": 44.0
  },
  "nvrnagn-deluge": {
    "fresh": 100.0,
    "floral": 92.0,
    "white-blossoms": 84.0,
    "musk": 76.0
  },
  "nvrnagn-lackerli": {
    "balsamic": 100.0,
    "wood": 92.0,
    "tonka": 84.0,
    "honey": 76.0,
    "almond": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0
  },
  "brandt-london-fog": {
    "bergamot": 100.0,
    "tea": 92.0,
    "smoky-notes": 84.0,
    "honey": 76.0,
    "lavender": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "floral": 36.0
  },
  "lepoque-serotonin-spritz": {
    "jasmine": 100.0,
    "musk": 92.0,
    "orange-blossom": 84.0,
    "floral": 76.0
  },
  "jovoy-psychedelique": {
    "citrus": 100.0,
    "patchouli": 92.0,
    "cistus": 84.0,
    "amber": 76.0,
    "geranium": 68.0,
    "fresh": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "dark": 28.0
  },
  "mind-games-olfactive-travel-set-fruity": {},
  "dannam-pho-breakfast": {
    "citrus": 100.0,
    "lime": 92.0,
    "hexagonal-frangipani": 84.0,
    "cedar": 76.0,
    "gaiac-wood": 68.0,
    "fresh": 60.0,
    "woody": 52.0
  },
  "mith-thai-tea-one-fine-day": {
    "tea": 100.0,
    "milk": 92.0,
    "lily-of-the-valley": 84.0,
    "vanilla": 76.0,
    "sandalwood": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "aromatic": 36.0,
    "tea-forward": 28.0
  },
  "mith-thai-pomelo-one-fine-day": {
    "cardamom": 100.0,
    "lavender": 92.0,
    "pepper": 84.0,
    "vanilla": 76.0,
    "nervous-neroli": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "mith-lemon-ice-tea-one-fine-day": {
    "grapefruit-zest": 100.0,
    "leather": 92.0,
    "lemon": 84.0,
    "orange": 76.0,
    "tea": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "dark": 44.0
  },
  "mith-horizon": {
    "amber": 100.0,
    "precious-woods": 92.0,
    "spices": 84.0,
    "virtual-violet": 76.0,
    "resin-smoke": 68.0,
    "spiced-aromatic": 60.0
  },
  "mith-golden-hour": {
    "mandarin": 100.0,
    "orange": 92.0,
    "lychee": 84.0,
    "orange-blossom": 76.0,
    "ylang-ylang": 68.0,
    "floral": 60.0
  },
  "mith-oud-and-black-tea": {
    "basil": 100.0,
    "cactus": 92.0,
    "cinnamon": 84.0,
    "date-palm": 76.0,
    "incense": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0
  },
  "mith-nude": {
    "bergamot": 100.0,
    "pear": 92.0,
    "peach": 84.0,
    "violet-leaves": 76.0,
    "peony": 68.0,
    "fruity": 60.0
  },
  "mith-the-odyssey": {
    "bergamot": 100.0,
    "lemon": 92.0,
    "cardamom": 84.0,
    "ginger": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "mith-blue-wood": {
    "bergamot": 100.0,
    "tea": 92.0,
    "lemon": 84.0,
    "seawater": 76.0,
    "angular-anise": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0
  },
  "mith-mystery-for-him": {
    "amber": 100.0,
    "bamboo": 92.0,
    "cedar": 84.0,
    "jasmine": 76.0,
    "musk": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0
  },
  "investi-parfums-the-architect": {
    "citrus": 100.0,
    "amber": 92.0,
    "floral": 84.0,
    "rose": 76.0,
    "jasmine": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "woody": 44.0,
    "earthy": 36.0,
    "resin-smoke": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "sora-dora-raphael": {
    "bergamot": 100.0,
    "lilac": 92.0,
    "orange-blossom": 84.0,
    "ylang": 76.0,
    "amber": 68.0,
    "resin-smoke": 60.0,
    "floral": 52.0
  },
  "amouage-journey-man": {
    "pepper": 100.0,
    "orange": 92.0,
    "cardamom": 84.0,
    "bergamot": 76.0,
    "neroli": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-remain": {
    "pimento": 100.0,
    "bergamot": 92.0,
    "orange": 84.0,
    "omani-green-frankincense": 76.0,
    "carrot": 68.0
  },
  "amouage-meander": {
    "carrot": 100.0,
    "pepper": 92.0,
    "incense": 84.0,
    "orris-root": 76.0,
    "cypriol": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-existence": {
    "lily-of-the-valley": 100.0,
    "rose": 92.0,
    "mystikal": 84.0,
    "incense": 76.0,
    "balsamic": 68.0,
    "resin-smoke": 60.0,
    "floral": 52.0
  },
  "amouage-love-delight": {
    "ginger": 100.0,
    "rose": 92.0,
    "cinnamon": 84.0,
    "orange": 76.0,
    "heliotrope": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-epic-man": {
    "incense": 100.0,
    "pepper": 92.0,
    "cardamom": 84.0,
    "myrtle": 76.0,
    "clove": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "amouage-opus-xvi-timber": {
    "cardamom": 100.0,
    "juniper": 92.0,
    "chocolate": 84.0,
    "pepper": 76.0,
    "pine": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-lyric-man": {
    "lime": 100.0,
    "bergamot": 92.0,
    "rose": 84.0,
    "angelica": 76.0,
    "galbanum": 68.0,
    "floral": 60.0
  },
  "amouage-discovery-kit": {},
  "june-thirtieth-serene-santal": {
    "apple": 100.0,
    "lemon": 92.0,
    "mint": 84.0,
    "nervous-neroli": 76.0,
    "pepper": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "june-thirtieth-vanillas-muse": {
    "caribbean-amyris": 100.0,
    "brazilian-tonka-bean-absolute": 92.0,
    "florentine-iris": 84.0,
    "orange": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "june-thirtieth-og": {
    "citrus": 100.0,
    "blossoms": 92.0,
    "pepper": 84.0,
    "flixzampuron": 76.0,
    "balsamic": 68.0,
    "fresh": 60.0,
    "resin-smoke": 52.0,
    "spiced-aromatic": 44.0
  },
  "bdk-parfums-rouge-smoking-extrait": {
    "royal-ann-cherry": 100.0,
    "almond": 92.0,
    "elemi-resin": 84.0,
    "pepper": 76.0,
    "orange": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "bdk-parfums-pas-ce-soir-extrait": {
    "pear": 100.0,
    "ginger": 92.0,
    "pepper": 84.0,
    "chocolate": 76.0,
    "orange": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "bdk-parfums-tubereuse-imperial": {
    "egyptian-geranium": 100.0,
    "pepper": 92.0,
    "rose": 84.0,
    "comorian-ylang-ylang": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "bdk-parfums-velvet-tonka": {
    "almond": 100.0,
    "orange-blossom": 92.0,
    "balkans-tobacco-absolute": 84.0,
    "rose": 76.0,
    "tonka-bean-absolute": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "bdk-parfums-312-saint-honore": {
    "pepper": 100.0,
    "french-angelica-root": 92.0,
    "iris": 84.0,
    "orange-blossom": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-silver-oud": {
    "cypriol": 100.0,
    "patchouli": 92.0,
    "cedar": 84.0,
    "oud": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "resin-smoke": 36.0,
    "dark": 28.0
  },
  "roja-burlington-1819": {
    "amber": 100.0,
    "plum": 92.0,
    "vanilla": 84.0,
    "hexagonal-frangipani": 76.0,
    "gourmand": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0
  },
  "roja-a-midsummer-dream": {
    "sweet-violet": 100.0,
    "mountain-bluebell": 92.0,
    "aquatic-notes": 84.0,
    "moss": 76.0,
    "oak-leaf": 68.0,
    "earthy": 60.0
  },
  "roja-nuwa": {
    "apple": 100.0,
    "grapefruit": 92.0,
    "lime": 84.0,
    "mint": 76.0,
    "pepper": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "roja-isola-verde": {
    "bergamot": 100.0,
    "clove": 92.0,
    "pepper": 84.0,
    "sage": 76.0,
    "violet-leaf": 68.0,
    "aromatic": 60.0,
    "spiced-aromatic": 52.0
  },
  "roja-oceania": {
    "neroli-absolute": 100.0
  },
  "roja-isola-blu": {
    "candied-fruits": 100.0,
    "orange": 92.0,
    "pepper": 84.0,
    "parallel-patchouli": 76.0,
    "almond": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "roja-serenity-blend": {
    "amber": 100.0,
    "bergamot": 92.0,
    "birch-tar": 84.0,
    "galbanum": 76.0,
    "leather": 68.0,
    "resin-smoke": 60.0,
    "dark": 52.0
  },
  "roja-elysium-pour-femme": {
    "sweet": 100.0,
    "molasses": 92.0,
    "butter": 84.0,
    "cinnamon": 76.0,
    "clove": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "roja-elysium-pour-homme": {
    "bergamot": 100.0,
    "pineapple": 92.0,
    "simulated-suede": 84.0,
    "jasmine": 76.0,
    "musk": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "les-indemodables-cafe-arabesque": {
    "orchid": 100.0,
    "orange": 92.0,
    "tangerine": 84.0,
    "heliotrope": 76.0,
    "tropical": 68.0,
    "fruity": 60.0
  },
  "rania-j-sharyar": {
    "grapefruit": 100.0,
    "lemon": 92.0,
    "conjugated-labdanum": 84.0,
    "patchouli": 76.0,
    "vetiver": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "dark": 44.0
  },
  "rania-j-oud-assam": {
    "bergamot": 100.0,
    "orange": 92.0,
    "oud": 84.0,
    "india": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "dark": 44.0
  },
  "rania-j-veliatte-extrait": {
    "bergamot": 100.0,
    "orange": 92.0,
    "lemon": 84.0,
    "lavender": 76.0,
    "beeswax": 68.0,
    "aromatic": 60.0,
    "floral": 52.0
  },
  "fugazzi-angel-dust": {
    "caribbean-amyris": 100.0,
    "brazilian-tonka-bean-absolute": 92.0,
    "moss": 84.0,
    "florentine-iris": 76.0,
    "orange": 68.0,
    "earthy": 60.0
  },
  "27-9-cammeo": {
    "apple-peel": 100.0,
    "pepper": 92.0,
    "apple": 84.0,
    "jasmine": 76.0,
    "lily-of-the-valley": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "27-9-lapel": {
    "bergamot": 100.0,
    "pineapple": 92.0,
    "pepper": 84.0,
    "orange": 76.0,
    "red-thyme": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "27-9-velour": {
    "caramelized-almond": 100.0,
    "cardamom": 92.0,
    "sri-lankan-cinnamon": 84.0,
    "rose": 76.0,
    "cognac": 68.0,
    "floral": 60.0,
    "boozy": 52.0,
    "spiced-aromatic": 44.0
  },
  "borntostandout-drunk-lovers-extrait-extreme": {
    "bergamot": 100.0,
    "clary-sage": 92.0,
    "red-wine": 84.0,
    "wine-lees": 76.0,
    "brandy": 68.0
  },
  "city-rhythm-san-diego": {
    "bay-rum": 100.0,
    "floral": 92.0,
    "leather": 84.0,
    "musk": 76.0,
    "spices": 68.0,
    "spiced-aromatic": 60.0,
    "dark": 52.0
  },
  "city-rhythm-marthas-vineyard": {
    "apple": 100.0,
    "orange-blossom": 92.0,
    "floral": 84.0,
    "fruity": 76.0
  },
  "house-of-bo-casa-blanca": {
    "mineral": 100.0,
    "tea": 92.0,
    "balsamic": 84.0,
    "copal-blanco": 76.0,
    "desert-fig": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0
  },
  "house-of-la-mar": {
    "iris": 100.0,
    "leather": 92.0,
    "orange": 84.0,
    "rose": 76.0,
    "hempzidralok": 68.0,
    "floral": 60.0,
    "dark": 52.0
  },
  "house-of-bo-rosario": {
    "berry": 100.0,
    "blood": 92.0,
    "red-plum": 84.0,
    "simulated-suede": 76.0,
    "fruity": 68.0
  },
  "house-of-bo-bombom": {
    "bergamot": 100.0,
    "lemon-zest": 92.0,
    "pear": 84.0,
    "freesia": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "house-of-bo-cosmos": {
    "bergamot": 100.0,
    "coconut": 92.0,
    "rose": 84.0,
    "palestinian-sweet-lime": 76.0,
    "suede": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "dark": 44.0
  },
  "house-of-bo-ave-maria": {
    "apricot": 100.0,
    "berry": 92.0,
    "rotated-resins": 84.0,
    "fruity": 76.0
  },
  "house-of-bo-xuxu": {
    "tea": 100.0,
    "osmanthus": 92.0,
    "patchouli": 84.0,
    "hypothetical-heliotrope": 76.0,
    "bergamot": 68.0,
    "fresh": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "aromatic": 36.0,
    "tea-forward": 28.0,
    "floral": 20.0,
    "dark": 12.0
  },
  "nissaba-discovery-kit": {
    "amber": 100.0,
    "woody": 92.0,
    "tea": 84.0,
    "aromatic": 76.0,
    "fresh": 68.0,
    "resin-smoke": 60.0
  },
  "nissaba-grand-ile": {
    "madonna-lily": 100.0,
    "oriental-lily": 92.0,
    "ghost-galbanum": 84.0,
    "candle-wax": 76.0,
    "cotton": 68.0
  },
  "nissaba-tierra-maya": {
    "iris": 100.0,
    "oud": 92.0,
    "woody": 84.0,
    "resin-smoke": 76.0,
    "floral": 68.0,
    "dark": 60.0
  },
  "nissaba-chaco": {
    "pimento": 100.0,
    "pepper": 92.0,
    "plum": 84.0,
    "comorian-ylang-ylang": 76.0,
    "iris": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "nissaba-les-alpes-extrait": {
    "fresh": 100.0,
    "balsamic": 92.0,
    "thyme": 84.0,
    "rosemary": 76.0,
    "berry": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "resin-smoke": 36.0,
    "fruity": 28.0,
    "spiced-aromatic": 20.0,
    "dark": 12.0
  },
  "fugazzi-workaholic-extrait": {
    "amber": 100.0,
    "rose": 92.0,
    "orange": 84.0,
    "sandalwood": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0,
    "spiced-aromatic": 28.0
  },
  "fugazzi-orange-crush-extrait": {
    "orange": 100.0,
    "citrus": 92.0,
    "bergamot": 84.0,
    "berry": 76.0,
    "iso-e-super": 68.0,
    "fresh": 60.0,
    "fruity": 52.0
  },
  "fugazzi-vanilla-haze-extrait": {
    "sandalwood": 100.0,
    "tonka": 92.0,
    "vanilla": 84.0,
    "gourmand": 76.0,
    "woody": 68.0
  },
  "fugazzi-pomegranoudh-extrait": {
    "pomegranate": 100.0,
    "red-fruits": 92.0,
    "bergamot": 84.0,
    "oud": 76.0,
    "patchouli": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "dark": 36.0
  },
  "fugazzi-angel-dust-extrait": {
    "aglaia": 100.0,
    "black-sea-salt": 92.0,
    "charcoal": 84.0,
    "clary-sage": 76.0,
    "oud": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "dark": 44.0
  },
  "fugazzi-vanilla-haze": {
    "peach": 100.0,
    "tagetes": 92.0,
    "forgotten-frankincense": 84.0,
    "cedar": 76.0,
    "clove": 68.0,
    "woody": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "fugazzi-orange-crush": {
    "bergamot": 100.0,
    "clove": 92.0,
    "spices": 84.0,
    "vanilla": 76.0,
    "freesia": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "fugazzi-sugar-daddy-extrait": {
    "tangerine": 100.0,
    "bergamot": 92.0,
    "berry": 84.0,
    "clove": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "fugazzi-passionfroudh-extrait": {
    "passionfruit": 100.0,
    "mango": 92.0,
    "tea": 84.0,
    "ginger": 76.0,
    "pepper": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "fugazzi-best-seller-discovery-kit": {},
  "le-persona-salty-skin": {
    "cistus-absolute": 100.0,
    "spritz-veneziano": 92.0,
    "rose": 84.0,
    "vetiver": 76.0,
    "saffron": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "le-persona-whispering-kiss": {
    "clove": 100.0,
    "rilthondexum": 92.0,
    "spiced-aromatic": 84.0
  },
  "le-persona-masquerade-ball": {
    "bergamot": 100.0,
    "lavender": 92.0,
    "lemon": 84.0,
    "patchouli": 76.0,
    "proven-al-blossoms": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "aromatic": 44.0,
    "floral": 36.0,
    "dark": 28.0
  },
  "le-persona-lp04-golden-gym": {
    "bergamot": 100.0,
    "cardamom-oil-guatemala": 92.0,
    "rose": 84.0,
    "cedar": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "floral": 44.0
  },
  "le-persona-lp03-wooden-face": {
    "tea": 100.0,
    "cardamom": 92.0,
    "orange": 84.0,
    "fig": 76.0,
    "pear": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "tea-forward": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0
  },
  "le-persona-lp02-peacock-feather": {
    "lime": 100.0,
    "bergamot": 92.0,
    "lemon": 84.0,
    "lavender": 76.0,
    "white-blossoms": 68.0,
    "aromatic": 60.0,
    "floral": 52.0
  },
  "le-persona-lp01-mystic-rose": {
    "white-peony": 100.0,
    "rose": 92.0,
    "pepper": 84.0,
    "jasmine": 76.0,
    "golden-amber": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "tada-parfumeur-itim-kati": {
    "amber": 100.0,
    "basil": 92.0,
    "pepper": 84.0,
    "pine": 76.0,
    "juniper": 68.0,
    "woody": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0
  },
  "tada-parfumeur-sugidama": {
    "floral": 100.0,
    "musk": 92.0,
    "calcified-cypress": 84.0
  },
  "tada-parfumeur-iyokan": {
    "orange": 100.0,
    "mango": 92.0,
    "vetiver": 84.0,
    "woody": 76.0,
    "earthy": 68.0,
    "fruity": 60.0,
    "dark": 52.0
  },
  "tada-parfumeur-vanilla-mystique": {
    "green-cognac": 100.0,
    "rose": 92.0,
    "vanilla": 84.0,
    "simulated-suede": 76.0,
    "gourmand": 68.0,
    "floral": 60.0
  },
  "tada-parfumeur-lamoon": {
    "cardamom": 100.0,
    "coriander": 92.0,
    "lemon": 84.0,
    "virtual-violet": 76.0,
    "absinthe-wormwood": 68.0,
    "spiced-aromatic": 60.0
  },
  "tada-parfumeur-gyokuro": {
    "butterscotch": 100.0,
    "chrysanthemum": 92.0,
    "lilac": 84.0,
    "patchouli": 76.0,
    "pumpkin": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "dark": 44.0
  },
  "tada-parfumeur-akatsuki": {
    "berry": 100.0,
    "orange": 92.0,
    "pepper": 84.0,
    "branched-benzoin": 76.0,
    "amber": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "tada-parfumeur-lost-in-a-fluffy-nest": {
    "bulgarian-lavender": 100.0,
    "cardamom": 92.0,
    "ceylonese-cinnamon": 84.0,
    "clove": 76.0,
    "egyptian-geranium": 68.0,
    "spiced-aromatic": 60.0
  },
  "gallivant-nida": {
    "violet": 100.0,
    "foug-re-notes": 92.0,
    "woody": 84.0,
    "urpzilthnomex": 76.0,
    "floral": 68.0
  },
  "room-1015-sweet-leaf": {
    "amyris": 100.0,
    "boronia": 92.0,
    "pine": 84.0,
    "berry": 76.0,
    "yuzu": 68.0,
    "woody": 60.0,
    "fruity": 52.0
  },
  "room-1015-purple-mantra": {
    "blueberry": 100.0,
    "maple-syrup": 92.0,
    "pancake": 84.0,
    "syrup": 76.0
  },
  "room-1015-jasmine-freak": {
    "cardamom": 100.0,
    "grapefruit": 92.0,
    "mint": 84.0,
    "jasmine": 76.0,
    "pepper": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "room-1015-wasabi-klub": {
    "mimosa": 100.0,
    "orange": 92.0,
    "neroli": 84.0,
    "green-notes": 76.0,
    "precious-woods": 68.0,
    "floral": 60.0
  },
  "third-eye-fragrance-flamango": {
    "akigalawood": 100.0,
    "apricot": 92.0,
    "cucumber": 84.0,
    "italian-bergamot": 76.0,
    "precious-woods": 68.0,
    "fruity": 60.0
  },
  "city-rhythm-key-west": {
    "leaves": 100.0,
    "bifurcated-vetiver": 92.0,
    "jasmine": 84.0,
    "tomato": 76.0,
    "oud": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "dark": 36.0
  },
  "amouage-decision": {
    "incense": 100.0,
    "balsamic": 100.0,
    "cardamom": 91.48,
    "bergamot": 91.48,
    "pepper": 84.87,
    "gourmand": 56.4,
    "woody": 80.7,
    "aromatic": 91.48,
    "resin-smoke": 100.0,
    "spiced-aromatic": 91.48
  },
  "amouage-jubilation-40": {
    "balsamic": 100.0,
    "incense": 100.0,
    "patchouli": 79.16,
    "cedar": 79.16,
    "berry": 66.33,
    "gourmand": 64.8,
    "woody": 79.16,
    "earthy": 79.16,
    "aromatic": 55.32,
    "resin-smoke": 100.0,
    "fruity": 66.33,
    "spiced-aromatic": 64.8,
    "dark": 79.16
  },
  "amouage-beach-hut-man": {
    "vetiver": 75.09,
    "woody": 75.09,
    "patchouli": 75.09,
    "moss": 48.05,
    "mint": 40.0,
    "fresh": 100.0,
    "earthy": 75.09,
    "aromatic": 74.35,
    "dark": 75.09
  },
  "lost-tribe-santal-absolu": {
    "balsamic": 100.0,
    "oud": 92.0,
    "floral": 84.0,
    "rose": 76.0,
    "iris": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "aromatic": 36.0,
    "resin-smoke": 28.0,
    "fruity": 20.0,
    "dark": 12.0
  },
  "lost-tribe-watch-king": {
    "fig-leaf": 100.0,
    "milk": 92.0,
    "petitgrain-sur-fleurs": 84.0,
    "orange": 76.0,
    "violet-leaf-absolute": 68.0,
    "gourmand": 60.0
  },
  "lost-tribe-rock-star": {
    "sandalwood": 100.0,
    "amber": 76.1,
    "vanilla": 67.56,
    "banana": 40.0,
    "cognac": 39.0,
    "gourmand": 67.56,
    "woody": 100.0,
    "resin-smoke": 76.1,
    "floral": 71.4,
    "boozy": 39.0,
    "fruity": 60.73,
    "spiced-aromatic": 71.4
  },
  "lost-tribe-pop-star": {
    "sandalwood": 100.0,
    "amber": 76.1,
    "vanilla": 67.56,
    "banana": 40.0,
    "cognac": 39.0,
    "gourmand": 67.56,
    "woody": 100.0,
    "resin-smoke": 76.1,
    "floral": 71.4,
    "boozy": 39.0,
    "fruity": 60.73,
    "spiced-aromatic": 71.4
  },
  "meo-fusciuni-sogni": {
    "cedar": 100.0,
    "sandalwood": 100.0,
    "vetiver": 100.0,
    "incense": 48.86,
    "amber": 48.86,
    "woody": 100.0,
    "earthy": 100.0,
    "resin-smoke": 48.86,
    "dark": 100.0
  },
  "meo-fusciuni-last-season": {
    "vetiver": 100.0,
    "patchouli": 100.0,
    "cedar": 100.0,
    "sandalwood": 100.0,
    "leather": 80.77,
    "fresh": 60.68,
    "woody": 100.0,
    "earthy": 100.0,
    "aromatic": 78.79,
    "resin-smoke": 60.58,
    "spiced-aromatic": 63.77,
    "dark": 100.0
  },
  "meo-fusciuni-little-song": {
    "musk": 100.0,
    "coffee": 89.41,
    "tobacco": 80.02,
    "rose": 75.41,
    "pepper": 65.64,
    "gourmand": 89.41,
    "woody": 56.82,
    "aromatic": 60.75,
    "floral": 75.41,
    "spiced-aromatic": 65.64,
    "dark": 80.02
  },
  "meo-fusciuni-isola": {
    "yuzu": 100.0,
    "lemon": 100.0,
    "bergamot": 100.0,
    "mandarin": 100.0,
    "neroli": 100.0,
    "fresh": 100.0,
    "aromatic": 57.43,
    "floral": 100.0
  },
  "meo-fusciuni-varanasi": {
    "leather": 100.0,
    "incense": 80.99,
    "amber": 80.99,
    "pine": 64.8,
    "vetiver": 64.8,
    "woody": 64.8,
    "oud": 61.17,
    "earthy": 64.8,
    "resin-smoke": 80.99,
    "spiced-aromatic": 63.71,
    "dark": 100.0
  },
  "meo-fusciuni-narcotico": {
    "incense": 100.0,
    "balsamic": 100.0,
    "patchouli": 82.79,
    "oud": 65.62,
    "tonka": 62.89,
    "gourmand": 62.89,
    "woody": 82.79,
    "earthy": 82.79,
    "resin-smoke": 100.0,
    "spiced-aromatic": 88.46,
    "dark": 82.79
  },
  "meo-fusciuni-2-nota-di-viaggio": {
    "tobacco": 55.27,
    "mint": 40.0,
    "lemongrass": 38.0,
    "chamomile": 37.0,
    "fresh": 100.0,
    "aromatic": 80.08,
    "spiced-aromatic": 66.48,
    "dark": 55.27
  },
  "meo-fusciuni-viole-nere": {
    "violet": 100.0,
    "iris": 100.0,
    "musk": 100.0,
    "sandalwood": 99.43,
    "patchouli": 99.43,
    "woody": 99.43,
    "earthy": 99.43,
    "floral": 100.0,
    "dark": 99.43
  },
  "zernell-gillie-rock": {
    "ginger": 100.0,
    "citrus": 100.0,
    "lime": 100.0,
    "yuzu": 100.0,
    "apple": 62.24,
    "fresh": 100.0,
    "fruity": 62.24,
    "spiced-aromatic": 100.0
  },
  "brandt-guava-sorbet-elixir": {
    "passionfruit": 100.0,
    "bergamot": 93.64,
    "mandarin": 93.64,
    "vanilla": 72.42,
    "musk": 69.24,
    "fresh": 93.64,
    "gourmand": 72.42,
    "floral": 69.24,
    "fruity": 100.0
  },
  "city-rhythm-savannah": {
    "tropical": 73.21,
    "musk": 56.79,
    "amber": 47.28,
    "grapefruit": 45.56,
    "peach": 40.0,
    "gourmand": 55.49,
    "resin-smoke": 47.28,
    "floral": 56.79,
    "fruity": 100.0
  },
  "lorenzo-pazzaglia-tropikalys-karma": {
    "pineapple": 100.0,
    "apple": 100.0,
    "mango": 100.0,
    "coconut": 87.02,
    "milk": 75.73,
    "gourmand": 87.02,
    "fruity": 100.0
  },
  "lorenzo-pazzaglia-gin-fusion": {
    "lime": 100.0,
    "lemon": 100.0,
    "yuzu": 100.0,
    "orange": 100.0,
    "bergamot": 100.0,
    "fresh": 100.0,
    "aromatic": 65.53,
    "spiced-aromatic": 100.0
  },
  "dorsay-l-b": {
    "bergamot": 100.0,
    "lemon": 100.0,
    "orange-blossom": 100.0,
    "neroli": 100.0,
    "iris": 78.39,
    "fresh": 100.0,
    "woody": 71.02,
    "earthy": 59.32,
    "resin-smoke": 57.44,
    "floral": 100.0
  },
  "srhy-flower-s": {
    "amber": 100.0,
    "leaves": 92.0,
    "peach": 84.0,
    "jilthzorpanex": 76.0,
    "resin-smoke": 68.0,
    "fruity": 60.0
  },
  "srhy-air-of-the-forest": {
    "french-lavender": 100.0,
    "marshmallow": 92.0,
    "passionfruit": 84.0,
    "fruity": 76.0
  },
  "srhy-meet-joplin": {
    "lime": 100.0,
    "lemon": 92.0,
    "bergamot": 84.0,
    "peach": 76.0,
    "orange": 68.0,
    "fruity": 60.0
  },
  "srhy-basting-day": {
    "fresh": 100.0
  },
  "srhy-believe-in-capitalism": {
    "amber": 100.0,
    "red-apple": 92.0,
    "inverse-incense": 84.0,
    "resin-smoke": 76.0
  },
  "srhy-series-a": {
    "grass": 100.0,
    "pear": 92.0,
    "humdraxpelum": 84.0,
    "neroli": 76.0,
    "orange-blossom": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "giardini-di-toscana-borabora": {
    "jasmine": 100.0,
    "apricot": 88.63,
    "coconut": 88.63,
    "vanilla": 88.63,
    "caramel": 88.63,
    "gourmand": 88.63,
    "floral": 100.0,
    "fruity": 88.63
  },
  "loumari-discovery-set": {},
  "loumari-saja": {
    "rose": 100.0,
    "pepper": 89.06,
    "saffron": 89.06,
    "amber": 89.06,
    "incense": 73.91,
    "gourmand": 61.25,
    "woody": 70.63,
    "oud": 70.63,
    "resin-smoke": 89.06,
    "floral": 100.0,
    "fruity": 64.77,
    "spiced-aromatic": 89.06
  },
  "loumari-radanfor": {
    "incense": 100.0,
    "balsamic": 100.0,
    "cardamom": 99.24,
    "pepper": 99.24,
    "vanilla": 85.8,
    "gourmand": 85.8,
    "aromatic": 72.74,
    "resin-smoke": 100.0,
    "floral": 78.95,
    "spiced-aromatic": 99.24
  },
  "loumari-noble-cavale": {
    "pine": 100.0,
    "vetiver": 100.0,
    "sandalwood": 100.0,
    "bergamot": 91.52,
    "cardamom": 91.52,
    "fresh": 65.99,
    "woody": 100.0,
    "earthy": 100.0,
    "aromatic": 91.52,
    "spiced-aromatic": 91.52,
    "dark": 100.0
  },
  "loumari-maydan": {
    "cinnamon": 100.0,
    "saffron": 100.0,
    "amber": 100.0,
    "pepper": 100.0,
    "patchouli": 93.56,
    "gourmand": 100.0,
    "woody": 93.56,
    "earthy": 93.56,
    "aromatic": 85.78,
    "resin-smoke": 100.0,
    "fruity": 80.22,
    "spiced-aromatic": 100.0,
    "dark": 93.56
  },
  "loumari-aomak": {
    "orange": 100.0,
    "mandarin": 100.0,
    "ginger": 100.0,
    "neroli": 100.0,
    "cardamom": 67.42,
    "fresh": 100.0,
    "aromatic": 67.42,
    "floral": 100.0,
    "spiced-aromatic": 100.0
  },
  "loumari-amber-malatya": {
    "sandalwood": 100.0,
    "patchouli": 100.0,
    "balsamic": 91.17,
    "apricot": 76.89,
    "leather": 73.84,
    "woody": 100.0,
    "earthy": 100.0,
    "resin-smoke": 91.17,
    "floral": 63.98,
    "fruity": 76.89,
    "spiced-aromatic": 68.06,
    "dark": 100.0
  },
  "loumari-almeria": {
    "pepper": 100.0,
    "orange": 88.74,
    "almond": 83.03,
    "cinnamon": 83.03,
    "tobacco": 83.03,
    "fresh": 88.74,
    "gourmand": 83.03,
    "woody": 76.75,
    "floral": 69.16,
    "spiced-aromatic": 100.0,
    "dark": 83.03
  },
  "loumari-porthole": {
    "pineapple": 100.0,
    "passionfruit": 100.0,
    "caramel": 96.25,
    "sea-salt": 73.01,
    "bergamot": 73.01,
    "fresh": 73.01,
    "gourmand": 96.25,
    "fruity": 100.0,
    "spiced-aromatic": 56.02
  },
  "kerosene-with-angels-and-archangels": {
    "incense": 100.0,
    "cedar": 89.63,
    "sandalwood": 89.63,
    "rose": 85.56,
    "musk": 47.78,
    "woody": 89.63,
    "resin-smoke": 100.0,
    "floral": 85.56,
    "spiced-aromatic": 68.52
  },
  "borntostandout-black-guava": {
    "oud": 87.44,
    "mandarin": 75.2,
    "patchouli": 70.37,
    "rose": 66.23,
    "cardamom": 64.22,
    "fresh": 75.2,
    "woody": 87.44,
    "earthy": 70.37,
    "resin-smoke": 87.44,
    "floral": 66.23,
    "fruity": 100.0,
    "spiced-aromatic": 64.22,
    "dark": 87.44
  },
  "borntostandout-black-mango": {
    "mango": 100.0,
    "orange": 89.56,
    "vanilla": 89.56,
    "oud": 81.36,
    "pine": 74.53,
    "gourmand": 89.56,
    "woody": 81.36,
    "resin-smoke": 81.36,
    "floral": 59.74,
    "fruity": 100.0,
    "dark": 81.36
  },
  "borntostandout-drink-milk": {
    "caramel": 100.0,
    "milk": 100.0,
    "vanilla": 100.0,
    "tonka": 100.0,
    "iris": 59.09,
    "gourmand": 100.0,
    "woody": 56.72,
    "floral": 59.09
  },
  "borntostandout-drunk-maple": {
    "rum": 100.0,
    "coffee": 100.0,
    "vanilla": 100.0,
    "sandalwood": 89.11,
    "pepper": 62.41,
    "gourmand": 100.0,
    "woody": 89.11,
    "boozy": 100.0,
    "spiced-aromatic": 62.41
  },
  "borntostandout-fig-porn": {
    "fig": 100.0,
    "pear": 100.0,
    "vanilla": 83.2,
    "cedar": 74.62,
    "sandalwood": 74.62,
    "fresh": 100.0,
    "gourmand": 83.2,
    "woody": 74.62,
    "floral": 66.77,
    "fruity": 100.0
  },
  "borntostandout-drunk-saffron": {
    "saffron": 100.0,
    "vanilla": 76.78,
    "coffee": 69.86,
    "patchouli": 68.61,
    "leather": 67.94,
    "gourmand": 76.78,
    "woody": 68.61,
    "earthy": 68.61,
    "fruity": 70.05,
    "spiced-aromatic": 100.0,
    "dark": 68.61
  },
  "borntostandout-drunk-lovers": {
    "pine": 100.0,
    "sandalwood": 100.0,
    "cedar": 100.0,
    "patchouli": 100.0,
    "vetiver": 100.0,
    "gourmand": 80.38,
    "woody": 100.0,
    "earthy": 100.0,
    "aromatic": 68.43,
    "resin-smoke": 80.38,
    "floral": 58.96,
    "fruity": 55.95,
    "spiced-aromatic": 80.38,
    "dark": 100.0
  },
  "borntostandout-indecent-cherry": {
    "cherry": 100.0,
    "almond": 99.69,
    "berry": 99.69,
    "vanilla": 99.69,
    "amber": 52.99,
    "gourmand": 99.69,
    "resin-smoke": 52.99,
    "fruity": 100.0
  },
  "borntostandout-dirty-rice": {
    "sandalwood": 100.0,
    "cedar": 100.0,
    "vetiver": 100.0,
    "milk": 83.34,
    "musk": 78.14,
    "gourmand": 83.34,
    "woody": 100.0,
    "earthy": 100.0,
    "floral": 72.35,
    "dark": 100.0
  },
  "borntostandout-sugar-addict": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "rum": 95.31,
    "cinnamon": 95.31,
    "chocolate": 95.31,
    "gourmand": 100.0,
    "woody": 56.84,
    "resin-smoke": 77.75,
    "boozy": 95.31,
    "spiced-aromatic": 95.31
  },
  "lepoque-dopamine-rose": {
    "berry": 100.0,
    "rose": 98.59,
    "ozonic": 91.85,
    "rhubarb": 39.0,
    "marshmallow": 37.0,
    "fresh": 91.85,
    "gourmand": 83.69,
    "floral": 98.59,
    "fruity": 100.0
  },
  "lepoque-inner-child": {
    "bergamot": 66.66,
    "vanilla": 65.59,
    "linen": 40.0,
    "freesia": 38.0,
    "lily-of-the-valley": 36.0,
    "fresh": 66.66,
    "gourmand": 65.59,
    "floral": 100.0
  },
  "mind-games-kingside": {
    "almond": 100.0,
    "pine": 81.74,
    "milk": 71.15,
    "rum": 57.17,
    "tonka": 57.17,
    "gourmand": 100.0,
    "woody": 81.74,
    "resin-smoke": 59.29,
    "boozy": 57.17
  },
  "pernoire-mansa": {
    "oud": 100.0,
    "iris": 91.35,
    "musk": 91.35,
    "rose": 86.69,
    "pepper": 69.12,
    "woody": 100.0,
    "earthy": 66.99,
    "resin-smoke": 100.0,
    "floral": 91.35,
    "fruity": 67.26,
    "spiced-aromatic": 73.23,
    "dark": 100.0
  },
  "pernoire-kama": {
    "leather": 100.0,
    "iris": 78.87,
    "violet": 78.87,
    "musk": 78.87,
    "wood": 66.14,
    "gourmand": 89.5,
    "woody": 66.14,
    "earthy": 56.79,
    "resin-smoke": 55.31,
    "floral": 78.87,
    "fruity": 75.77,
    "dark": 100.0
  },
  "pernoire-naki": {
    "passionfruit": 100.0,
    "vanilla": 89.37,
    "white-blossoms": 67.05,
    "sandalwood": 62.72,
    "musk": 52.55,
    "fresh": 96.79,
    "gourmand": 89.37,
    "woody": 62.72,
    "floral": 67.05,
    "fruity": 100.0
  },
  "pernoire-oudian": {
    "oud": 100.0,
    "saffron": 98.98,
    "leather": 98.98,
    "tropical": 86.34,
    "incense": 82.93,
    "woody": 100.0,
    "resin-smoke": 100.0,
    "fruity": 86.34,
    "spiced-aromatic": 98.98,
    "dark": 100.0
  },
  "dannam-spring-festival": {
    "mandarin": 90.0,
    "tanghulu": 40.0,
    "plum": 39.0,
    "red-lantern": 38.0,
    "plum-blossom": 37.0,
    "fresh": 90.0,
    "floral": 100.0,
    "fruity": 56.0
  },
  "dannam-the-silk-road": {
    "tobacco": 100.0,
    "leather": 64.29,
    "vetiver": 53.0,
    "spices": 39.0,
    "ginseng": 36.0,
    "gourmand": 65.0,
    "woody": 53.0,
    "earthy": 53.0,
    "spiced-aromatic": 76.0,
    "dark": 100.0
  },
  "dannam-moonlight-samurai": {
    "leather": 100.0,
    "cedar": 70.1,
    "sake": 54.21,
    "floral": 37.0,
    "woody": 70.1,
    "aromatic": 64.27,
    "dark": 100.0
  },
  "dannam-da-lat": {
    "cardamom": 100.0,
    "leather": 92.0,
    "oud": 84.0,
    "powder": 76.0,
    "woody": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0,
    "dark": 44.0
  },
  "dannam-sakura-snow": {
    "bergamot": 100.0,
    "chinotto": 92.0,
    "pineapple": 84.0,
    "zempfrixdolam": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "dannam-arashiyama": {
    "bamboo-leaves": 100.0,
    "fresh-grass": 92.0,
    "rain-notes": 84.0,
    "violet": 76.0,
    "bamboo-wood": 68.0,
    "floral": 60.0
  },
  "dannam-chinese-moon-cake": {
    "cinnamon": 100.0,
    "rum": 92.0,
    "pepper": 84.0,
    "cognac": 76.0,
    "ginger": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "spiced-aromatic": 44.0
  },
  "dannam-chinese-caligraphy": {
    "geranium": 100.0,
    "pine": 92.0,
    "rosemary": 84.0,
    "blorkzanthumer": 76.0,
    "lily-of-the-valley": 68.0,
    "woody": 60.0,
    "aromatic": 52.0
  },
  "dannam-monsoon-tea": {
    "orange": 100.0,
    "grapefruit": 92.0,
    "lemon": 84.0,
    "jasminum-grandiflorum": 76.0,
    "vextronplibar": 68.0
  },
  "dannam-tokyo-nights": {
    "sandalwood": 100.0,
    "cinnamon": 92.0,
    "bengal-nagarmotha": 84.0,
    "oud": 76.0,
    "cardamom": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "chris-collins-lust": {
    "dark-chocolate": 100.0,
    "almond": 92.0,
    "walnut": 84.0,
    "orris-concrete": 76.0,
    "balsamic": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "chris-collins-kingmaker": {
    "pine": 100.0,
    "oud": 100.0,
    "patchouli": 100.0,
    "sandalwood": 100.0,
    "cardamom": 60.08,
    "woody": 100.0,
    "earthy": 100.0,
    "resin-smoke": 100.0,
    "spiced-aromatic": 60.08,
    "dark": 100.0
  },
  "chris-collins-harlem-nights": {
    "patchouli": 100.0,
    "cedar": 100.0,
    "sandalwood": 100.0,
    "vetiver": 100.0,
    "saffron": 92.04,
    "woody": 100.0,
    "earthy": 100.0,
    "floral": 70.01,
    "boozy": 64.59,
    "spiced-aromatic": 92.04,
    "dark": 100.0
  },
  "chris-collins-lost-in-paradise": {
    "musk": 100.0,
    "wild-orchid": 92.0,
    "peach-skin": 84.0,
    "ylang": 76.0,
    "coconut": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "chris-collins-vide-cor-meum": {
    "thyme": 100.0,
    "bergamot": 92.0,
    "incense": 84.0,
    "rose": 76.0,
    "cedar": 68.0,
    "woody": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0
  },
  "chris-collins-villain": {
    "fresh": 71.18,
    "gourmand": 62.94,
    "woody": 71.18,
    "oud": 67.06,
    "aromatic": 100.0,
    "resin-smoke": 71.18,
    "spiced-aromatic": 62.94,
    "dark": 71.18
  },
  "chris-collins-forbidden-apple": {
    "sweet": 100.0,
    "berry": 100.0,
    "cinnamon": 100.0,
    "vanilla": 100.0,
    "pine": 58.89,
    "gourmand": 100.0,
    "woody": 58.89,
    "fruity": 100.0,
    "spiced-aromatic": 100.0
  },
  "chris-collins-savant-manhattan-cherry": {
    "black-cherry": 100.0,
    "whiskey": 92.0,
    "davana": 84.0,
    "tonka": 76.0,
    "cinnamon": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "spiced-aromatic": 44.0
  },
  "chris-collins-african-rooibos": {
    "cardamom": 100.0,
    "bergamot": 92.0,
    "pepper": 84.0,
    "tea": 76.0,
    "iris": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "city-rhythm-tempo": {
    "bergamot": 100.0,
    "pear": 88.4,
    "berry": 88.4,
    "tonka": 88.4,
    "vanilla": 88.4,
    "fresh": 100.0,
    "gourmand": 88.4,
    "resin-smoke": 72.75,
    "fruity": 88.4,
    "spiced-aromatic": 66.26
  },
  "city-rhythm-manhattan-midnight": {
    "tea": 100.0,
    "pepper": 94.99,
    "balsamic": 94.99,
    "tobacco": 94.99,
    "bergamot": 75.7,
    "fresh": 100.0,
    "gourmand": 72.06,
    "aromatic": 100.0,
    "tea-forward": 100.0,
    "resin-smoke": 94.99,
    "spiced-aromatic": 94.99,
    "dark": 94.99
  },
  "city-rhythm-tropical-confessions": {
    "jasmine": 100.0,
    "tonka": 83.32,
    "coconut": 78.07,
    "lime": 76.21,
    "vanilla": 61.59,
    "fresh": 76.21,
    "gourmand": 83.32,
    "woody": 60.32,
    "resin-smoke": 57.27,
    "floral": 100.0,
    "boozy": 56.29
  },
  "city-rhythm-2654": {
    "orange": 100.0,
    "lime": 100.0,
    "vanilla": 98.56,
    "tonka": 98.56,
    "coconut": 93.42,
    "fresh": 100.0,
    "gourmand": 98.56,
    "resin-smoke": 56.59,
    "spiced-aromatic": 59.96
  },
  "city-rhythm-miami": {
    "coconut": 100.0,
    "ylang": 100.0,
    "rum": 100.0,
    "tobacco": 100.0,
    "tonka": 100.0,
    "fresh": 63.55,
    "gourmand": 100.0,
    "floral": 100.0,
    "boozy": 100.0,
    "dark": 100.0
  },
  "city-rhythm-dc": {
    "pear": 100.0,
    "vanilla": 98.44,
    "jasmine": 67.33,
    "cherry": 64.22,
    "cherry-blossom": 64.22,
    "fresh": 64.22,
    "gourmand": 98.44,
    "woody": 61.11,
    "floral": 67.33,
    "fruity": 100.0,
    "spiced-aromatic": 56.44
  },
  "narcotica-discovery-kit": {},
  "narcotica-maniac": {
    "apple": 100.0,
    "berry": 100.0,
    "vanilla": 60.24,
    "lemon": 56.66,
    "coconut": 51.7,
    "fresh": 56.66,
    "gourmand": 100.0,
    "fruity": 100.0
  },
  "narcotica-limonata": {
    "berry": 100.0,
    "mango": 100.0,
    "fig": 100.0,
    "grapefruit": 64.5,
    "ginger": 64.5,
    "fresh": 100.0,
    "gourmand": 71.93,
    "aromatic": 63.83,
    "resin-smoke": 59.27,
    "fruity": 100.0,
    "spiced-aromatic": 64.5
  },
  "narcotica-love-me-latte": {
    "pear": 100.0,
    "coconut": 100.0,
    "fig": 100.0,
    "caramel": 100.0,
    "vanilla": 100.0,
    "fresh": 100.0,
    "gourmand": 100.0,
    "woody": 58.04,
    "fruity": 100.0
  },
  "narcotica-narco-oasis": {
    "passionfruit": 100.0,
    "berry": 100.0,
    "pear": 100.0,
    "peach": 100.0,
    "sweet": 100.0,
    "gourmand": 100.0,
    "fruity": 100.0
  },
  "narcotica-happy-dust": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "mango": 92.9,
    "coconut": 92.9,
    "sweet": 92.9,
    "gourmand": 100.0,
    "resin-smoke": 62.71,
    "floral": 79.2,
    "fruity": 92.9
  },
  "narcotica-doza": {
    "incense": 100.0,
    "amber": 100.0,
    "balsamic": 100.0,
    "pine": 77.36,
    "smoke": 77.36,
    "woody": 77.36,
    "resin-smoke": 100.0,
    "dark": 77.36
  },
  "narcotica-dulce-diablo": {
    "rum": 100.0,
    "chocolate": 100.0,
    "apricot": 100.0,
    "cognac": 100.0,
    "honey": 100.0,
    "gourmand": 100.0,
    "woody": 65.49,
    "boozy": 100.0,
    "fruity": 100.0,
    "spiced-aromatic": 76.2
  },
  "narcotica-narcotica-signature": {
    "sweet": 100.0,
    "pine": 92.0,
    "pepper": 84.0,
    "patchouli": 76.0,
    "cannabis": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "earthy": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0,
    "dark": 20.0
  },
  "sora-dora-mandorle": {
    "bergamot": 100.0,
    "raspberry-leaf": 92.0,
    "red-fruits": 84.0,
    "backwards-bergamot": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "sora-dora-ylop": {
    "lavender": 100.0,
    "lemon": 92.0,
    "fig-leaf": 84.0,
    "almond": 76.0,
    "cedar": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "aromatic": 44.0,
    "floral": 36.0
  },
  "sora-dora-jany": {
    "saffron": 100.0,
    "absinth": 92.0,
    "bergamot": 84.0,
    "lime": 76.0,
    "ghost-galbanum": 68.0,
    "spiced-aromatic": 60.0
  },
  "sora-dora-mallow": {
    "violet": 100.0,
    "vanilla": 74.89,
    "berry": 73.19,
    "almond": 73.19,
    "orange-blossom": 52.02,
    "gourmand": 74.89,
    "floral": 100.0,
    "fruity": 73.19
  },
  "sora-dora-gladiator": {
    "fresh": 100.0,
    "woody": 82.02,
    "aromatic": 94.27,
    "fruity": 72.95,
    "spiced-aromatic": 85.09
  },
  "xerjoff-accento": {
    "true-lavender": 100.0,
    "basil": 92.0,
    "cinnamon": 84.0,
    "bergamot": 76.0,
    "vextronplibar": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "spiced-aromatic": 44.0
  },
  "xerjoff-la-capitale": {
    "berry": 100.0,
    "peach": 100.0,
    "caramel": 95.51,
    "vanilla": 95.51,
    "balsamic": 77.79,
    "gourmand": 95.51,
    "resin-smoke": 77.79,
    "fruity": 100.0,
    "spiced-aromatic": 70.33,
    "dark": 70.33
  },
  "xerjoff-torino-21": {
    "motor-oil": 100.0,
    "vanilla": 92.0,
    "coconut": 84.0,
    "smoke": 76.0,
    "leather": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "dark": 44.0
  },
  "xerjoff-torino-22": {
    "berry": 100.0,
    "orange": 92.0,
    "jasmine": 84.0,
    "peach": 76.0,
    "orbital-orris": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "xerjoff-erba-gold": {
    "berry": 100.0,
    "cyclamen": 92.0,
    "orange": 84.0,
    "echoed-elemi": 76.0,
    "osmanthus": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "xerjoff-torino-24": {
    "mango": 100.0,
    "bergamot": 92.0,
    "plum": 84.0,
    "mandarin": 76.0,
    "orange-blossom": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "xerjoff-naxos": {
    "lavender": 100.0,
    "bergamot": 92.0,
    "lemon": 84.0,
    "omani-frankincense": 76.0,
    "honey": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "floral": 44.0
  },
  "xerjoff-erba-pura": {
    "pine": 100.0,
    "rosemary": 92.0,
    "thyme": 84.0,
    "cedar": 76.0,
    "incense": 68.0,
    "woody": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0
  },
  "xerjoff-torino-25": {
    "apple": 100.0,
    "bergamot": 92.0,
    "berry": 84.0,
    "pineapple": 76.0,
    "translated-turmeric": 68.0,
    "fruity": 60.0
  },
  "xerjoff-louis-xv-1722-rose": {
    "berry": 100.0,
    "pear": 92.0,
    "rose": 84.0,
    "plum": 76.0,
    "geranium": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "casamorati-quattro-pizzi": {
    "davana": 100.0,
    "coriander": 92.0,
    "pepper": 84.0,
    "rum": 76.0,
    "tuberose": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "boozy": 44.0,
    "spiced-aromatic": 36.0
  },
  "casamorati-mefisto": {
    "grapefruit": 100.0,
    "bergamot": 100.0,
    "lemon": 100.0,
    "violet": 88.5,
    "iris": 88.5,
    "fresh": 100.0,
    "woody": 55.82,
    "aromatic": 63.85,
    "floral": 88.5,
    "spiced-aromatic": 60.12
  },
  "casamorati-italica": {
    "milk": 100.0,
    "sicilian-almond": 92.0,
    "saffron": 84.0,
    "toffee": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "casamorati-lira": {
    "orange": 100.0,
    "bergamot": 92.0,
    "lavender": 84.0,
    "cinnamon": 76.0,
    "jasmine": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "casamorati-dama-bianca": {
    "chinese-kumquat": 100.0,
    "florentine-orris": 92.0,
    "lime": 84.0,
    "lilac": 76.0,
    "violet": 68.0,
    "floral": 60.0
  },
  "orto-parisi-risvelium": {
    "tomato-leaf": 100.0,
    "basil": 92.0,
    "bergamot": 84.0,
    "grothzenvixol": 76.0,
    "iris": 68.0,
    "aromatic": 60.0,
    "floral": 52.0
  },
  "orto-parisi-cuoium": {
    "aged-paper": 100.0,
    "amber": 92.0,
    "caramel": 84.0,
    "cypriol": 76.0,
    "nagarmotha": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0
  },
  "orto-parisi-terroni": {
    "caramel": 100.0,
    "fruity": 92.0,
    "echoed-elemi": 84.0,
    "gourmand": 76.0
  },
  "orto-parisi-stercus": {
    "rose": 100.0,
    "orange": 92.0,
    "blackberry": 84.0,
    "cinnamon": 76.0,
    "coriander": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "orto-parisi-seminalis": {
    "rain-accord": 100.0,
    "cotton": 92.0,
    "cedar": 84.0,
    "peony": 76.0,
    "pepper": 68.0,
    "woody": 60.0,
    "spiced-aromatic": 52.0
  },
  "orto-parisi-megamare": {
    "cedar": 100.0,
    "geranium": 92.0,
    "ginger": 84.0,
    "grapefruit": 76.0,
    "lavender": 68.0,
    "woody": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "spiced-aromatic": 36.0
  },
  "orto-parisi-bergamask": {
    "bergamot": 100.0,
    "lemon": 100.0,
    "orange-blossom": 100.0,
    "musk": 69.78,
    "cedar": 44.7,
    "fresh": 100.0,
    "woody": 44.7,
    "aromatic": 56.68,
    "floral": 100.0,
    "spiced-aromatic": 56.34
  },
  "goldfield-banks-pacific-rock-moss": {
    "jasmine": 100.0,
    "magnolia": 92.0,
    "musk": 84.0,
    "floral": 76.0
  },
  "goldfield-banks-bohemian-lime": {
    "black-cherry": 100.0,
    "chewing-gum": 92.0,
    "liquorice": 84.0,
    "musk": 76.0
  },
  "goldfield-banks-sunset-hour": {
    "bamboo": 100.0,
    "pear-blossom": 92.0,
    "musk": 84.0,
    "xondripleval": 76.0
  },
  "goldfield-banks-ingenious-ginger": {
    "green-notes": 100.0,
    "woody": 92.0
  },
  "goldfield-banks-pacific-rock-flower": {
    "sandalwood": 100.0,
    "cedar": 100.0,
    "patchouli": 100.0,
    "lemon": 66.73,
    "sea-salt": 60.05,
    "fresh": 66.73,
    "woody": 100.0,
    "earthy": 100.0,
    "dark": 100.0
  },
  "goldfield-banks-rose-magnitude": {
    "lychee": 100.0,
    "grapefruit": 92.0,
    "berry": 84.0,
    "nested-nutmeg": 76.0,
    "peach": 68.0,
    "fruity": 60.0
  },
  "goldfield-banks-silky-woods": {
    "rosemary": 100.0,
    "thyme": 92.0,
    "ginger": 84.0,
    "orange-blossom": 76.0,
    "saffron": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "boadicea-the-victorious-ardent": {
    "rose": 100.0,
    "saffron": 92.0,
    "carrot-seed": 84.0,
    "coriander": 76.0,
    "beeswax": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "boadicea-the-victorious-glorious": {
    "berry": 100.0,
    "elemi-resin": 92.0,
    "pineapple": 84.0,
    "apple": 76.0,
    "peach": 68.0,
    "fruity": 60.0
  },
  "boadicea-the-victorious-bodacious": {
    "cherry": 100.0,
    "almond": 92.0,
    "cognac": 84.0,
    "clove": 76.0,
    "pepper": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "boadicea-the-victorious-harmonius": {
    "musk": 100.0,
    "cognac": 92.0,
    "bergamot": 84.0,
    "cardamom": 76.0,
    "rum": 68.0,
    "gourmand": 60.0,
    "boozy": 52.0,
    "spiced-aromatic": 44.0
  },
  "boadicea-the-victorious-1907": {
    "cardamom": 100.0,
    "cinnamon": 92.0,
    "lemon": 84.0,
    "pepper": 76.0,
    "cashmere": 68.0,
    "gourmand": 60.0,
    "spiced-aromatic": 52.0
  },
  "mind-games-blockade": {
    "mango": 100.0,
    "pepper": 74.58,
    "bergamot": 73.33,
    "lavender": 50.09,
    "tomato-leaf": 38.0,
    "fresh": 68.44,
    "gourmand": 67.18,
    "aromatic": 73.33,
    "floral": 74.36,
    "fruity": 100.0,
    "spiced-aromatic": 74.58
  },
  "mind-games-queening": {
    "musk": 100.0,
    "vanilla": 89.91,
    "coconut": 65.4,
    "apple": 57.76,
    "rum": 57.76,
    "gourmand": 89.91,
    "floral": 100.0,
    "boozy": 57.76,
    "fruity": 57.76
  },
  "mind-games-jadoube": {
    "berry": 100.0,
    "patchouli": 83.53,
    "rose": 70.69,
    "balsamic": 66.56,
    "orange": 56.04,
    "gourmand": 56.04,
    "woody": 83.53,
    "earthy": 83.53,
    "resin-smoke": 66.56,
    "floral": 70.69,
    "fruity": 100.0,
    "spiced-aromatic": 56.51,
    "dark": 83.53
  },
  "mind-games-queenside": {
    "berry": 100.0,
    "pear": 100.0,
    "patchouli": 76.15,
    "lychee": 39.0,
    "lily-of-the-valley": 37.0,
    "fresh": 81.94,
    "woody": 76.15,
    "earthy": 76.15,
    "aromatic": 74.51,
    "fruity": 100.0,
    "spiced-aromatic": 60.07,
    "dark": 76.15
  },
  "perfumology-blyss": {
    "bergamot": 100.0,
    "cashmere-wood": 92.0,
    "grass": 84.0,
    "lemon": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0
  },
  "perfumology-clutch": {
    "cardamom": 100.0,
    "lotus-leaf": 92.0,
    "water-iris": 84.0,
    "pepper": 76.0,
    "conjugated-labdanum": 68.0,
    "spiced-aromatic": 60.0
  },
  "perfumology-lima": {
    "tobacco": 100.0,
    "cedar": 92.0,
    "bursera": 84.0,
    "woody": 76.0,
    "dark": 68.0
  },
  "perfumology-decadent-memories": {
    "gourmand": 77.93,
    "woody": 69.57,
    "fruity": 100.0
  },
  "mind-games-french-defense": {
    "cherry": 100.0,
    "amber": 89.05,
    "rose": 63.81,
    "cedar": 61.19,
    "violet-leaves": 39.0,
    "gourmand": 68.57,
    "woody": 61.19,
    "resin-smoke": 89.05,
    "floral": 63.81,
    "fruity": 100.0
  },
  "dorsay-tonka-hysteria": {
    "tonka": 100.0,
    "vanilla": 100.0,
    "incense": 98.21,
    "balsamic": 98.21,
    "cinnamon": 70.67,
    "gourmand": 100.0,
    "resin-smoke": 98.21,
    "floral": 60.49,
    "spiced-aromatic": 70.67
  },
  "gallivant-naples": {
    "incense": 100.0,
    "balsamic": 100.0,
    "amber": 100.0,
    "patchouli": 84.55,
    "vetiver": 84.55,
    "fresh": 65.61,
    "woody": 84.55,
    "earthy": 84.55,
    "aromatic": 79.13,
    "resin-smoke": 100.0,
    "spiced-aromatic": 82.65,
    "dark": 84.55
  },
  "kerosene-walk-the-sea": {
    "amber": 100.0,
    "white-blossoms": 98.84,
    "sea-salt": 92.07,
    "musk": 69.83,
    "cedar": 52.43,
    "fresh": 92.07,
    "woody": 52.43,
    "resin-smoke": 100.0,
    "floral": 98.84,
    "dark": 91.74
  },
  "kerosene-blackmail": {
    "oud": 100.0,
    "vanilla": 91.83,
    "amber": 80.56,
    "musk": 78.88,
    "berry": 70.83,
    "gourmand": 91.83,
    "woody": 100.0,
    "resin-smoke": 100.0,
    "floral": 78.88,
    "fruity": 70.83,
    "dark": 100.0
  },
  "kerosene-sweetly-known": {
    "cardamom": 100.0,
    "caramel": 75.66,
    "vanilla": 62.4,
    "cacao-pod": 51.82,
    "musk": 47.02,
    "gourmand": 75.66,
    "aromatic": 58.45,
    "spiced-aromatic": 100.0
  },
  "kerosene-followed": {
    "coffee": 100.0,
    "amber": 91.06,
    "caramel": 78.84,
    "chocolate": 70.26,
    "vanilla": 70.26,
    "gourmand": 100.0,
    "resin-smoke": 91.06,
    "spiced-aromatic": 91.06
  },
  "kerosene-unknown-pleasures": {
    "lemon": 100.0,
    "bergamot": 100.0,
    "tonka": 73.37,
    "caramel": 66.51,
    "honey": 66.51,
    "fresh": 100.0,
    "gourmand": 73.37,
    "aromatic": 55.79
  },
  "kerosene-summer-of-84": {
    "grapefruit": 100.0,
    "lemon": 100.0,
    "bergamot": 100.0,
    "water-notes": 39.0,
    "melon": 37.0,
    "fresh": 100.0
  },
  "kerosene-vanilified": {
    "vanilla": 100.0,
    "chocolate": 80.0,
    "musk": 67.67,
    "gourmand": 100.0,
    "floral": 67.67,
    "spiced-aromatic": 60.0
  },
  "spiritica-weon": {
    "coconut": 100.0,
    "milk": 92.0,
    "clove": 84.0,
    "pineapple": 76.0,
    "pistachio": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "spiritica-leonarda": {
    "butter": 100.0,
    "cotton-candy": 92.0,
    "liquorice": 84.0,
    "salted-caramel": 76.0,
    "sugar-cane": 68.0
  },
  "spiritica-jeffrey": {
    "bergamot": 100.0,
    "tea": 92.0,
    "lemon": 84.0,
    "seawater": 76.0,
    "floral": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0
  },
  "spiritica-lynch-aka-smoke-styrax": {
    "saffron": 100.0,
    "tobacco": 100.0,
    "cherry": 95.88,
    "vanilla": 95.88,
    "balsamic": 78.85,
    "gourmand": 95.88,
    "woody": 78.85,
    "resin-smoke": 78.85,
    "fruity": 95.88,
    "spiced-aromatic": 100.0,
    "dark": 100.0
  },
  "spiritica-atmayatra": {
    "bergamot": 100.0,
    "berry": 92.0,
    "fruity": 84.0
  },
  "spiritica-mango-macumba": {
    "mango": 100.0,
    "papaya": 92.0,
    "mint": 84.0,
    "lime": 76.0,
    "pineapple": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0
  },
  "spiritica-yuzuyakuza": {
    "orange-blossom": 100.0,
    "pineapple": 92.0,
    "gardenia": 84.0,
    "clove": 76.0,
    "jasmine": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "dorsay-olfactory-discoveries-set": {},
  "dannam-pomelo-oolong": {
    "floral": 100.0,
    "moss": 92.0,
    "woody": 84.0,
    "earthy": 76.0
  },
  "dorsay-e-q": {
    "iris": 100.0,
    "wood": 93.48,
    "patchouli": 93.48,
    "amber": 79.82,
    "jasmine": 59.43,
    "woody": 93.48,
    "earthy": 93.48,
    "resin-smoke": 79.82,
    "floral": 100.0,
    "spiced-aromatic": 58.33,
    "dark": 93.48
  },
  "dorsay-c-g": {
    "angelica": 40.0,
    "lemon-leaf": 39.0,
    "lime-linden-blossom": 38.0,
    "hay": 37.0,
    "ac-cia": 36.0,
    "fresh": 100.0,
    "gourmand": 77.89,
    "aromatic": 60.74,
    "floral": 96.21,
    "spiced-aromatic": 58.37
  },
  "dorsay-r-b": {
    "musk": 100.0,
    "wood": 68.3,
    "sandalwood": 68.3,
    "rose": 61.7,
    "incense": 53.05,
    "woody": 68.3,
    "resin-smoke": 53.05,
    "floral": 77.63
  },
  "dorsay-g-a": {
    "cardamom": 100.0,
    "leather": 96.0,
    "cedar": 92.8,
    "patchouli": 92.8,
    "grapefruit": 82.0,
    "fresh": 82.0,
    "woody": 92.8,
    "earthy": 92.8,
    "aromatic": 69.4,
    "floral": 82.0,
    "spiced-aromatic": 100.0,
    "dark": 96.0
  },
  "dorsay-holy-berry": {
    "oud": 100.0,
    "milk": 83.49,
    "vanilla": 83.49,
    "cardamom": 81.12,
    "amber": 81.12,
    "gourmand": 83.49,
    "woody": 100.0,
    "resin-smoke": 100.0,
    "floral": 71.92,
    "fruity": 86.36,
    "spiced-aromatic": 81.12,
    "dark": 100.0
  },
  "dorsay-rose-blaze": {
    "rose": 100.0,
    "tonka": 63.92,
    "iris": 60.96,
    "gourmand": 63.92,
    "floral": 100.0
  },
  "dorsay-flower-lust": {
    "tonka": 100.0,
    "balsamic": 92.59,
    "sandalwood": 89.07,
    "patchouli": 89.07,
    "vetiver": 89.07,
    "gourmand": 100.0,
    "woody": 89.07,
    "earthy": 89.07,
    "resin-smoke": 92.59,
    "floral": 86.84,
    "spiced-aromatic": 88.12,
    "dark": 89.07
  },
  "liis-unseen-discovery-kit": {
    "amber": 100.0,
    "rose": 92.0,
    "spices": 84.0,
    "resin-smoke": 76.0,
    "floral": 68.0,
    "spiced-aromatic": 60.0
  },
  "liis-vivid-discovery-kit": {},
  "liis-flower-glyph": {
    "bergamot": 100.0,
    "peach": 92.0,
    "plum": 84.0,
    "jasmine": 76.0,
    "lily-of-the-valley": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "room-1015-cherry-punk": {
    "pink-musk": 100.0,
    "pepper": 92.0,
    "rose": 84.0,
    "vanilla": 76.0,
    "gourmand": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "room-1015-wave-child": {
    "orange": 100.0,
    "mandarin": 92.0,
    "lemon": 84.0,
    "watermelon": 76.0,
    "coconut": 68.0,
    "gourmand": 60.0
  },
  "room-1015-poppy-riot": {
    "orange": 100.0,
    "milk": 100.0,
    "tonka": 100.0,
    "tobacco": 100.0,
    "saffron": 92.41,
    "fresh": 72.94,
    "gourmand": 100.0,
    "woody": 64.07,
    "floral": 59.77,
    "fruity": 63.78,
    "spiced-aromatic": 92.41,
    "dark": 100.0
  },
  "room-1015-love-o-matic": {
    "rose": 100.0,
    "angular-anise": 92.0,
    "bourbon-geranium": 84.0,
    "clove": 76.0,
    "white-ambergris": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "room-1015-cherry-punk-extrait-de-parfum": {
    "cherry": 100.0,
    "tonka": 78.36,
    "saffron": 75.96,
    "pepper": 75.96,
    "leather": 45.47,
    "gourmand": 78.36,
    "fruity": 100.0,
    "spiced-aromatic": 75.96,
    "dark": 45.47
  },
  "room-1015-electric-wood-extrait-de-parfum": {
    "champagne": 100.0,
    "dark-chocolate": 92.0,
    "berry": 84.0,
    "fruity": 76.0
  },
  "cirque-du-soleil-leau-de-parfum": {
    "cattleya-orchid": 100.0,
    "shadow-sage": 92.0,
    "magnolia": 84.0,
    "klempzordivan": 76.0,
    "musk": 68.0,
    "floral": 60.0
  },
  "liis-rose-struck": {
    "bergamot": 100.0,
    "raspberry-leaf": 92.0,
    "jasmine": 84.0,
    "lily-of-the-valley": 76.0,
    "rose": 68.0,
    "floral": 60.0
  },
  "xtrait-perfumery-gift-card": {},
  "pernoire-vitias": {
    "lime": 100.0,
    "bergamot": 100.0,
    "marine-notes": 78.82,
    "pepper": 76.02,
    "musk": 74.58,
    "fresh": 100.0,
    "aromatic": 72.74,
    "resin-smoke": 63.16,
    "spiced-aromatic": 76.02,
    "dark": 55.09
  },
  "pernoire-yuma": {
    "pepper": 100.0,
    "ginger": 100.0,
    "bergamot": 89.49,
    "yuzu": 65.93,
    "wood": 61.36,
    "fresh": 85.93,
    "woody": 61.36,
    "aromatic": 89.49,
    "spiced-aromatic": 100.0
  },
  "pernoire-melos": {
    "honey": 100.0,
    "tea": 97.78,
    "berry": 79.67,
    "almond": 79.67,
    "milk": 79.67,
    "fresh": 97.78,
    "gourmand": 100.0,
    "aromatic": 97.78,
    "floral": 97.78,
    "fruity": 79.67
  },
  "pernoire-poka": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "caramel": 92.22,
    "cinnamon": 92.22,
    "balsamic": 78.04,
    "gourmand": 100.0,
    "woody": 60.65,
    "resin-smoke": 78.04,
    "spiced-aromatic": 92.22
  },
  "pernoire-anelo": {
    "pineapple": 100.0,
    "mango": 100.0,
    "mandarin": 89.94,
    "ginger": 83.29,
    "vetiver": 47.86,
    "fresh": 83.29,
    "gourmand": 89.94,
    "woody": 47.86,
    "earthy": 47.86,
    "fruity": 100.0,
    "spiced-aromatic": 83.29,
    "dark": 47.86
  },
  "amouage-line-618": {
    "milk": 100.0,
    "omani-green-frankincense": 92.0,
    "peach": 84.0,
    "pepper": 76.0,
    "pineapple": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "amouage-love-hibiscus": {
    "passionfruit": 100.0,
    "salted-caramel": 92.0,
    "bergamot": 84.0,
    "hibiscus": 76.0,
    "incense": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0
  },
  "investi-parfums-find-me": {
    "berry": 100.0,
    "sweet": 92.0,
    "cinnamon": 84.0,
    "jasmine": 76.0,
    "amber": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "floral": 44.0,
    "fruity": 36.0,
    "spiced-aromatic": 28.0
  },
  "investi-parfums-vanilla-date": {
    "tonka-alcoolat": 100.0,
    "cherry": 92.0,
    "marzipan": 84.0,
    "dates": 76.0,
    "figs": 68.0,
    "fruity": 60.0
  },
  "investi-parfums-discovery-set": {
    "vanilla": 100.0,
    "gourmand": 92.0
  },
  "zernell-gillie-disco": {
    "bergamot": 100.0,
    "grapefruit": 100.0,
    "amber": 85.6,
    "tobacco": 85.6,
    "saffron": 85.6,
    "fresh": 100.0,
    "gourmand": 60.0,
    "woody": 64.8,
    "aromatic": 71.0,
    "resin-smoke": 85.6,
    "spiced-aromatic": 85.6,
    "dark": 85.6
  },
  "zernell-gillie-techno": {
    "pepper": 100.0,
    "saffron": 100.0,
    "amber": 100.0,
    "leather": 95.88,
    "suede": 95.88,
    "fresh": 67.86,
    "gourmand": 62.14,
    "woody": 75.75,
    "earthy": 75.75,
    "aromatic": 69.8,
    "resin-smoke": 100.0,
    "fruity": 81.24,
    "spiced-aromatic": 100.0,
    "dark": 95.88
  },
  "zernell-gillie-hip-hop": {
    "saffron": 100.0,
    "balsamic": 100.0,
    "berry": 93.23,
    "musk": 76.06,
    "chocolate": 63.65,
    "fresh": 63.37,
    "gourmand": 63.65,
    "woody": 78.77,
    "resin-smoke": 100.0,
    "floral": 59.69,
    "fruity": 93.23,
    "spiced-aromatic": 100.0
  },
  "zernell-gillie-house": {
    "tonka": 100.0,
    "berry": 100.0,
    "orange": 100.0,
    "oud": 62.59,
    "saffron": 61.74,
    "gourmand": 100.0,
    "woody": 62.59,
    "aromatic": 58.06,
    "resin-smoke": 62.59,
    "floral": 57.77,
    "fruity": 100.0,
    "spiced-aromatic": 61.74,
    "dark": 62.59
  },
  "zernell-gillie-jazz": {
    "vanilla": 98.69,
    "honey": 98.69,
    "tobacco": 98.69,
    "chocolate": 98.69,
    "balsamic": 66.96,
    "gourmand": 98.69,
    "woody": 100.0,
    "resin-smoke": 66.96,
    "floral": 66.14,
    "dark": 98.69
  },
  "zernell-gillie-r-and-b": {
    "amber": 97.81,
    "honey": 91.8,
    "cedar": 91.8,
    "rose": 61.99,
    "guava": 40.0,
    "fresh": 80.45,
    "gourmand": 91.8,
    "woody": 91.8,
    "resin-smoke": 97.81,
    "floral": 61.99,
    "fruity": 100.0
  },
  "zernell-gillie-blues": {
    "apricot": 100.0,
    "coffee": 100.0,
    "oud": 86.73,
    "balsamic": 59.67,
    "brandy": 40.0,
    "gourmand": 100.0,
    "woody": 86.73,
    "resin-smoke": 86.73,
    "floral": 82.04,
    "fruity": 100.0,
    "spiced-aromatic": 59.67,
    "dark": 86.73
  },
  "les-indemodables-immortelle-solaire": {
    "lavender": 100.0,
    "freesia": 92.0,
    "musk": 84.0,
    "peach": 76.0,
    "pot-marigold": 68.0,
    "aromatic": 60.0,
    "floral": 52.0,
    "fruity": 44.0
  },
  "les-indemodables-oranger-sirocco": {
    "lavender": 100.0,
    "yuzu": 92.0,
    "plum": 84.0,
    "grothzenvixol": 76.0,
    "pine": 68.0,
    "woody": 60.0,
    "aromatic": 52.0,
    "floral": 44.0,
    "fruity": 36.0
  },
  "les-indemodables-ambre-supreme": {
    "cherry-blossom": 100.0,
    "cupcake": 92.0,
    "gardenia": 84.0,
    "ginger": 76.0,
    "lemon-myrtle": 68.0,
    "floral": 60.0,
    "spiced-aromatic": 52.0
  },
  "les-indemodables-rose-de-jamal": {
    "rose": 100.0,
    "vervain": 92.0,
    "chamomile": 84.0,
    "lily-of-the-valley": 76.0,
    "orange-blossom": 68.0,
    "floral": 60.0
  },
  "belnu-chai-fleur": {
    "ceylonese-cinnamon": 100.0,
    "green-guatemala-cardamom": 92.0,
    "indonesian-nutmeg": 84.0,
    "proven-al-lavender": 76.0,
    "spanish-cistus": 68.0
  },
  "belnu-incense-antique": {
    "cardamom": 100.0,
    "pepper": 92.0,
    "italian-lemon": 84.0,
    "balkans-tobacco": 76.0,
    "indonesian-patchouli": 68.0,
    "spiced-aromatic": 60.0
  },
  "belnu-rose-steady": {
    "bay-leaf": 100.0,
    "cashmere-wood": 92.0,
    "somali-frankincense": 84.0,
    "fig-leaf": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0
  },
  "amouage-purpose-50": {
    "sandalwood": 100.0,
    "vetiver": 100.0,
    "pepper": 80.33,
    "saffron": 80.33,
    "incense": 62.29,
    "woody": 100.0,
    "earthy": 100.0,
    "resin-smoke": 62.29,
    "spiced-aromatic": 80.33,
    "dark": 100.0
  },
  "bdk-parfums-vanille-caviar": {
    "cardamom": 100.0,
    "calamus": 92.0,
    "berry": 84.0,
    "vanilla": 76.0,
    "chocolate": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "bdk-parfums-pas-ce-soir": {
    "ginger": 100.0,
    "pear": 92.0,
    "orange": 84.0,
    "pepper": 76.0,
    "quince-chutney": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "bdk-parfums-rouge-smoking": {
    "cherry": 100.0,
    "pepper": 92.0,
    "italian-bergamot": 84.0,
    "vanilla": 76.0,
    "heliotrope": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "bdk-parfums-gris-charnel": {
    "cardamom": 100.0,
    "fig": 92.0,
    "tea": 84.0,
    "bourbon-vetiver": 76.0,
    "orris-absolute": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "bdk-parfums-gris-charnel-extrait": {
    "cardamom": 100.0,
    "fig": 92.0,
    "tea": 84.0,
    "iris-tingitana-absolute": 76.0,
    "bourbon-vetiver": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "fruity": 44.0,
    "spiced-aromatic": 36.0
  },
  "bdk-parfums-impadia": {
    "pear": 100.0,
    "italian-bergamot": 92.0,
    "italian-mandarine-orpur": 84.0,
    "rose": 76.0,
    "orange": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "bdk-parfums-citrus-riviera": {
    "orange": 100.0,
    "italian-lemon": 92.0,
    "moroccan-neroli": 84.0,
    "fig": 76.0,
    "eucalyptus": 68.0,
    "fresh": 60.0,
    "fruity": 52.0
  },
  "amouage-outlands": {
    "incense": 100.0,
    "amber": 100.0,
    "oud": 100.0,
    "cardamom": 76.02,
    "pepper": 76.02,
    "fresh": 60.54,
    "gourmand": 55.07,
    "woody": 100.0,
    "aromatic": 73.6,
    "resin-smoke": 100.0,
    "spiced-aromatic": 76.02,
    "dark": 100.0
  },
  "amouage-reflection-45": {
    "cardamom": 100.0,
    "cedar": 91.62,
    "sandalwood": 91.62,
    "vetiver": 91.62,
    "patchouli": 91.62,
    "woody": 91.62,
    "earthy": 91.62,
    "aromatic": 100.0,
    "resin-smoke": 89.5,
    "floral": 64.48,
    "spiced-aromatic": 100.0,
    "dark": 91.62
  },
  "amouage-guidance-46": {
    "sandalwood": 100.0,
    "pear": 69.08,
    "almond": 64.6,
    "rose": 63.01,
    "jasmine": 63.01,
    "gourmand": 64.6,
    "woody": 100.0,
    "resin-smoke": 62.61,
    "floral": 63.01,
    "fruity": 69.08,
    "spiced-aromatic": 62.61
  },
  "amouage-reflection-man": {
    "sandalwood": 100.0,
    "cedar": 100.0,
    "vetiver": 100.0,
    "patchouli": 100.0,
    "jasmine": 82.95,
    "woody": 100.0,
    "earthy": 100.0,
    "aromatic": 67.72,
    "floral": 82.95,
    "dark": 100.0
  },
  "amouage-guidance": {
    "sandalwood": 100.0,
    "incense": 69.01,
    "amber": 69.01,
    "saffron": 66.25,
    "pear": 63.27,
    "gourmand": 57.38,
    "woody": 100.0,
    "resin-smoke": 69.01,
    "fruity": 63.27,
    "spiced-aromatic": 66.25
  },
  "clive-christian-blonde-amber": {
    "sandalwood": 100.0,
    "patchouli": 100.0,
    "cedar": 100.0,
    "vetiver": 100.0,
    "incense": 97.34,
    "fresh": 57.92,
    "gourmand": 75.98,
    "woody": 100.0,
    "earthy": 100.0,
    "aromatic": 63.68,
    "resin-smoke": 97.34,
    "floral": 71.77,
    "fruity": 66.58,
    "spiced-aromatic": 94.06,
    "dark": 100.0
  },
  "clive-christian-town-and-country": {
    "blackberry": 100.0,
    "cherry-blossom": 92.0,
    "grapefruit": 84.0,
    "berry": 76.0,
    "displaced-daffodil": 68.0,
    "fruity": 60.0
  },
  "clive-christian-strange-heavens-out-of-the-blue": {
    "carnation": 100.0,
    "lemon": 92.0,
    "mimosa": 84.0,
    "seaweed": 76.0,
    "musk": 68.0
  },
  "clive-christian-jump-up-and-kiss-me-hedonistic": {
    "resin-smoke": 100.0,
    "dark": 73.08
  },
  "hellenist-le-chant-dachille": {
    "neroli": 100.0,
    "orange-blossom": 100.0,
    "lemon": 99.32,
    "ylang": 71.59,
    "pepper": 65.07,
    "fresh": 99.32,
    "gourmand": 71.59,
    "aromatic": 67.85,
    "floral": 100.0,
    "spiced-aromatic": 65.07
  },
  "hellenist-lombre-dart-mis": {
    "amber": 100.0,
    "bergamot": 92.0,
    "black-musk": 84.0,
    "cedar": 76.0,
    "clary-sage": 68.0,
    "woody": 60.0,
    "resin-smoke": 52.0
  },
  "hellenist-les-bras-de-morphee": {
    "jasmine": 100.0,
    "magnolia": 92.0,
    "musk": 84.0,
    "norbflixtamor": 76.0,
    "floral": 68.0
  },
  "hellenist-les-dieux-aux-bains": {
    "bergamot": 100.0,
    "citrus": 92.0,
    "green-notes": 84.0,
    "lavender": 76.0,
    "lemon": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "floral": 44.0
  },
  "hellenist-la-nuit-des-300": {
    "bergamot": 100.0,
    "green-notes": 92.0,
    "pepper": 84.0,
    "plorzinkwedal": 76.0,
    "lilac": 68.0,
    "spiced-aromatic": 60.0
  },
  "lorenzo-pazzaglia-summer-hammer": {
    "mango": 100.0,
    "pineapple": 100.0,
    "coconut": 100.0,
    "sandalwood": 60.0,
    "vetiver": 60.0,
    "gourmand": 100.0,
    "woody": 60.0,
    "earthy": 60.0,
    "fruity": 100.0,
    "dark": 60.0
  },
  "lorenzo-pazzaglia-black-sea": {
    "sea-salt": 100.0,
    "bergamot": 73.72,
    "ozonic": 57.9,
    "amber": 55.35,
    "orange-blossom": 45.73,
    "fresh": 100.0,
    "aromatic": 73.72,
    "resin-smoke": 55.35,
    "floral": 45.73
  },
  "lorenzo-pazzaglia-sun-gria": {
    "berry": 100.0,
    "apple": 100.0,
    "orange": 79.32,
    "bergamot": 79.32,
    "lemon": 79.32,
    "fresh": 79.32,
    "gourmand": 75.35,
    "fruity": 100.0
  },
  "lorenzo-pazzaglia-speachless": {
    "apple": 100.0,
    "lime": 99.3,
    "orange": 99.3,
    "lemon": 99.3,
    "ginger": 99.3,
    "fresh": 99.3,
    "gourmand": 72.57,
    "aromatic": 78.4,
    "fruity": 100.0,
    "spiced-aromatic": 99.3
  },
  "lorenzo-pazzaglia-van-py-rhum": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "rum": 68.65,
    "caramel": 68.65,
    "patchouli": 63.17,
    "gourmand": 100.0,
    "woody": 63.17,
    "earthy": 63.17,
    "boozy": 68.65,
    "spiced-aromatic": 59.81,
    "dark": 63.17
  },
  "lorenzo-pazzaglia-evil-angel": {
    "sandalwood": 100.0,
    "cedar": 100.0,
    "lime": 98.36,
    "citrus": 98.36,
    "fruity": 87.26,
    "fresh": 98.36,
    "gourmand": 82.72,
    "woody": 100.0,
    "aromatic": 69.52,
    "spiced-aromatic": 82.72
  },
  "lorenzo-pazzaglia-green-island": {
    "yuzu": 100.0,
    "mandarin": 100.0,
    "bergamot": 100.0,
    "ginger": 100.0,
    "cedar": 91.57,
    "fresh": 100.0,
    "gourmand": 59.72,
    "woody": 91.57,
    "earthy": 91.57,
    "aromatic": 65.76,
    "fruity": 62.4,
    "spiced-aromatic": 100.0
  },
  "lorenzo-pazzaglia-sex-sea": {
    "citrus": 100.0,
    "yuzu": 100.0,
    "bergamot": 100.0,
    "orange": 100.0,
    "sea-salt": 65.51,
    "fresh": 100.0,
    "aromatic": 75.16,
    "spiced-aromatic": 64.98
  },
  "lorenzo-pazzaglia-dream-sea": {
    "sandalwood": 100.0,
    "cedar": 100.0,
    "vanilla": 96.39,
    "sea-salt": 90.49,
    "ozonic": 84.99,
    "fresh": 90.49,
    "gourmand": 96.39,
    "woody": 100.0,
    "resin-smoke": 76.35,
    "floral": 71.29,
    "spiced-aromatic": 66.77,
    "dark": 63.23
  },
  "lorenzo-pazzaglia-van-sea": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "sea-salt": 90.08,
    "caramel": 68.66,
    "amber": 59.56,
    "fresh": 90.08,
    "gourmand": 100.0,
    "aromatic": 96.82,
    "resin-smoke": 59.56,
    "spiced-aromatic": 66.24
  },
  "giardini-di-toscana-blu-mare": {
    "bergamot": 100.0,
    "pine": 100.0,
    "grapefruit": 85.99,
    "lemon": 85.99,
    "pepper": 63.43,
    "fresh": 85.99,
    "woody": 100.0,
    "earthy": 60.95,
    "aromatic": 100.0,
    "spiced-aromatic": 63.43
  },
  "brandt-guava-sorbet": {
    "passionfruit": 100.0,
    "mandarin": 97.37,
    "vanilla": 97.37,
    "grapefruit": 78.38,
    "bergamot": 78.38,
    "fresh": 78.38,
    "gourmand": 97.37,
    "floral": 59.8,
    "fruity": 100.0
  },
  "brandt-genesis": {
    "tobacco": 100.0,
    "sandalwood": 100.0,
    "saffron": 87.83,
    "rose": 70.92,
    "berry": 56.92,
    "gourmand": 56.92,
    "woody": 100.0,
    "floral": 70.92,
    "fruity": 56.92,
    "spiced-aromatic": 87.83,
    "dark": 100.0
  },
  "dannam-mango-sticky-rice": {
    "mango": 100.0,
    "coconut": 55.2,
    "rice": 39.0,
    "gourmand": 93.65,
    "fruity": 100.0
  },
  "dannam-japanese-whiskey": {
    "amber": 100.0,
    "grapefruit": 92.0,
    "orange": 84.0,
    "orchid": 76.0,
    "pepper": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "dannam-chapter-1-discovery-set-enchanting-vietnam": {},
  "dannam-chapter-2-discovery-set-memories-of-japan": {
    "berry": 100.0,
    "rice": 92.0,
    "tea": 84.0,
    "whiskey": 76.0,
    "fresh": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "boozy": 44.0,
    "fruity": 36.0
  },
  "french-cowboy-pear-pavlova": {
    "fresh": 57.11,
    "gourmand": 100.0,
    "floral": 75.43,
    "fruity": 80.83
  },
  "french-cowboy-mezcal-chocolat": {
    "gourmand": 58.22,
    "woody": 63.6,
    "spiced-aromatic": 100.0
  },
  "fleurit-parfums-fleuriste": {
    "floral": 100.0,
    "fruity": 92.0,
    "sweet": 84.0,
    "theoretical-tobacco": 76.0,
    "gourmand": 68.0
  },
  "fleurit-parfums-g-teau-des-anges": {
    "pear": 100.0,
    "pepper": 92.0,
    "phantom-peony": 84.0,
    "jasmine": 76.0,
    "orange-blossom": 68.0,
    "floral": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  },
  "fleurit-parfums-fleurs-de-d-esse": {
    "bergamot": 100.0,
    "grapefruit": 92.0,
    "orange": 84.0,
    "melancholic-myrrh": 76.0,
    "freesia": 68.0
  },
  "fleurit-parfums-sainte-fum-e": {
    "bergamot": 100.0,
    "lemon": 92.0,
    "pepper": 84.0,
    "amber": 76.0,
    "heliotrope": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "fleurit-parfums-fleurs-de-tabac": {
    "angelica": 100.0,
    "bergamot": 92.0,
    "pepper": 84.0,
    "elemi-resin": 76.0,
    "incense": 68.0,
    "resin-smoke": 60.0,
    "spiced-aromatic": 52.0
  },
  "gallivant-istanbul": {
    "bergamot": 100.0,
    "cardamom": 92.0,
    "red-thyme": 84.0,
    "lavender-absolute": 76.0,
    "geranium": 68.0,
    "spiced-aromatic": 60.0
  },
  "gallivant-tokyo": {
    "pepper": 100.0,
    "cardamom": 100.0,
    "cedar": 92.27,
    "sandalwood": 92.27,
    "vetiver": 92.27,
    "woody": 92.27,
    "earthy": 92.27,
    "aromatic": 71.32,
    "resin-smoke": 74.13,
    "spiced-aromatic": 100.0,
    "dark": 92.27
  },
  "gallivant-london": {
    "apple": 100.0,
    "berry": 92.0,
    "freesia": 84.0,
    "musk": 76.0,
    "rose": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "gallivant-bukhara": {
    "coriander": 100.0,
    "caraway": 92.0,
    "pear": 84.0,
    "bergamot": 76.0,
    "orris-iris": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "gallivant-gdansk": {
    "cherry-blossom": 100.0,
    "sandalwood": 92.0,
    "tea": 84.0,
    "cedar": 76.0,
    "fresh": 68.0,
    "woody": 60.0,
    "aromatic": 52.0
  },
  "giardini-di-toscana-bianco-latte": {
    "vanilla": 100.0,
    "caramel": 88.74,
    "honey": 88.74,
    "musk": 55.87,
    "coumarin": 39.0,
    "gourmand": 100.0,
    "resin-smoke": 56.05,
    "floral": 55.87
  },
  "giardini-di-toscana-oro-e-miele": {
    "vanilla": 100.0,
    "tonka": 100.0,
    "honey": 96.17,
    "coconut": 96.17,
    "berry": 96.17,
    "gourmand": 100.0,
    "resin-smoke": 55.04,
    "floral": 93.14,
    "fruity": 96.17
  },
  "giardini-di-toscana-ricordami": {
    "bergamot": 79.1,
    "lemon": 79.1,
    "orange": 79.1,
    "vetiver": 63.88,
    "cedar": 63.88,
    "fresh": 100.0,
    "woody": 63.88,
    "earthy": 63.88,
    "aromatic": 69.13,
    "dark": 63.88
  },
  "giardini-di-toscana-verde-respiro": {
    "berry": 100.0,
    "patchouli": 76.88,
    "vanilla": 69.4,
    "bergamot": 67.6,
    "amber": 51.24,
    "gourmand": 69.4,
    "woody": 76.88,
    "earthy": 76.88,
    "aromatic": 67.6,
    "resin-smoke": 51.24,
    "fruity": 100.0,
    "dark": 76.88
  },
  "giardini-di-toscana-discovery-set": {},
  "liis-bo": {
    "cedar": 100.0,
    "vanilla": 50.08,
    "elemi-resin": 40.0,
    "tobacco": 39.0,
    "kyara-incense": 38.0,
    "gourmand": 50.08,
    "woody": 100.0,
    "dark": 39.0
  },
  "liis-studied": {
    "orange": 100.0,
    "omani-frankincense": 92.0,
    "pepper": 84.0,
    "coffee": 76.0,
    "jasmine": 68.0,
    "gourmand": 60.0,
    "floral": 52.0,
    "spiced-aromatic": 44.0
  },
  "liis-floating": {
    "fresh": 77.66,
    "gourmand": 68.75,
    "woody": 56.64,
    "floral": 61.33,
    "fruity": 100.0
  },
  "liis-celestial-object": {
    "almond": 100.0,
    "tonka": 95.01,
    "incense": 65.88,
    "balsamic": 65.88,
    "quince": 40.0,
    "gourmand": 100.0,
    "resin-smoke": 65.88,
    "fruity": 75.5
  },
  "liis-choux-choux": {
    "aromatic": 100.0,
    "bergamot": 92.0,
    "lemon-zest": 84.0,
    "geranium": 76.0,
    "lavender": 68.0,
    "floral": 60.0
  },
  "liis-ethereal-wave": {
    "bergamot": 100.0,
    "coconut": 92.0,
    "grapefruit": 84.0,
    "musk": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0
  },
  "liis-in-this-world": {
    "milk": 100.0,
    "berry": 92.0,
    "negative-narcissus": 84.0,
    "gourmand": 76.0,
    "fruity": 68.0
  },
  "liis-lucienne": {
    "pomelo": 40.0,
    "lemon-zest": 39.0,
    "magnolia": 38.0,
    "water-lily": 37.0,
    "pitahaya": 36.0,
    "fresh": 94.54,
    "floral": 100.0
  },
  "liis-of-true-minds": {
    "french-narcissus": 100.0,
    "sandalwood": 92.0,
    "orange": 84.0,
    "osmanthus": 76.0,
    "pink-lotus": 68.0,
    "woody": 60.0,
    "floral": 52.0
  },
  "twentysecondofmay-roots-of-kente": {
    "wood": 100.0,
    "musk": 92.0,
    "balsamic": 84.0,
    "jasmine": 76.0,
    "tonka": 68.0,
    "gourmand": 60.0,
    "woody": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0
  },
  "rania-j-jasmin-kama": {
    "freesia": 100.0,
    "virtual-violet": 92.0,
    "berry": 84.0,
    "junkrothfelm": 76.0,
    "vanilla": 68.0,
    "gourmand": 60.0,
    "fruity": 52.0
  },
  "rania-j-t-habanero": {
    "vanilla": 100.0,
    "gourmand": 92.0
  },
  "twentysecondofmay-bees-home": {
    "orange": 100.0,
    "grapefruit": 92.0,
    "mint": 84.0,
    "cinnamon": 76.0,
    "rose": 68.0,
    "fresh": 60.0,
    "gourmand": 52.0,
    "aromatic": 44.0,
    "floral": 36.0,
    "spiced-aromatic": 28.0
  },
  "twentysecondofmay-frosted-flame": {
    "patchouli": 100.0,
    "quembrathosin": 92.0,
    "woody": 84.0,
    "earthy": 76.0,
    "dark": 68.0
  },
  "twentysecondofmay-sunbeds-and-daydreams": {
    "fresh-pear": 100.0,
    "solar-accord": 92.0,
    "jasmine": 84.0,
    "honey": 76.0,
    "marine-accord-sea-water": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "jovoy-parfums-fire-at-will": {
    "vanilla": 100.0,
    "mimosa": 92.0,
    "sweet": 84.0,
    "amber": 76.0,
    "musk": 68.0,
    "gourmand": 60.0,
    "resin-smoke": 52.0,
    "fruity": 44.0
  },
  "jovoy-parfums-remember-me": {
    "cardamom": 100.0,
    "lemon": 92.0,
    "bergamot": 84.0,
    "tea": 76.0,
    "ginger": 68.0,
    "fresh": 60.0,
    "aromatic": 52.0,
    "spiced-aromatic": 44.0
  },
  "jovoy-parfums-musc-pallas": {
    "ambrette-musk-mallow": 100.0,
    "bergamot": 92.0,
    "iris": 84.0,
    "peach": 76.0,
    "ocean-spray-marine-notes": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "jovoy-parfums-discovery-kit": {
    "amber": 100.0,
    "resin-smoke": 92.0
  },
  "les-indemodables-foug-re-meraude": {
    "pepper": 100.0,
    "fruity": 92.0,
    "leather": 84.0,
    "oud": 76.0,
    "patchouli": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "spiced-aromatic": 36.0,
    "dark": 28.0
  },
  "les-indemodables-cuir-de-chine": {
    "rose": 100.0,
    "rosa-centifolia": 92.0,
    "orange": 84.0,
    "berry": 76.0,
    "melancholic-myrrh": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "les-indemodables-chypre-azural": {
    "rose": 100.0,
    "rosa-centifolia": 92.0,
    "orange": 84.0,
    "brimzalthok": 76.0,
    "berry": 68.0,
    "floral": 60.0,
    "fruity": 52.0
  },
  "les-indemodables-iris-perle": {
    "fresh": 100.0,
    "amber": 92.0,
    "jasmine": 84.0,
    "iris": 76.0,
    "violet": 68.0,
    "gourmand": 60.0,
    "aromatic": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0
  },
  "les-indemodables-musc-des-sables": {
    "fresh": 77.52,
    "woody": 76.58,
    "earthy": 84.3,
    "resin-smoke": 93.64,
    "floral": 100.0,
    "spiced-aromatic": 57.15,
    "dark": 68.18
  },
  "les-indemodables-vanille-havane": {
    "tobacco": 100.0,
    "chocolate": 100.0,
    "rum": 100.0,
    "vanilla": 100.0,
    "amber": 71.33,
    "gourmand": 100.0,
    "woody": 57.21,
    "resin-smoke": 71.33,
    "boozy": 100.0,
    "fruity": 67.57,
    "spiced-aromatic": 71.33,
    "dark": 100.0
  },
  "les-indemodables-patchouli-noisette": {
    "lychee": 100.0,
    "apricot-nectar": 92.0,
    "coconut": 84.0,
    "datura": 76.0,
    "jasmine": 68.0,
    "gourmand": 60.0,
    "floral": 52.0
  },
  "les-indemodables-discovery-kit": {},
  "rania-j-samar-kand-extrait": {
    "bergamot": 100.0,
    "orange": 92.0,
    "osmanthus": 84.0,
    "geranium": 76.0,
    "ylang": 68.0,
    "floral": 60.0
  },
  "rania-j-ambre-loup": {
    "apple": 100.0,
    "bergamot": 92.0,
    "ginger": 84.0,
    "lemon": 76.0,
    "drowsy-iris": 68.0,
    "fruity": 60.0,
    "spiced-aromatic": 52.0
  },
  "dannam-white-rice": {
    "incense": 100.0,
    "eucalyptus": 92.0,
    "bergamot": 84.0,
    "jasmine": 76.0,
    "vetiver": 68.0,
    "woody": 60.0,
    "earthy": 52.0,
    "resin-smoke": 44.0,
    "floral": 36.0,
    "dark": 28.0
  },
  "dannam-strawberry-mochi": {
    "aldehydes": 100.0,
    "geranium": 92.0,
    "heliotrope": 84.0,
    "orange-blossom": 76.0,
    "sandalwood": 68.0,
    "woody": 60.0,
    "floral": 52.0
  },
  "dannam-vietnamese-coffee": {
    "rose": 100.0,
    "raspberry-liqueur": 92.0,
    "osmanthus": 84.0,
    "peach-blossom": 76.0,
    "amber": 68.0,
    "resin-smoke": 60.0,
    "floral": 52.0
  },
  "dannam-matcha-soft-serve": {
    "balsamic": 100.0,
    "passionfruit": 92.0,
    "saffron": 84.0,
    "backwards-bergamot": 76.0,
    "geranium": 68.0,
    "resin-smoke": 60.0,
    "fruity": 52.0,
    "spiced-aromatic": 44.0
  }
};

  window.XTRAIT_PRODUCT_TAGS = map;
  window.XTRAIT_PRODUCT_NOTE_WEIGHTS = noteWeights;
  window.xtraitProductNoteWeight = function (handle, note) {
    var productWeights = noteWeights[String(handle || '')] || {};
    var key = String(note || '').replace(/^note:/, '').trim().toLowerCase();
    return parseFloat(productWeights[key] || 0) || 0;
  };
  window.xtraitMergeProductTags = function (handle, existing) {
    var seen = {};
    var out = [];
    var fallback = map[handle] || [];
    var fallbackHasNotes = fallback.some(function (tag) {
      return normalize(tag).indexOf('note:') === 0;
    });
    var hasExistingGender = false;

    function normalize(tag) {
      return String(tag || '').trim().toLowerCase();
    }

    function add(tag) {
      tag = normalize(tag);
      if (!tag || seen[tag]) return;
      seen[tag] = true;
      out.push(tag);
    }

    (Array.isArray(existing) ? existing : []).forEach(function (tag) {
      tag = normalize(tag);
      if (!tag) return;
      if (fallbackHasNotes && tag.indexOf('note:') === 0) return;
      if (tag.indexOf('gender:') === 0) hasExistingGender = true;
      add(tag);
    });

    fallback.forEach(function (tag) {
      tag = normalize(tag);
      if (tag.indexOf('gender:') === 0 && hasExistingGender) return;
      add(tag);
    });

    return out;
  };
})();
